{
  "common": {
    "show_password": "パスワードを表示",
    "hide_password": "パスワードを隠す",
    "loading": "読み込み中…",
    "retry": "再試行",
    "error": "エラーが発生しました",
    "none": "—",
    "cancel": "キャンセル",
    "back": "戻る",
    "copy": "コピー",
    "done": "完了",
    "save": "保存",
    "edit": "編集",
    "close": "閉じる",
    "list_sep": "、",
    "list_sep2": "；",
    "colon": "：",
    "paren": "（{{x}}）",
    "saving": "保存中…",
    "yes": "あり",
    "on": "オン",
    "off": "オフ",
    "device_id": "デバイス ID",
    "action_delete": "削除",
    "action_remove": "削除",
    "action_update_fw": "更新を開始",
    "action_apply": "適用",
    "action_change": "設定を変更",
    "action_revoke": "取り消す",
    "action_purge": "データを消去",
    "action_reboot": "再起動",
    "confirm_type": "確認のため「{{name}}」と入力",
    "action_end": "終了",
    "action_sign_out": "ログアウト",
    "op_failed": "操作を完了できませんでした。しばらくしてからもう一度お試しください。（コード：{{code}}）",
    "state_unknown": "不明",
    "pick_date": "日付を選ぶ",
    "dt24_bad": "2026-10-13 22:25 の形式（24 時間制）で入力してください",
    "on_this_page": "このページ："
  },
  "auth": {
    "title": "ログイン",
    "email": "メールアドレス",
    "password": "パスワード",
    "submit": "ログイン",
    "submitting": "ログイン中…",
    "err_INVALID_CREDENTIALS": "メールアドレスまたはパスワードが正しくありません",
    "err_RATE_LIMITED": "試行回数が多すぎます。しばらくしてから再試行してください",
    "err_NETWORK": "接続できません。ネットワークを確認してください",
    "err_IDENTITY_UNAVAILABLE": "アカウントサービスに接続できません",
    "err_default": "ログインに失敗しました（{{code}}）",
    "reason_SESSION_IDLE": "操作がなかったため自動的にログアウトしました。再度ログインしてください。",
    "err_SESSION_IDLE": "一定時間操作がなかったため、再度ログインしてください",
    "err_PASSKEY_REQUIRED": "このアカウントはパスキーでログインしてください",
    "reason_SESSION_REAUTH": "当直アカウントは 12 時間ごとに再ログインが必要です。",
    "hint": "{{brand}} アプリと同じアカウントでログインします。自分のデバイス、組織から許可されたデバイス、共有されたデバイスがすべてここに表示されます。",
    "forgot": "パスワードをお忘れですか？",
    "forgot_title": "パスワードの再設定",
    "forgot_hint": "アカウントのメールアドレスを入力してください。再設定リンクをお送りします。",
    "forgot_submit": "再設定リンクを送信",
    "forgot_sent": "このメールアドレスのアカウントがあれば、再設定リンクを送信しました。迷惑メールフォルダもご確認ください。",
    "forgot_back": "ログインに戻る",
    "no_account": "アカウントをお持ちでない方",
    "signup": "新規登録",
    "signup_title": "アカウントを作成",
    "signup_hint": "このアカウントは {{brand}} アプリでも使えます。組織からの招待や共有されたデバイスも同じアカウントで見られます。",
    "signup_submit": "アカウントを作成",
    "pending_invite": "ログインすると、開いた招待を自動的に受け入れます。",
    "err_EMAIL_EXISTS": "このメールアドレスはすでに登録されています。ログインしてください",
    "err_WEAK_PASSWORD": "パスワードが短すぎるか、推測されやすいものです",
    "err_SIGNUP_CLOSED": "このサービスは新規登録を終了しました",
    "err_BRAND_OFFBOARDING": "このブランドは新規登録を停止しています",
    "reason_other": "ログアウトしました。もう一度ログインしてください。"
  },
  "nav": {
    "overview": "概要",
    "live": "ライブ",
    "playback": "再生",
    "events": "イベントとアラーム",
    "map": "マップ",
    "devices": "デバイス",
    "ai": "AI 分析",
    "backup": "オフサイトバックアップ",
    "exports": "エクスポートと証拠",
    "people": "メンバーとアクセス",
    "audit": "監査",
    "billing": "プランと請求",
    "rules": "自動化ルール",
    "sites": "組織と拠点",
    "org": "組織設定",
    "account": "マイアカウント"
  },
  "shell": {
    "scope_all": "すべて（自分のもの + 組織から許可されたもの + 共有されたもの）",
    "language": "言語",
    "logout": "ログアウト",
    "env": "環境",
    "env_badge": "環境：{{env}}",
    "scope": "範囲",
    "present_end": "デモを終了"
  },
  "planned": {
    "title": "{{name}}：計画中",
    "body": "このモジュールは {{milestone}} で提供予定です。仕様は plan/vms-web-v0.md。",
    "spec": "仕様の章"
  },
  "overview": {
    "title": "概要",
    "homes": "$t(leaf.cur)",
    "devices": "デバイス",
    "online": "オンライン",
    "offline": "オフライン",
    "role": "役割",
    "no_homes": "$t(leaf.cur)または拠点がありません。アプリで$t(leaf.cur)を作成するか、組織管理者に権限を依頼してください。",
    "open_devices": "デバイスを見る",
    "cameras": "映像（オンライン / すべて）",
    "recent_events": "最近のイベント",
    "devices_n_one": "{{count}} 台",
    "devices_n_other": "{{count}} 台",
    "channels_note_one": "ほかに NVR のチャンネルが {{count}} 個",
    "channels_note_other": "ほかに NVR のチャンネルが {{count}} 個",
    "devices_tip": "デバイス = 実機の台数。NVR チャンネルは含みません（NVR は 1 台）",
    "offline_tip": "NVR がオンラインでチャンネルだけオフラインの場合はチャンネルだけ数えます",
    "online_rate": "デバイスのオンライン率 {{pct}}%",
    "cameras_tip": "映像 = カメラまたはチャンネル。NVR はチャンネルの数だけ映像があります。クリックでビデオウォールに表示",
    "recorders_bad": "{{bad}} / {{total}} 異常",
    "recorders_tip": "レコーダー = NVR と Kinio Station（Mac / Windows 版を含む）",
    "basis_auto": "最近の平均録画 {{mbps}} Mbps、容量 {{gb}} GB（循環上書き）で試算",
    "basis_off": "最近の平均録画 {{mbps}} Mbps、残り {{gb}} GB で試算（上書きなし）",
    "fw_outdated_one": "{{count}} 台に更新あり",
    "fw_outdated_other": "{{count}} 台に更新あり",
    "fw_all_latest_one": "{{count}} 台が最新",
    "fw_all_latest_other": "{{count}} 台が最新",
    "fw_tip": "デバイス本体だけを数えます（チャンネルは NVR に含めます）。「デバイス › ファームウェア」と同じデータです",
    "todo_title": "対応が必要",
    "todo_none": "いま対応が必要なものはありません。",
    "todo_offline": "オフライン：デバイス {{devices}} 台、チャンネル {{channels}} 個",
    "todo_storage_one": "{{count}} 台のレコーダーでストレージ異常",
    "todo_storage_other": "{{count}} 台のレコーダーでストレージ異常",
    "todo_cert_one": "{{count}} 台の証明書が期限切れまたは期限間近",
    "todo_cert_other": "{{count}} 台の証明書が期限切れまたは期限間近",
    "todo_fw_one": "{{count}} 台にファームウェア更新あり",
    "todo_fw_other": "{{count}} 台にファームウェア更新あり",
    "todo_alarms_one": "未対応のアラーム {{count}} 件",
    "todo_alarms_other": "未対応のアラーム {{count}} 件",
    "todo_gaps_one": "{{count}} 台のカメラで過去 24 時間の録画に欠落があります",
    "todo_gaps_other": "{{count}} 台のカメラで過去 24 時間の録画に欠落があります",
    "gap_cam_reason": "{{name}}（{{reason}}）",
    "and_more_one": " ほか {{count}} 台",
    "and_more_other": " ほか {{count}} 台",
    "act_view": "表示",
    "act_check": "確認",
    "act_update": "ファームウェアを見る",
    "act_handle": "アラームに対応",
    "act_playback": "再生",
    "recent_alarms": "最近のアラーム",
    "no_alarms": "最近のアラームはありません",
    "unknown_device": "削除されたデバイス",
    "home_online": "{{on}} / {{total}} 台オンライン",
    "armed_hint": "警戒モード：どの検知をアラームにするかを決めます",
    "fw_item": "{{name}}（現在 {{v}}）",
    "no_new_alarms_open_one": "最近の新しいアラームはありません。未対応の以前のアラームが {{count}} 件あります。",
    "no_new_alarms_open_other": "最近の新しいアラームはありません。未対応の以前のアラームが {{count}} 件あります。",
    "open_alarms": "未対応のアラーム",
    "open_alarms_more": "{{count}} 件すべて見る",
    "fw_all_latest_card_one": "すべて最新（{{count}} 台）",
    "fw_all_latest_card_other": "すべて最新（{{count}} 台）",
    "fw_unknown_note_one": "{{count}} 台はバージョンを取得できません",
    "fw_unknown_note_other": "{{count}} 台はバージョンを取得できません",
    "recorders_ok_one": "{{count}} 台正常",
    "recorders_ok_other": "{{count}} 台正常",
    "offline_short": "{{devices}} 台 · {{channels}} ch",
    "offline_dev_only_one": "{{count}} 台",
    "offline_dev_only_other": "{{count}} 台",
    "offline_ch_only_one": "{{count}} チャンネル",
    "offline_ch_only_other": "{{count}} チャンネル",
    "todo_alarms_more_one": "未対応のアラーム {{count}}+ 件",
    "todo_alarms_more_other": "未対応のアラーム {{count}}+ 件",
    "todo_alarms_counting": "未対応のアラームがあります（集計中）",
    "unlisted_open_one": "ほかに未登録または削除済みのデバイスからのアラームが {{count}} 件あります（件数に含めません）",
    "unlisted_open_other": "ほかに未登録または削除済みのデバイスからのアラームが {{count}} 件あります（件数に含めません）"
  },
  "devices": {
    "title": "デバイス",
    "search": "名前・機種で検索",
    "col_name": "名前",
    "col_home": "$t(leaf.cur) / 拠点",
    "col_model": "機種",
    "col_kind": "種別",
    "col_fw": "ファームウェア",
    "col_status": "状態",
    "col_last_seen": "最終接続",
    "online": "オンライン",
    "offline": "オフライン",
    "unknown": "不明",
    "empty": "デバイスがありません",
    "count_one": "{{count}} 台",
    "count_other": "{{count}} 台",
    "home_failed": "{{home}} の読み込みに失敗：{{err}}",
    "expand": "展開",
    "collapse": "折りたたむ",
    "channels": "{{n}} ch",
    "watch": "視聴",
    "kind_native": "Kinio",
    "kind_child": "チャンネル / 子デバイス",
    "kind_lscloud": "LS Cloud",
    "kind_swann": "Swann",
    "filter_status": "状態",
    "filter_all": "すべての状態",
    "view": "表示",
    "view_table": "表",
    "view_tree": "場所別",
    "col_recording": "クラウド録画",
    "col_ai": "AI",
    "col_location": "場所",
    "seat_event": "イベントシート",
    "seat_continuous": "常時シート",
    "reason_keepalive_timeout": "接続タイムアウト",
    "reason_gateway_lost": "プラットフォームとの接続が切断",
    "reason_missed_check_in": "スリープ後に応答なし",
    "reason_clean_close": "デバイス側から切断",
    "reason_probe_timeout": "応答確認がタイムアウト",
    "reason_superseded": "新しい接続に置き換えられました",
    "reason_channel_offline": "チャンネルがオフライン",
    "reason_read_error": "読み取り失敗",
    "reason_other": "原因不明",
    "count2_one": "{{count}} 台のデバイス · {{channels}} チャンネル",
    "count2_other": "{{count}} 台のデバイス · {{channels}} チャンネル",
    "count_tip": "デバイス = 実機の台数（NVR は 1 台）。チャンネルは別に数えます",
    "filter_cert": "証明書の期限が近いもののみ",
    "filter_type": "種類",
    "type_all": "すべての種類",
    "type_camera": "カメラ",
    "type_recorder": "レコーダー",
    "type_sensor": "センサー",
    "cols": "列 ▾",
    "col_reason": "オフラインの理由",
    "col_actions": "操作",
    "more": "{{name}} のその他の操作",
    "model_generic": "RTSP カメラ（型番情報なし）",
    "model_unknown": "型番をまだ取得していません",
    "model_onvif": "ONVIF カメラ"
  },
  "live": {
    "cameras": "カメラ",
    "no_cameras": "視聴できるカメラがありません",
    "layout": "レイアウト",
    "autofill": "オンラインのカメラで埋める",
    "empty_cell": "左の一覧からカメラをクリックするか、ここにドラッグしてください",
    "back_to_wall": "ビデオウォールに戻る",
    "expand": "拡大",
    "remove": "ビデオウォールから外す",
    "connecting": "接続中…",
    "offline": "デバイスがオフライン",
    "no_video": "接続済みですが、デバイスから映像が送られていません",
    "failed": "表示できません（{{code}}）",
    "err_DEVICE_OFFLINE": "デバイスがオフライン",
    "err_CHANNEL_OFFLINE": "チャンネルがオフライン",
    "err_HARDWARE_ERROR": "デバイスの映像エンジンエラー。続く場合はデバイスを再起動してください",
    "err_FORBIDDEN": "このデバイスを視聴する権限がありません",
    "err_NO_WEBRTC": "ブラウザが WebRTC 非対応です",
    "slow_first_frame": "接続済み。映像を待っています（バッテリー / HaLow カメラはスリープ中の可能性があります）",
    "err_MAX_SESSIONS_REACHED": "このデバイスの同時視聴数が上限に達しました。他の画面を閉じてください",
    "err_VIEWER_LIMIT": "このデバイスの同時視聴数が上限に達しました。他の画面を閉じてください",
    "watch_playback": "再生",
    "budget_note": "このパソコンで同時にデコードできるのは {{budget}} 本までです。残り {{n}} 枠はプレビュー表示です。「ライブにする」か拡大でライブ表示します。",
    "preview": "プレビュー",
    "go_live": "ライブにする",
    "stream_main": "高画質",
    "stream_sub": "データ節約",
    "reconnect_wait": "{{s}} 秒後に自動再接続（{{n}} 回目）",
    "reconnecting": "再接続中…（{{n}} 回目）",
    "err_STALLED": "映像が途切れました",
    "err_NETWORK": "ネットワークが切断されました",
    "err_CONNECT_TIMEOUT": "接続がタイムアウトしました",
    "err_SIGNAL_CLOSED": "接続が切断されました",
    "err_SESSION_REVOKED": "ログインが無効になりました（他の場所でログアウトまたはパスワード再設定）。再度ログインしてください",
    "err_ACCESS_REVOKED": "視聴権限が取り消されました",
    "err_CODEC_UNSUPPORTED": "このチャンネルのエンコード（H.265）はブラウザで再生できません。このチャンネルのサブストリームを H.264 に変更してください",
    "err_INVALID_PAYLOAD": "接続を確立できません（リクエスト形式の不一致）",
    "path_lan": "LAN",
    "path_direct": "直接",
    "path_relay": "中継",
    "zoom_reset": "{{z}}× リセット",
    "zoom_hint": "ホイールで拡大、ドラッグで移動、ダブルクリックでリセット",
    "snapshot": "スナップショット（ダウンロード）",
    "replay": "30 秒戻って再生",
    "stream_switch": "画質切替：データ節約 / 高画質（現在：{{s}}）",
    "stream_manual": "手動",
    "custom_grid": "カスタム",
    "custom_cols": "列",
    "custom_rows": "行",
    "custom_apply": "適用",
    "err_RELAY_IDLE": "中継接続が長時間操作されなかったため切断しました",
    "err_RELAY_LIMIT": "中継接続が 1 回 30 分の上限に達したため切断しました",
    "relay_idle_warn": "中継接続は操作がありません。{{s}} 秒後に切断します",
    "relay_continue": "視聴を続ける",
    "talk": "押して話す",
    "talking": "通話中…",
    "talk_starting": "マイクを起動中…",
    "talk_hint": "押している間だけ話せます（フォーカス時はスペースキーでも可）",
    "listen_on": "現場の音声をオン",
    "listen_off": "現場の音声をオフ",
    "talk_forbidden": "このデバイスで通話する権限がありません",
    "talk_incapable": "このデバイスは双方向通話に対応していません",
    "talk_busy": "別のユーザーが通話中です",
    "talk_denied": "ブラウザーでマイクの使用が許可されていません",
    "talk_error": "通話を開始できませんでした。もう一度お試しください",
    "talk_unavailable": "映像の接続後に通話できます",
    "no_live_n_one": "{{count}} 台は現在ライブ映像を見られません",
    "no_live_n_other": "{{count}} 台は現在ライブ映像を見られません",
    "ms_popout": "別の画面で開く（ビデオウォール）",
    "ms_pick_screen": "どの画面に表示",
    "ms_this_screen": "この画面",
    "ms_drag_hint": "新しいウィンドウを開きました。表示したい画面にドラッグし、F11 で全画面にしてください。",
    "ms_blocked": "ブラウザがポップアップをブロックしました。このサイトのポップアップを許可してください。",
    "ms_restore": "マルチ画面の配置を復元（{{n}}）",
    "ms_wall": "ビデオウォール（別の画面）",
    "ms_f11": "F11 で全画面",
    "ms_alarm_here": "アラームはこのウィンドウに表示",
    "ms_claim_alarm": "このウィンドウでアラームを表示",
    "ms_close_wall": "このウォールを閉じる",
    "ms_budget_shared": "他の画面がデコード枠 {{total}} 中 {{used}} を使用中",
    "snapshot_at": "スナップショット {{at}}",
    "scope_changed": "範囲を {{name}} に切り替えました（{{n}} 画面）。",
    "scope_fill": "この範囲のカメラでウォールを埋める",
    "scope_keep": "今のウォールのままにする",
    "overflow_n_one": "次のページにあと {{count}} 画面あります",
    "overflow_n_other": "次のページにあと {{count}} 画面あります",
    "overflow_next": "次のページ",
    "more_grids": "その他のレイアウト",
    "ms_popout_hint": "ビデオウォールだけのウィンドウを開きます。別の画面にドラッグして全画面表示できます",
    "grid_key": "{{n}} 分割（ショートカット {{key}}）",
    "stream_main_short": "高",
    "stream_sub_short": "省",
    "conn_info": "接続情報（経路・コーデック・解像度）",
    "tile_more": "{{name}} のその他の操作（画質、接続情報、音声、スナップショット、巻き戻し、PTZ）",
    "slow_first_frame_wired": "接続しました。最初の映像を待っています…",
    "slow_connect": "接続にいつもより時間がかかっています…",
    "wall_out_of_scope_one": "ウォールの {{count}} 枠が現在の範囲外です",
    "wall_out_of_scope_other": "ウォールの {{count}} 枠が現在の範囲外です",
    "wall_fill_scope": "この範囲に入れ替える",
    "out_of_scope_tile": "この枠は現在の範囲外です（{{where}}）",
    "scope_changed_all_on": "範囲を {{name}} に切り替えました（{{n}} 画面はすべて表示中）。",
    "scope_ack": "OK",
    "autofill_all_on": "この範囲の映像はすべてウォールにあります",
    "wall_pruned_one": "{{count}} 件の映像が一覧から外れたため（カメラの移動・解除・権限の取り消し）、ウォールから外しました。",
    "wall_pruned_other": "{{count}} 件の映像が一覧から外れたため（カメラの移動・解除・権限の取り消し）、ウォールから外しました。",
    "wall_pruned_undo": "元に戻す",
    "wall_pruned_ok": "OK",
    "cell_gone": "このカメラは一覧にありません",
    "cell_no_live": "このデバイスにはライブ映像がありません",
    "err_UNREACHABLE": "映像に接続できません（デバイスはオンラインと表示されています）",
    "err_ICE_FAILED": "接続が切れました。再接続中…",
    "failed_retrying": "接続が切れました。再接続中…",
    "failed_plain": "表示できません",
    "reconnect_now": "今すぐ再接続",
    "focus": "フォーカス",
    "focus_tip": "メニューを隠して映像を画面いっぱいに表示（Shift+F）",
    "focus_exit": "フォーカスを終了（Esc）",
    "empty_cell_focus": "フォーカスを終了するとカメラを追加できます"
  },
  "events": {
    "search": "種別・デバイス・$t(leaf.cur)で検索",
    "count": "{{n}} 件",
    "empty": "該当するイベントがありません",
    "class_motion": "動き",
    "class_sensor": "センサー",
    "class_system": "システム",
    "class_other": "その他",
    "live_new": "ライブ",
    "class_alarm": "アラーム",
    "class_detection": "検知",
    "mark_all_seen": "すべて既読にする",
    "unseen_n": "未確認のアラーム・検知 {{n}} 件",
    "thumb_alt": "イベントのサムネイル",
    "cls_name": {
      "motion": "動き",
      "person": "人",
      "human": "人",
      "vehicle": "車両",
      "pet": "動物",
      "package": "荷物",
      "ai_label": "AI 検知",
      "sound": "音",
      "alarm": "アラーム",
      "tamper": "遮蔽・破壊",
      "contact": "ドア / 窓",
      "occupancy": "在室 / 不在",
      "doorbell": "ドアベル",
      "call": "呼び出し",
      "connection": "接続",
      "storage": "ストレージ",
      "recording": "録画",
      "power": "電源",
      "ota": "ファームウェア更新",
      "credential": "証明書",
      "system": "システム",
      "security_mode": "警戒モード",
      "bookmark": "ブックマーク"
    },
    "type_unknown": "その他のイベント",
    "chip_tip": "クリックでこの種類だけを表示し、もう一度クリックですべてに戻ります。⌘ / Ctrl を押しながらクリックで複数選択できます",
    "more": "その他",
    "unregistered_channel": "{{parent}} / CH{{n}}（未登録のチャンネル）",
    "device_unknown": "一覧にないデバイス",
    "tab_alarms": "アラーム",
    "tab_alarms_n_one": "アラーム（未対応 {{count}}）",
    "tab_alarms_n_other": "アラーム（未対応 {{count}}）",
    "tab_all": "すべてのイベント",
    "tab_saved": "保存した検索",
    "other_channels": "その他のチャンネル（{{n}}）",
    "device_unknown_tail": "一覧にないデバイス（…{{tail}}）",
    "tag": {
      "person": "人",
      "human": "人",
      "vehicle": "車両",
      "car": "車",
      "animal": "動物",
      "pet": "ペット",
      "dog": "犬",
      "cat": "猫",
      "package": "荷物",
      "face": "顔",
      "bark": "犬の鳴き声",
      "glass_break": "ガラス破損",
      "baby_cry": "泣き声",
      "smoke_alarm": "煙感知器の警報音",
      "motion": "動き",
      "sound": "音",
      "bicycle": "自転車",
      "motorcycle": "バイク"
    },
    "other_devices": "その他（{{n}}）",
    "times_n": "× {{n}} 回（最初 {{since}}）",
    "times_only": "× {{n}} 回",
    "ep_lasted": "継続時間 {{dur}}",
    "ep_open": "継続中",
    "ep_stale": "終了の記録なし",
    "ep_end_only": "終了",
    "times_counting": "集計中",
    "all_loaded": "全 {{n}} 回を読み込み済み（{{rows}} 行にまとめています）",
    "no_thumb": "サムネイルなし",
    "tab_alarms_more_one": "アラーム（未対応 {{count}}+）",
    "tab_alarms_more_other": "アラーム（未対応 {{count}}+）",
    "ep_lasted_lt1": "1 秒未満",
    "tab_alarms_counting": "アラーム（集計中）",
    "compose": {
      "multi_press_n": "{{count}} 回連続押し",
      "contact_opened": "開いた",
      "contact_closed": "閉じた",
      "leak_detected": "漏水を検知",
      "leak_cleared": "漏水解除",
      "occupied": "在室",
      "unoccupied": "不在",
      "ai_detected": "AI：{{what}}"
    },
    "lens_chip_a11y": "{{name}}のイベント"
  },
  "playback": {
    "recording_sd": "メモリーカード",
    "day": "日付",
    "pick_time": "下のタイムラインをドラッグまたはクリックして再生時刻を選んでください",
    "timeline": "録画タイムライン",
    "type_continuous": "常時",
    "type_event": "イベント",
    "no_recording_after": "この時刻以降の録画はありません",
    "tunnel_idle": "再生用接続：未接続",
    "tunnel_opening": "再生用接続を確立中…",
    "tunnel_open": "再生用接続：接続済み",
    "tunnel_failed": "再生用接続に失敗しました",
    "tunnel_closed": "再生用接続を切断しました",
    "err_MAX_SESSIONS_REACHED": "デバイスの同時接続数が上限に達しました（ライブと再生で共有）。他の画面を閉じてください",
    "err_VIEWER_LIMIT": "デバイスの同時接続数が上限に達しました（ライブと再生で共有）。他の画面を閉じてください",
    "err_CHANNEL_OFFLINE": "チャンネルがオフライン",
    "err_HARDWARE_ERROR": "デバイスの映像エンジンエラー。続く場合はデバイスを再起動してください",
    "err_CODEC_UNSUPPORTED": "このチャンネルのエンコード（H.265）はブラウザで再生できません。このチャンネルのサブストリームを H.264 に変更してください",
    "err_INVALID_PAYLOAD": "接続を確立できません（リクエスト形式の不一致）",
    "err_TUNNEL_TIMEOUT": "再生用接続がタイムアウトしました",
    "unified": "タイムライン",
    "all_sources": "すべてのソースを表示",
    "src_cloud": "クラウド",
    "src_nvr": "NVR ディスク",
    "src_sd": "SD カード",
    "src_edge": "ONVIF edge",
    "src_backup": "オフサイトバックアップ",
    "gap": "欠落",
    "gap_offline": "デバイスオフライン",
    "gap_retention": "保存期間外",
    "gap_unknown": "ソース不明（デバイスに接続できません）",
    "gap_not_recorded": "録画なし",
    "gaps_title_one": "欠落 {{count}} 件",
    "gaps_title_other": "欠落 {{count}} 件",
    "summary": "録画 {{spans}} 件、欠落 {{gaps}} 件",
    "source_changed": "ソース切替：{{from}} → {{to}}。",
    "end_of_day": "この日の録画はこれ以降ありません",
    "zoom_in": "拡大",
    "zoom_out": "縮小",
    "pan_back": "前へ",
    "pan_forward": "後へ",
    "zoom_span": "表示幅 {{span}}",
    "hours": "{{n}} 時間",
    "minutes": "{{n}} 分",
    "dst_day": "夏時間の切替日（{{h}} 時間）",
    "err_no_recording_after": "この時刻以降の録画はありません",
    "err_TUNNEL_NOT_READY": "再生用接続を確立中です。しばらくしてから再試行してください",
    "err_TUNNEL_FAILED": "再生用接続に失敗しました。デバイスのローカル録画は一時的に表示できません",
    "tz": "タイムゾーン",
    "tz_site": "拠点のタイムゾーン",
    "tz_browser": "ブラウザのタイムゾーン",
    "src_node": "パソコン",
    "src_phone": "スマホ本体",
    "gap_paused": "一時停止：{{reason}}",
    "unknown_node_offline": "不明（パソコンがオフライン）",
    "unknown_node_pending": "不明（パソコンからの報告待ち）",
    "unknown_phone_offline": "不明（スマホがオフライン）",
    "err_NODE_PLAYBACK_UNAVAILABLE": "パソコン側の録画再生はまだ提供されていません（この時間帯はパソコンに録画あり）",
    "pause_app_background": "アプリがバックグラウンド",
    "pause_killed": "アプリ終了",
    "pause_updating": "更新中",
    "pause_schedule": "スケジュール",
    "pause_home_mode": "在宅中",
    "pause_thermal": "高温",
    "pause_battery_low": "電池残量低下",
    "pause_storage_full": "容量不足",
    "pause_camera_busy": "カメラ使用中",
    "pause_permission": "カメラ権限なし",
    "pause_local_network_denied": "ローカルネットワーク権限なし",
    "pause_mic_denied": "マイク権限なし",
    "pause_plan_limit": "プラン台数超過",
    "pause_in_pocket": "スマホ収納中",
    "pause_user": "手動で一時停止",
    "pause_source_unreachable": "パソコンからカメラに接続できない",
    "pause_not_recorded": "録画方式により録画なし",
    "prev_month": "前月",
    "next_month": "翌月",
    "day_has_rec": "{{day}}（録画あり）",
    "day_legend": "色付きの日は録画あり（クラウドまたはデバイス本体）",
    "event_density": "イベント密度",
    "events_n_one": "{{count}} 件のイベント",
    "events_n_other": "{{count}} 件のイベント",
    "speed": "速度",
    "frame_back": "前のフレーム",
    "frame_fwd": "次のフレーム",
    "timeline_aria": "再生タイムライン（ドラッグでスクロール、ホイールで拡大縮小。← / → 移動、Shift + ← / → 前後のイベント、スペースで再生 / 一時停止）",
    "seam": "イベントのない {{d}} を折りたたみました",
    "dur_hm": "{{h}} 時間 {{m}} 分",
    "only_events": "イベントのある時間帯のみ",
    "no_events_day": "この日はイベントがありません",
    "end_of_events": "これ以降のイベントはありません",
    "group_person": "人",
    "group_vehicle": "車",
    "group_animal": "動物",
    "group_package": "荷物",
    "group_sound": "音",
    "group_sensor": "センサー",
    "group_alarm": "アラーム",
    "group_motion": "動き",
    "skipped_from": "{{gaps}}。{{at}} から再生します。",
    "err_local_unreachable": "{{name}} の{{src}}録画を読み込めません（デバイスが応答しません）。",
    "err_source_unreachable": "この録画を読み込めません（{{src}}）。しばらくしてから再試行してください。",
    "err_decode": "ブラウザーでこの録画を再生できません（形式が非対応か、ファイルが破損しています）。",
    "err_generic": "この録画を再生できません。しばらくしてから再試行してください。",
    "err_detail": "詳細",
    "no_sources": "このカメラには録画元がありません（SD カードやレコーダーがなく、クラウド録画もオフです）。",
    "no_recording_unreachable": "この日の録画を読み込めませんでした。接続できない録画元があります（デバイスがオフラインか応答なし）。表示されていない録画があるかもしれません。",
    "no_recording_day": "この日はどのソースにも録画がありません。考えられる原因：",
    "go_last_day": "録画がある直近の日へ（{{day}}）",
    "err_overlay": "再生できません（理由は下記）",
    "err_local_offline": "{{name}} はオフラインのため、ローカル録画を読み込めません。",
    "err_cloud_unreachable": "クラウド録画を一時的に読み込めません。しばらくしてから再試行してください。",
    "err_no_cloud": "このカメラにはクラウド録画がありません。",
    "err_forbidden": "このカメラの再生権限がありません。",
    "try_cloud": "クラウド録画を見る",
    "try_source": "{{src}}を見る",
    "go_nearest": "最も近い録画へ",
    "buy_seats": "シートを購入",
    "gap_none_span": "{{from}}–{{to}} は録画がありません",
    "why_overwritten": "{{src}}は循環上書きされました（古い録画は新しい録画で上書きされます）",
    "why_no_cloud": "クラウド録画がオンになっていない",
    "why_schedule": "録画スケジュールがこの時間帯を含んでいない",
    "why_offline": "{{name}} がこの時間オフラインだった",
    "no_rec_events_one": "この日はイベントが {{count}} 件ありますが、再生できる録画はありません。",
    "no_rec_events_other": "この日はイベントが {{count}} 件ありますが、再生できる録画はありません。",
    "from_event": "イベントから：{{name}} · {{cam}} · {{at}}",
    "from_event_generic": "イベント",
    "from_event_dismiss": "この表示を消す",
    "drag_hint": "タイムラインをドラッグして時間を変えます。中央の線が再生位置です。クリックでその時刻へ移動します。",
    "hint_ok": "OK",
    "settings": "タイムライン設定（タイムゾーン・凡例・イベントのみ・全ソース）",
    "modes": "再生モード",
    "mode_single": "1 画面",
    "day_no_rec": "この日は録画がありません",
    "why_local_unreachable": "{{name}} の{{src}}録画を現在読み込めません（デバイスが応答していません）。",
    "why_local_offline": "{{name}} がオフラインのため、{{src}}録画を読み込めません。",
    "why_cloud_no_clip": "{{name}} にはこの時間帯のクラウドクリップがありません（クラウドはイベントのクリップのみ保存）。",
    "why_cloud_retention": "クラウドの保存期間（{{n}} 日）を過ぎています。",
    "why_local_empty": "{{src}}にもこの時間帯の録画はありません（上書きされたか、スケジュール外の可能性）。",
    "retry_local": "{{src}}を再読み込み",
    "seek_no_rec": "{{at}} は録画がありません。{{from}} から再生します。",
    "fallback": "{{dev}} の {{src}} を読めないため、{{to}}の録画を {{at}} から再生しています。",
    "cam_not_found": "このカメラが見つかりません（削除されたか、再生の権限がない可能性があります）。左側または上部で選んでください。",
    "pick_camera": "カメラを選択…",
    "slow": "{{src}}の録画の読み込みに時間がかかっています。",
    "slow_fallback": "{{src}}の録画が {{sec}} 秒たっても映らないため、{{to}}に切り替えました（{{at}} から）。",
    "avoid_broken": "{{dev}} の {{src}}は先ほど読めなかったため、先に{{to}}を再生しています（{{at}} から）。",
    "src_missing": "このカメラにはこの時間の{{src}}の録画がないため、ほかのソースを使います。",
    "back_to": "{{src}}に戻す",
    "src_pinned": "選んだソース：カメラを切り替えても引き継ぎます",
    "src_auto_hint": "自動で選んだソース（最近再生できたものを優先）",
    "src_auto": "ソースを自動で選ぶ",
    "play": "▶ 再生",
    "pause": "⏸ 一時停止",
    "sound_on": "🔇 音を出す",
    "sound_off": "🔊 音を消す",
    "fullscreen": "⛶ 全画面",
    "cloud_suspect": "このクラウドクリップは不完全な可能性があります（長さが不自然です）。映像が緑色になったり止まったりすることがあります。",
    "cloud_suspect_switched": "このクラウドクリップは不完全な可能性があるため（長さが不自然）、{{to}}を再生しています（{{at}} から）。",
    "events_n_more": "{{count}} 件以上のイベント（{{count}} 件のみ表示）",
    "slow_tier_hint": "通信速度が足りず、再生が途切れます。録画画質を標準に変更することをおすすめします（今後の録画のみ）。",
    "slow_tier_switch": "標準に変更",
    "slow_tier_never": "今後表示しない",
    "slow_tier_close": "閉じる",
    "slow_tier_done": "標準に変更しました。今後の録画は標準画質になり、録画済みの映像はそのままです。",
    "slow_tier_sent": "送信しました。カメラが接続されると標準に切り替わります。",
    "slow_tier_hint_no_write": "通信速度が足りず、再生が途切れます。このカメラの設定権限がある人が録画画質を標準に変更できます。",
    "slow_tier_failed": "変更できませんでした。デバイスの「録画とストレージ」タブ › 録画画質でもう一度お試しください。",
    "err_local_host_limit": "{{name}} のレコーダーで同時に再生できるローカル映像は最大 {{n}} 本のため、この映像は読み込みませんでした。1 画面で再生してください。"
  },
  "map": {
    "plans": "平面図",
    "upload": "平面図をアップロード",
    "place_devices": "デバイスを配置",
    "pick_device": "デバイスを選んでから、平面図上をクリックして配置",
    "click_to_place": "平面図上の位置をクリック",
    "done": "完了",
    "edit": "配置を編集",
    "delete": "平面図を削除",
    "confirm_delete": "平面図「{{name}}」を削除しますか？",
    "no_map_key": "地図にはブランドの Google / Baidu キーが必要です（brands/<Brand>/vms/vms.yaml maps.*）。平面図モードは使えます。",
    "empty": "平面図がまだありません。図面（PNG / JPG / SVG / WebP、20 MB まで）をアップロードしてカメラとセンサーを配置します。",
    "rotate_left": "左へ 15° 回転",
    "rotate_right": "右へ 15° 回転",
    "remove": "削除",
    "load_demo": "サンプル平面図を読み込む（自動配置）",
    "demo_name": "サンプル 1F",
    "owner": "アップロード先",
    "conflict": "他の人が変更しました。再読み込みしたので、もう一度操作してください",
    "empty_readonly": "平面図がまだありません。$t(leaf.cur)のオーナー / 管理者 または組織管理者がアップロードできます。",
    "mode_map": "地図",
    "mode_plan": "平面図",
    "load_failed": "地図の読み込みに失敗しました：{{err}}",
    "fallback": "{{from}} の読み込みに失敗したため {{to}} に切り替えました",
    "provider": "地図",
    "provider_google": "Google",
    "provider_baidu": "Baidu",
    "provider_dev": "開発用ベースマップ",
    "dev_basemap": "開発環境：このブランドには Google / Baidu の地図キーがまだないため、開発用ベースマップを使っています（本番では表示されません）。",
    "health_ok": "正常",
    "health_warn": "オフラインのデバイスあり",
    "health_alarm": "アラーム中",
    "sites": "拠点",
    "set_location": "地図で位置を選択",
    "click_map_home": "地図をクリックしてこの拠点の位置を設定",
    "click_map_to_place": "地図をクリックして配置（デバイスを再クリックで移動）",
    "overlays": "平面図の重ね合わせ",
    "align": "位置合わせ",
    "opacity": "透明度",
    "heading": "向き",
    "fov": "画角",
    "range": "距離",
    "move": "移動",
    "align_title": "「{{name}}」の位置合わせ",
    "align_help": "平面図上の点をクリックし、地図上の同じ場所をクリックします。2 点 = 移動・回転・拡大縮小、3 点 = 歪みも補正。",
    "align_click_img": "平面図上の {{n}} 点目をクリック",
    "align_click_map": "地図上で {{n}} 点目の実際の位置をクリック",
    "align_save": "適用（{{n}} 点）",
    "align_reset": "やり直す",
    "align_clear": "重ね合わせを解除",
    "align_bad": "制御点が重なっているか一直線上にあります",
    "align_ready": "3 点そろいました。「適用」を押してください",
    "timezone": "タイムゾーン",
    "timezone_unset": "タイムゾーン（未設定・ブラウザ）",
    "events_recent": "最近のイベント（{{n}}）",
    "events_results": "検索結果（{{n}}）",
    "events_clear": "検索結果をクリア",
    "events_title": "イベント",
    "events_none": "イベントはありません",
    "events_playback": "この場面を再生",
    "events_help": "イベントのあったデバイスは地図上で点滅します。項目をクリックするとそのデバイスを強調表示します。位置が分かるのは地図に配置済みのデバイスだけです。",
    "search_placeholder": "住所や地名を検索",
    "search": "検索",
    "search_none": "該当する住所がありません",
    "search_busy": "住所検索が多すぎます。少し待ってからやり直してください",
    "search_attrib": "開発用の住所検索：© OpenStreetMap contributors（Nominatim）",
    "tiles_failed": "地図の背景を読み込めません。",
    "use_plan": "平面図に切り替える",
    "alarms_only": "アラームのみ",
    "unplaced_devices_one": "まだ地図に配置していないデバイス（{{count}}）· {{home}}",
    "unplaced_devices_other": "まだ地図に配置していないデバイス（{{count}}）· {{home}}",
    "placed_devices_one": "地図に配置済み（{{count}}）",
    "placed_devices_other": "地図に配置済み（{{count}}）",
    "all_placed": "この拠点のデバイスはすべて地図に配置済みです。",
    "timezone_change": "変更",
    "timezone_edit": "タイムゾーンを変更",
    "site_health_alarm": "赤：ここのデバイスがアラーム中",
    "site_health_warn": "黄：ここのデバイスがオフライン",
    "site_health_ok": "緑：ここのデバイスはすべて正常",
    "location_set": "位置：設定済み",
    "location_unset": "位置：未設定",
    "location_pick": "設定",
    "location_move": "移動",
    "timezone_label": "タイムゾーン：{{tz}}",
    "timezone_unset_short": "未設定（ブラウザ）",
    "unplaced_devices_ch": "まだ地図に配置していないデバイス（{{count}}、うちチャンネル {{ch}}）· {{home}}"
  },
  "mfa": {
    "title": "2 段階認証",
    "code_body": "認証アプリ（Google Authenticator、Microsoft Authenticator など）を開き、6 桁のコードを入力してください。",
    "code": "認証コード",
    "recovery_hint": "スマートフォンが手元にない場合は、リカバリーコード（xxxx-xxxx）を入力してください。",
    "verify": "確認",
    "enroll_title": "2 段階認証の設定",
    "enroll_body": "認証アプリで QR コードを読み取り、表示された 6 桁のコードを入力してください。",
    "first_code": "アプリに表示されたコード",
    "enable": "2 段階認証を有効にする",
    "recovery_title": "リカバリーコード",
    "saved_continue": "保存しました、続行",
    "qr_alt": "認証アプリ設定用 QR コード",
    "manual_entry": "読み取れない場合はキーを手動入力：",
    "recovery_notice": "各リカバリーコードは 1 回だけ使えます。安全な場所（パスワードマネージャーや紙）に保管してください。スマートフォン紛失時の唯一のログイン手段で、再表示されません。",
    "copy_codes": "すべてコピー",
    "section": "2 段階認証",
    "enabled": "有効",
    "disabled": "無効",
    "required_policy": "所属する組織で 2 段階認証が必須になっています",
    "recovery_remaining": "リカバリーコード残り {{n}} 個",
    "regenerate": "リカバリーコードを再生成",
    "regenerate_body": "既存のリカバリーコードはすべて無効になります。現在のコードを入力してください。",
    "disable": "2 段階認証を無効にする",
    "disable_body": "パスワードのみでログインするようになります。パスワードと現在のコードを入力してください。",
    "err_MFA_CODE_INVALID": "認証コードが正しくないか、すでに使用されています",
    "err_MFA_TOKEN_INVALID": "認証がタイムアウトしました。パスワードを再入力してください",
    "err_RATE_LIMITED": "試行回数が多すぎます。しばらくしてから再試行してください",
    "err_INVALID_CREDENTIALS": "パスワードが正しくありません",
    "err_MFA_REQUIRED": "認証コードを入力してください",
    "err_MFA_ALREADY_ENABLED": "2 段階認証はすでに有効です",
    "err_MFA_NOT_SETUP": "2 段階認証が設定されていません",
    "err_MFA_REQUIRED_BY_POLICY": "所属する組織が 2 段階認証を必須にしています。少なくとも 1 つ（TOTP またはパスキー）を残してください",
    "err_SESSION_UNKNOWN": "ログイン状態が更新されました。もう一度お試しください",
    "err_NETWORK": "接続できません。ネットワークを確認してください",
    "err_IDENTITY_UNAVAILABLE": "アカウントサービスに一時的に接続できません",
    "err_default": "認証に失敗しました（{{code}}）"
  },
  "stepup": {
    "title": "本人確認",
    "body": "権限変更やメンバー停止などの重要な操作です。5 分以内に再認証してください。",
    "code_hint": "2 段階認証を有効にしている場合は、認証アプリ（Google Authenticator など）で Kinio の現在の 6 桁を入力してください。無効なら空欄のまま、パスワードだけ入力します。",
    "submit": "確認して続行",
    "code": "2 段階認証コード",
    "code_optional": "2 段階認証コード（有効にしている場合のみ）",
    "code_hint_on": "認証アプリ（Google Authenticator、Microsoft Authenticator など）で Kinio の現在の 6 桁を入力してください。手元にスマートフォンがない場合はリカバリーコード（xxxx-xxxx）を入力できます。"
  },
  "settings": {
    "security": "セキュリティ",
    "org": "組織",
    "notifications": "通知"
  },
  "activate": {
    "title": "招待を受け入れる",
    "bad_link": "招待リンクが不完全か期限切れです。招待した人に新しい招待を依頼してください。",
    "done": "アカウント {{email}} を作成し、参加しました。ログイン画面からログインしてください。",
    "to_login": "ログインへ",
    "body": "組織に招待されました（またはデバイスを共有されました）。アカウントをお持ちならログインしてください。お持ちでなければこの招待で登録します（招待されたメールが使われ、変更できません）。",
    "display_name": "表示名（任意）",
    "password_hint": "8 文字以上、よくあるパスワードは避けてください。",
    "password_again": "パスワード（確認）",
    "mismatch": "パスワードが一致しません",
    "submit": "登録して参加",
    "err_INVITE_GONE": "招待は期限切れか使用済みです。管理者に再招待を依頼してください",
    "err_ACCOUNT_EXISTS": "このメールアドレスはすでに登録されています。ログインしてください",
    "err_WEAK_PASSWORD": "パスワードが短すぎるか、推測されやすいものです",
    "err_INVITE_EMAIL_MISMATCH": "招待されたメールアドレスとログイン中のアカウントが一致しません",
    "err_default": "有効化に失敗しました（{{code}}）",
    "have_account": "アカウントをお持ちの方（ログイン）",
    "no_account": "アカウントをお持ちでない方（新規登録）",
    "register_body": "パスワードを設定するとアカウントが作成され、参加します。同じアカウントでブランドアプリも使えます。",
    "done_existing": "このメールにはすでにアカウントがあるため、そのまま参加しました。いつものパスワードでログインしてください。",
    "done_share": "共有が有効になりました。デバイスは「共有されたもの」に表示されます。",
    "err_INVITE_EMAIL_MISMATCH_masked": "この招待は {{email}} 宛てです。そのアカウントでログインしてください。",
    "err_ALREADY_MEMBER": "すでにこの組織のメンバーです",
    "err_ORG_SUSPENDED": "この組織は停止中のため参加できません",
    "err_EMAIL_NOT_VERIFIED": "先にメールアドレスを確認してから、招待を承諾してください。",
    "org": "組織",
    "invited_by": "招待した人",
    "invited_email": "招待されたメールアドレス",
    "expires": "有効期限",
    "already_member": "すでにこの組織のメンバーです（{{role}}）。",
    "accept": "受け入れて参加",
    "joined": "「{{name}}」に参加しました。組織のデバイスは「組織から」に表示されます。",
    "joined_short": "招待を受け入れました。",
    "switch_account": "ログアウトしてアカウントを切り替える",
    "to_devices": "デバイスへ",
    "joined_org": "「{{name}}」に参加しました。"
  },
  "org": {
    "err_default": "操作に失敗しました（{{code}}）",
    "err_VERSION_CONFLICT": "他のユーザーが更新しました。再読み込みしてからお試しください",
    "err_REAUTH_REQUIRED": "再認証が必要です",
    "err_SITE_CYCLE": "拠点を自身の配下へ移動することはできません",
    "err_CROSS_TREE": "拠点が別のツリーにあります",
    "err_SITE_ARCHIVED": "拠点はアーカイブ済みです",
    "err_OUT_OF_ANCHOR": "デバイスがこの拠点の範囲外です",
    "err_OUT_OF_SITE": "指定したデバイスが付与先の拠点にありません",
    "err_SITE_NOT_RELATED": "付与する拠点は$t(leaf.cur)の拠点の上位または下位である必要があります",
    "err_EMPTY_SCOPE": "範囲内にデバイスがありません",
    "err_GRANT_TOO_LONG": "付与期間は最長 90 日です",
    "err_NOT_ACTIVE_ORG_MEMBER": "この組織の有効なメンバーではありません",
    "err_ROLE_NOT_GRANT": "この役割はデータアクセス用ではありません",
    "err_NO_ACTIONS": "少なくとも 1 つの操作を選んでください",
    "err_BAD_SITE": "拠点の情報が不正です（名前は 1〜64 文字）",
    "err_BAD_TIMEZONE": "タイムゾーンの形式が不正です（例：Asia/Tokyo）",
    "err_ALREADY_MEMBER": "すでにメンバーです",
    "err_TOO_MANY_INVITES": "保留中の招待が多すぎます。不要なものを取り消してください",
    "err_LAST_ORG_ADMIN": "組織管理者を最低 1 人残してください",
    "err_SELF": "自分自身は停止できません",
    "err_LIMIT": "上限に達しました",
    "err_ORG_LIMIT": "作成できる組織は 1 人 5 つまでです（自分の家は含みません）",
    "err_FORBIDDEN": "権限がありません",
    "err_NOT_FOUND": "見つかりません",
    "err_NETWORK": "接続できません。ネットワークを確認してください",
    "no_site_permission": "この組織の拠点を管理する権限がありません。組織の管理者に問い合わせてください。",
    "create_title": "組織を作成",
    "create_body": "会社・店舗・地域・警備会社・設置業者などは組織を作成でき、独自の拠点ツリー、メンバー、役割、セキュリティポリシーを持てます。作成者がオーナーになります。1 人 5 つまで（自分の家は含みません）。",
    "name": "組織名",
    "create": "作成",
    "sites_title": "{{name}} の拠点",
    "add_root_site": "拠点を追加",
    "revoked_grants": "影響を受けた {{n}} 件の権限を取り消しました",
    "no_sites": "拠点はまだありません。本社や最初の拠点から追加してください。",
    "kind_site": "拠点",
    "kind_building": "建物",
    "kind_floor": "フロア",
    "kind_zone": "エリア",
    "archived": "アーカイブ済み",
    "add_child": "下位拠点を追加",
    "add_home": "$t(leaf.cur)を追加",
    "archive": "アーカイブ",
    "restore": "復元",
    "home": "$t(leaf.cur)",
    "add_child_of": "「{{name}}」の下に追加",
    "edit_site": "「{{name}}」を編集",
    "add_home_at": "「{{name}}」に$t(leaf.cur)を追加",
    "home_body": "$t(leaf.cur)はデバイスが実際にある場所です（例：「自宅」「A 棟監視」）。デバイスをこの$t(leaf.cur)にペアリングすると、役割とアクセス権に応じて使えます。",
    "home_name": "$t(leaf.cur)名",
    "kind": "種類",
    "site_name": "名前",
    "timezone": "タイムゾーン",
    "parent": "上位拠点",
    "parent_root": "（最上位）",
    "move_warning": "移動すると、範囲外になる権限は取り消されます。",
    "pick": "組織",
    "err_OWNS_HOMES": "この人はまだ$t(leaf.cur)の管理人です。先に引き継いでください",
    "err_HOME_UNASSIGNED": "この$t(leaf.cur)には管理人がいません。組織管理者が先に引き継いでください",
    "err_NOT_OWNER": "引き継ぎは現在の管理人からのみ開始できます",
    "err_REASON_REQUIRED": "理由を入力してください",
    "err_IDEMPOTENCY_KEY_REQUIRED": "再読み込みしてからお試しください",
    "err_HOME_NOT_FOUND": "$t(leaf.cur)が見つかりません",
    "err_WOULD_LOCK_OUT": "保存すると自分がアクセスできなくなります（現在の IP がリストにない、またはこのログインで 2 段階認証を使っていない）",
    "err_BAD_CIDR": "IP / CIDR の形式が正しくありません",
    "err_IP_NOT_ALLOWED": "組織のセキュリティポリシーでこのネットワークからのアクセスは許可されていません",
    "err_BAD_SCHEDULE": "時間帯の設定が正しくありません",
    "my_orgs": "自分の組織",
    "my_orgs_hint": "すべてのアカウントには自分の家（個人組織。退出・削除不可）があります。会社・店舗・地域などの組織を作成したり、他の組織に招待されたりできます。組織同士はお互いを見られません。",
    "kind_col": "種類",
    "kind_personal": "個人",
    "kind_team": "チーム",
    "personal_badge": "自分の家",
    "requires_mfa": "2 段階認証が必須",
    "manage": "管理",
    "leave": "退出",
    "leave_confirm": "「{{name}}」から退出しますか？",
    "leave_body": "この組織から与えられた権限だけがなくなります。自分の家、他の組織、共有されたものには影響しません。戻るには再度招待が必要です。",
    "created": "「{{name}}」を作成しました。あなたがオーナーです。",
    "personal_hint": "これは自分の家（個人組織）です。$t(leaf.cur)や拠点の追加、家族の招待ができます。退出・譲渡・削除はできず、アカウントに属します。",
    "team_hint": "チーム組織：組織の役割は組織の管理のみです。映像を見るには$t(leaf.cur)の役割か拠点のアクセス権が必要です。",
    "member_count_one": "メンバー {{count}} 人",
    "member_count_other": "メンバー {{count}} 人",
    "owner_transfer": "所有権を譲渡",
    "owner_transfer_of": "「{{name}}」の所有権を譲渡",
    "owner_transfer_hint": "新しいオーナーは有効な管理者である必要があります。あなたは管理者になります。双方とほかの管理者に通知されます。",
    "new_owner": "新しいオーナー",
    "no_admins": "ほかの管理者がいません。先にメンバータブで引き継ぐ人を管理者にしてください。",
    "owner_transfer_done": "所有権を譲渡しました。",
    "delete": "組織を削除",
    "delete_confirm": "「{{name}}」を削除しますか？",
    "delete_body": "メンバーは全員退出し、この組織への共有は終了します。$t(leaf.cur)が残っている組織は削除できません。先に$t(leaf.cur)を削除または移動してください。元に戻せません。",
    "err_ORG_NOT_EMPTY": "組織にまだ$t(leaf.cur)があります。先に次の$t(leaf.cur)を削除または移動してください：",
    "err_INVALID_NAME": "組織名は 2〜60 文字にしてください",
    "err_OWNER_REQUIRED": "オーナーのみ実行できます",
    "err_OWNER_CANNOT_LEAVE": "オーナーは退出できません。自分の家はアカウントに属します。チーム組織の場合は先に所有権を譲渡してください",
    "err_OWNER_ROLE": "オーナーの役割は所有権の譲渡でのみ変更できます",
    "err_PERSONAL_ORG": "自分の家（個人組織）は譲渡・削除できません",
    "err_TARGET_NOT_ORG_ADMIN": "対象はこの組織の有効な管理者である必要があります",
    "err_NOT_AN_ORG_MEMBER": "この組織のメンバーではなくなっています",
    "err_ORG_SUSPENDED": "この組織は停止中のため変更できません",
    "err_ORG_MFA_REQUIRED": "この組織は 2 段階認証が必須です。有効にして再ログインしてください",
    "err_ORG_NOT_FOUND": "組織が見つかりません",
    "err_DEV_HOME_NOT_ALLOWED": "この環境で組織や$t(leaf.cur)を作成するには事前の許可が必要です",
    "err_TEST_IDENTITY_REQUIRED": "この環境で組織や$t(leaf.cur)を作成できるのはテストアカウントのみです",
    "err_FEATURE_DISABLED": "この環境ではこの機能は提供されていません",
    "err_BAD_EMAIL": "メールアドレスの形式が正しくありません",
    "err_BAD_ROLE": "この役割はここでは使えません",
    "err_INVALID_ROLE": "この役割はこの組織では使えません",
    "err_INVITE_GONE": "招待は期限切れか使用済みです",
    "err_SHARE_EXISTS": "同じ用途の共有がすでにあります。既存の共有を調整してください",
    "err_SHARE_NOT_FOUND": "共有が見つかりません",
    "err_SHARE_SCOPE_EXCEEDED": "共有された範囲を超えています",
    "err_GRANT_EXCEEDS_ROLE": "自分が持っていない権限は共有できません",
    "err_INVALID_SCOPE": "選択した権限の一部はここでは使えません",
    "err_INVALID_GRANTEE": "共有先が正しくありません",
    "err_SCOPE_EXPAND": "縮小のみ可能です。広げるには共有し直してください",
    "err_TOO_LONG": "期間がこの用途の上限を超えています",
    "err_REQUEST_GONE": "共有リクエストは期限切れか使用済みです",
    "err_ORG_NOT_VERIFIED": "この組織はこの用途の審査を受けていません",
    "err_NOT_A_RENEWAL": "このコードは更新リクエストではありません",
    "err_NOT_INSTALL": "設置用の共有のみ完了できます",
    "err_EMAIL_EXISTS": "このメールアドレスはすでに登録されています",
    "err_BAD_TARGET": "選択したデバイスはこの$t(leaf.cur)にありません",
    "err_BAD_POLICY": "ポリシーの設定が正しくありません",
    "err_SITE_NOT_FOUND": "拠点が見つかりません",
    "rename": "名前を変更",
    "rename_of": "「{{name}}」の名前を変更",
    "err_USE_ORG_API": "組織から退出してください",
    "err_USER_NOT_FOUND": "先にこの組織のメンバーである必要があります",
    "err_UNAVAILABLE": "一時的に利用できません。しばらくしてからもう一度お試しください",
    "err_NOT_ORG_HOME": "その$t(leaf.cur)は選択したノードの下にありません",
    "err_IDEMPOTENCY_CONFLICT": "リクエスト内容が変わりました。ダイアログを閉じてやり直してください",
    "err_IDEMPOTENCY_IN_PROGRESS": "前のリクエストを処理中です。しばらくしてからもう一度お試しください",
    "err_RATE_LIMITED": "リクエストが多すぎます。しばらくしてからもう一度お試しください",
    "err_CLAIM_NOT_FOUND": "シリアル番号または注文番号が一致しません",
    "levels_hint": "構成ツリーの各階層の名前（例：エリア › 拠点 › フロア › ホーム）。パスやレポートでも使います。",
    "err_SHARE_KIND_NOT_ALLOWED": "Kinio Node と Wi-Fi アクセスポイントは共有できません（共有できる映像やデータがありません）。これらを外してから送信してください。"
  },
  "people": {
    "members": "メンバー",
    "grants": "アクセス権",
    "roles": "役割",
    "home_members": "$t(leaf.cur)のメンバー",
    "members_of": "{{name}} のメンバー",
    "invite": "メンバーを招待",
    "members_hint": "メンバーが見られるデバイスは$t(leaf.cur)の役割と拠点のアクセス権で決まります（組織の役割は組織の管理のみ）。停止・削除したメンバーは 30 秒以内にライブ映像と再生が切断されます。",
    "name": "ユーザー",
    "role": "役割",
    "status": "状態",
    "org_perms": "組織権限",
    "joined": "参加日",
    "all_perms": "すべて",
    "edit_perms": "権限",
    "suspend": "停止",
    "reactivate": "再開",
    "pending_invites": "保留中の招待",
    "expires": "{{date}} まで",
    "revoke_invite": "取り消し",
    "org_role_org_admin": "管理者",
    "org_role_developer": "開発者",
    "status_active": "有効",
    "status_suspended": "停止中",
    "status_left": "退出",
    "edit_perms_of": "{{name}} の組織権限",
    "perms_hint": "組織権限には映像の閲覧は含まれません。映像は「アクセス権」で付与してください。",
    "perm_org_sites": "拠点とメンバー",
    "perm_org_sites_desc": "拠点ツリー、$t(leaf.cur)、アクセス権の管理",
    "perm_org_audit": "監査",
    "perm_org_audit_desc": "監査ログの閲覧",
    "perm_org_billing": "請求",
    "perm_org_billing_desc": "プラン、支払い、使用量",
    "invite_link_body": "{{email}} はまだアカウントがないため、招待メールを送りました。このリンクを直接渡すこともできます（7 日間有効）：",
    "invite_body": "招待は常にメールで送ります。アカウントがあればすぐに参加して通知され、なければ招待メールから登録して参加します（7 日間有効）。",
    "invite_role_hint": "「メンバー」だけではデバイスの権限はありません。「アクセス権」タブの〔＋ アクセス権を付与〕で付与してください。管理者を招待できるのはオーナーだけです。",
    "send_invite": "招待を送信",
    "filter_user": "ユーザーで絞り込み",
    "all_users": "全員",
    "show_revoked": "取り消し済みを表示",
    "assign": "アクセス権を付与",
    "grants_hint": "アクセス権 = ユーザー × 拠点 × デバイス範囲 × 期間。拠点の移動やデバイスの移設後は「更新」で対象を再展開してください。",
    "no_grants": "アクセス権はまだありません。",
    "site": "拠点",
    "home": "$t(leaf.cur)",
    "scope": "デバイス範囲",
    "expires_col": "期限",
    "incl_desc": "（下位拠点を含む）",
    "scope_all": "拠点内すべて",
    "scope_list": "指定 {{n}} 台",
    "targets": "対象 {{n}} 件",
    "grant_active": "有効",
    "grant_expired": "期限切れ",
    "grant_revoked": "取り消し済み",
    "refresh": "更新",
    "refresh_hint": "現在の拠点とデバイスの位置で対象を再展開（期限も延長可）",
    "revoke": "取り消し",
    "revoke_confirm": "取り消しますか？対象のユーザーは 30 秒以内にこれらのデバイスへアクセスできなくなります。",
    "assigned": "付与しました。{{n}} 件のデバイス対象に展開されました：",
    "include_descendants": "下位拠点を含む",
    "no_related_homes": "この拠点の上下に$t(leaf.cur)はありません",
    "custom_actions": "操作を個別に選ぶ…",
    "actions": "操作",
    "scope_all_desc": "拠点内のすべてのデバイス（追加分は更新で反映）",
    "scope_list_desc": "指定したデバイスのみ",
    "devices": "デバイス一覧",
    "days": "有効日数",
    "days_hint": "最長 90 日。期限前に更新すると延長できます。",
    "stepup_note": "送信時に再認証を求められる場合があります。",
    "new_role": "役割を追加",
    "role_kind": "種類",
    "kind_grant": "データアクセス",
    "kind_home_admin": "$t(leaf.cur)管理",
    "kind_org_admin": "組織管理",
    "kind_org_permission": "組織権限",
    "system": "システム",
    "pending_apply": "追加した操作は既存の付与に自動反映されません。{{n}} 件は「適用」を押すと有効になります。",
    "pending_chip": "{{n}} 件が未適用",
    "apply": "適用",
    "apply_title": "既存の付与に適用",
    "apply_confirm": "「{{role}}」の現在の操作を、まだ更新されていない {{n}} 件の付与に適用しますか？付与ごとに個別に選んだ操作は残ります。",
    "applied": "{{n}} 件の付与に適用しました。",
    "edit_role": "役割を編集",
    "role_name": "役割名",
    "role_desc": "説明",
    "role_edit_note": "操作を外すと、この役割を使うすべての付与が即座に縮小されます。追加した操作は「適用」を押すと既存の付与に反映されます。",
    "home_members_hint": "$t(leaf.cur)の役割は組織のメンバーにのみ付与できます。家族はまず自分の家に招待してください（メンバータブ）。表示できるメンバーをここに一覧します。",
    "members_hidden": "組織の付与でこの$t(leaf.cur)にアクセスしているため、メンバー一覧は表示されません。",
    "hrole_owner": "オーナー",
    "hrole_admin": "管理者",
    "hrole_member": "メンバー",
    "hrole_guest": "ゲスト",
    "hrole_undefined": "アクセス権",
    "access": "権限の付与元",
    "access_of": "{{name}} の権限の付与元",
    "src_org": "組織",
    "src_homes": "$t(leaf.cur)の役割",
    "src_grants": "拠点のアクセス権（有効 {{n}} 件）",
    "src_note": "組織の役割自体に映像の権限はありません。映像には$t(leaf.cur)の役割か拠点のアクセス権が必要です。",
    "owns_homes": "この人は以下の$t(leaf.cur)の管理人です。先に「組織と拠点」で引き継いでください。引き継ぐ人がいない場合のみ「管理人なし」にします：",
    "unassign_owned": "後任なし：これらの$t(leaf.cur)を「管理人なし」にする（以後は組織管理者のみ引き継ぎ可能）",
    "left_done": "組織から外しました：アクセス権 {{grants}} 件を取り消し、$t(leaf.cur)の役割 {{homes}} 件を削除、{{unassigned}} 件の$t(leaf.cur)を「管理人なし」にしました。",
    "schedule": "時間帯の制限",
    "schedule_on": "指定した時間帯のみ有効（拠点のタイムゾーン {{tz}}）",
    "dow_1": "月",
    "dow_2": "火",
    "dow_3": "水",
    "dow_4": "木",
    "dow_5": "金",
    "dow_6": "土",
    "dow_7": "日",
    "from": "開始",
    "to": "終了",
    "duty_mode": "当直コンソール用アカウント",
    "duty_mode_desc": "操作がなくてもログアウトしない、12 時間ごとに再ログイン、録画のエクスポート不可",
    "duty_badge": "当直",
    "org_role_owner": "オーナー",
    "org_role_member": "メンバー",
    "org_role_guest": "ゲスト",
    "org_role_factory_ops": "生産管理",
    "role_of": "{{name}} の役割",
    "members_hint_personal": "自分の家のメンバー（家族など）：管理者はすべての$t(leaf.cur)を閲覧・管理でき、メンバーはすべての$t(leaf.cur)を閲覧でき、ゲストはデバイスを個別に許可するまで見られません。",
    "invite_body_personal": "家族を自分の家に招待します。アカウントがあればすぐに参加し、なければ招待メールが届きます（7 日間有効）。",
    "invite_role_hint_personal": "管理者はすべての$t(leaf.cur)を閲覧・管理、メンバーはすべての$t(leaf.cur)を閲覧、ゲストは既定でデバイスを見られません。管理者を招待できるのはオーナーだけです。",
    "invite_joined": "{{email}} はすでにアカウントがあるため、そのまま参加し通知されました。",
    "invite_here": "このサイトで受け入れるためのリンク：",
    "perm_org_devices": "デバイス在庫",
    "perm_org_devices_desc": "在庫の閲覧、登録、事前割り当て、取り込み（映像の閲覧は含みません）",
    "remove": "組織から外す",
    "remove_of": "{{name}} を組織から外す",
    "remove_body": "この組織が与えた権限（$t(leaf.cur)の役割、拠点のアクセス、組織への共有）のみ取り消します。本人の家、他の組織、個人への共有には影響しません。この組織のライブ映像は 30 秒以内に停止します。アカウントは残ります（再招待できます）。",
    "invited_by": "{{name}} が招待",
    "perm_org_support": "問題の報告",
    "perm_org_support_desc": "問題を報告し、組織の報告を閲覧（映像の閲覧は含みません）"
  },
  "roles": {
    "role-org-admin": "組織管理者",
    "role-org-admin_desc": "組織、拠点ツリー、メンバー、請求、監査。映像は別途付与が必要",
    "role-site-admin": "拠点管理者",
    "role-site-admin_desc": "範囲内の$t(leaf.cur)の管理者：デバイス、アクセス権、録画ポリシー",
    "role-operator": "オペレーター",
    "role-operator_desc": "ライブ、再生、通話、PTZ、サイレン",
    "role-viewer": "閲覧者",
    "role-viewer_desc": "ライブとイベント",
    "role-technician": "設置技術者",
    "role-technician_desc": "ピント・向き調整、設定。再生とイベント履歴は不可",
    "role-auditor": "監査担当",
    "role-auditor_desc": "監査ログ"
  },
  "actions": {
    "device": {
      "read": "デバイス閲覧",
      "control": "デバイス操作",
      "install": "デバイス設置",
      "diagnose": "リモート診断"
    },
    "media": {
      "live": "ライブ映像",
      "talk": "通話"
    },
    "recording": {
      "read": "再生",
      "export": "録画のエクスポート"
    },
    "event": {
      "read": "イベント閲覧"
    },
    "case": {
      "read": "案件閲覧",
      "handle": "案件対応"
    },
    "alarm": {
      "receive": "アラームを受信"
    },
    "security": {
      "arm": "リモートで警戒",
      "disarm": "リモートで警戒解除"
    },
    "home": {
      "profile": {
        "read": "$t(leaf.cur)情報の閲覧"
      }
    },
    "install": {
      "complete": "設置完了"
    }
  },
  "audit": {
    "pick_org": "表示する組織を選んでください。",
    "action": "操作",
    "all_actions": "すべての操作",
    "actor": "実行者",
    "all_actors": "すべての実行者",
    "empty": "該当する記録はありません。",
    "system": "システム",
    "more": "さらに古い記録を読み込む",
    "a_org_create": "組織作成",
    "a_site_create": "拠点追加",
    "a_site_update": "拠点変更",
    "a_home_create": "$t(leaf.cur)追加",
    "a_home_member_add": "$t(leaf.cur)メンバー割り当て",
    "a_device_location": "デバイス移設",
    "a_grant_create": "アクセス権付与",
    "a_grant_refresh": "アクセス権更新",
    "a_grant_revoke": "アクセス権取り消し",
    "a_role_create": "役割の追加",
    "a_role_update": "役割の変更",
    "a_member_update": "メンバー変更",
    "a_member_join": "メンバー参加",
    "a_member_activate": "招待を受け入れて参加",
    "a_member_leave": "メンバーが退出",
    "a_home_owner_handover": "管理人の引き継ぎ",
    "a_home_owner_takeover": "組織による引き継ぎ",
    "a_home_unassigned": "$t(leaf.cur)が管理人なしに",
    "a_org_security_policy": "セキュリティポリシー変更",
    "a_member_service_roles": "サービスの役割を設定",
    "a_member_duty_mode": "当直アカウント設定",
    "a_billing_checkout": "購入開始",
    "a_billing_seat_assign": "シート割り当て",
    "a_billing_seat_unassign": "シート解除",
    "a_ai_consent_grant": "クラウド AI 同意",
    "a_ai_consent_exclusions": "クラウド AI 除外リスト",
    "a_ai_consent_revoke": "クラウド AI 同意撤回",
    "a_ai_usage_threshold": "クラウド AI 枠の通知",
    "a_test_hook_billing_contract": "テストフック：契約",
    "search": "操作・デバイス・内容・IP を検索",
    "export_csv": "CSV エクスポート（直近 30 日）",
    "export_failed": "エクスポートに失敗しました。しばらくしてからもう一度お試しください",
    "a_device_settings": "デバイス設定の変更",
    "a_device_command": "デバイスコマンド",
    "a_member_invite": "メンバーを招待",
    "a_member_invite_revoke": "招待を取り消し",
    "a_member_role": "組織の役割を変更",
    "a_member_remove": "メンバーを除外",
    "a_org_owner_transfer": "所有権を譲渡",
    "a_org_delete": "組織を削除",
    "a_share_create": "個人に共有",
    "a_share_request": "共有リクエストを作成",
    "a_share_request_cancel": "共有リクエストを取り下げ",
    "a_share_accept": "組織への共有を承認",
    "a_share_shrink": "共有を縮小",
    "a_share_revoke": "共有を取り消し",
    "a_share_end": "組織が共有を終了",
    "a_share_handover": "設置の引き渡し",
    "a_share_grantee_removed": "共有先が共有を解除",
    "range": "期間",
    "r_today": "今日",
    "r_yesterday": "昨日",
    "r_7d": "過去 7 日",
    "r_custom": "カスタム",
    "from": "開始日",
    "to": "終了日",
    "g_media": "映像アクセス",
    "g_control": "デバイス操作",
    "g_settings": "設定変更",
    "g_perms": "権限",
    "g_account": "アカウント",
    "g_export": "エクスポート",
    "g_billing": "請求",
    "g_other": "その他",
    "g_all": "{{group}}すべて",
    "line": "{{who}} {{what}}",
    "line_target": "{{who}} {{what}}：{{target}}",
    "unknown_device": "あるデバイス",
    "unknown_user": "退出したメンバー",
    "unknown_home": "ある$t(leaf.cur)",
    "unknown_node": "あるノード",
    "src_local": "ローカル録画",
    "src_cloud": "クラウド録画",
    "f_device_ref": "デバイス",
    "f_device": "デバイス",
    "f_user_id": "対象",
    "f_target_user_id": "対象",
    "f_home_id": "$t(leaf.cur)",
    "f_node_id": "ノード",
    "f_source": "ソース",
    "f_reason": "理由",
    "f_keys": "変更した設定",
    "f_command": "コマンド",
    "f_path": "接続方法",
    "f_from": "再生開始位置",
    "f_ip": "IP",
    "tech": "技術的な詳細（サポート用）",
    "s_device_settings": "{{who}} が {{target}} の設定を変更",
    "s_device_command": "{{who}} が {{target}} にコマンドを送信",
    "s_device_rpc": "{{who}} が {{target}} にコマンドを送信",
    "s_device_control": "{{who}} が {{target}} を操作",
    "s_device_location": "{{who}} が {{target}} の位置を変更",
    "s_media_session_start": "{{who}} が {{target}} のライブ映像を視聴開始",
    "s_media_session_end": "{{who}} が {{target}} のライブ映像の視聴を終了",
    "s_recording_playback": "{{who}} が {{target}} の{{src}}を視聴",
    "s_recording_download": "{{who}} が {{target}} の録画をダウンロード",
    "s_recording_delete": "{{who}} が {{target}} の録画を削除",
    "s_grant_create": "{{who}} が {{target}} に拠点の権限を付与",
    "s_grant_refresh": "{{who}} が {{target}} の拠点の権限を更新",
    "s_grant_revoke": "{{who}} が {{target}} の拠点の権限を取り消し",
    "s_member_invite": "{{who}} が新しいメンバーを招待",
    "s_member_role": "{{who}} が {{target}} の組織の役割を変更",
    "s_member_remove": "{{who}} が {{target}} を組織から除外",
    "s_member_update": "{{who}} が {{target}} のメンバー設定を変更",
    "s_member_join": "{{target}} が組織に参加",
    "s_node_assignment_create": "{{who}} が {{target}} にユーザーを割り当て",
    "s_node_assignment_revoke": "{{who}} が {{target}} の割り当てを取り消し",
    "s_node_assignment_update": "{{who}} が {{target}} の割り当てを変更",
    "s_node_block_inheritance": "{{who}} が {{target}} の継承ブロックを変更",
    "s_audit_export": "{{who}} が監査ログをエクスポート",
    "s_billing_seat_assign": "{{who}} がクラウド録画のシートを割り当て",
    "a_device_rpc": "デバイスのリモート呼び出し",
    "a_media_session_start": "ライブ視聴開始",
    "a_media_session_end": "ライブ視聴終了",
    "a_recording_playback": "録画を再生",
    "a_recording_download": "録画をダウンロード",
    "a_recording_delete": "録画を削除",
    "a_recording_policy_update": "録画設定を変更",
    "a_node_assignment_create": "ノード割り当て",
    "a_node_assignment_update": "ノード割り当てを変更",
    "a_node_assignment_revoke": "ノード割り当てを取り消し",
    "a_node_create": "ノードを追加",
    "a_node_update": "ノードを変更",
    "a_node_move": "ノードを移動",
    "a_node_archive": "ノードを停止",
    "a_node_block_inheritance": "継承のブロック",
    "a_node_self_assign": "自分を割り当て",
    "a_role_apply": "役割の変更を適用",
    "a_member_group_create": "メンバーグループを追加",
    "a_member_group_update": "メンバーグループを変更",
    "a_member_group_delete": "メンバーグループを削除",
    "a_audit_export": "監査ログをエクスポート",
    "a_org_rename": "組織名を変更",
    "a_org_tree_settings": "階層名を変更",
    "a_home_delete": "$t(leaf.cur)を削除",
    "a_home_move_node": "$t(leaf.cur)を移動",
    "line_generic_target": "{{who}} が {{target}} を操作",
    "line_generic": "{{who}} が操作",
    "times_one": "× {{count}} 回",
    "times_other": "× {{count}} 回",
    "see_all": "監査ページですべて見る",
    "only_device": "{{name}} のみ",
    "clear_device": "すべてのデバイス",
    "a_media_live": "ライブ映像の視聴",
    "s_media_watched": "{{who}} が {{target}} のライブ映像を {{dur}} 視聴",
    "dur_s": "{{s}} 秒",
    "dur_ms": "{{m}} 分 {{s}} 秒",
    "s_media_replayed": "{{who}} が {{target}} のローカル録画を {{dur}} 再生",
    "paren": "（{{v}}）",
    "mode_write": "（入力可）",
    "mode_read": "（読み取り専用）",
    "mac_tail": "MAC 末尾 {{v}}",
    "fleet_cmd_other": "コマンド",
    "fleet_cmd_reboot": "再起動",
    "fleet_cmd_identify": "識別（点滅）",
    "fleet_cmd_site_wifi_set": "拠点の Wi-Fi 設定",
    "fleet_cmd_wifi_set": "Wi-Fi 設定",
    "fleet_cmd_ttl_config": "UART（TTL）設定",
    "fleet_cmd_ttl_open": "UART（TTL）を開く",
    "fleet_cmd_ttl_close": "UART（TTL）を閉じる",
    "fleet_cmd_caps": "機能の読み取り",
    "fleet_cmd_ota_update": "ファームウェア更新",
    "fleet_cmd_host_nodes": "接続中の Node 一覧",
    "fleet_cmd_host_power": "Node の電源切り替え",
    "fleet_cmd_host_reset": "Node をリセット",
    "fleet_cmd_host_ota": "Node のファームウェア更新",
    "fleet_cmd_host_flash": "Node にファームウェアを書き込み",
    "fleet_cmd_host_wifi": "Node の Wi-Fi 設定",
    "fleet_cmd_host_health": "Node の状態読み取り",
    "fleet_cmd_host_imeas": "電流測定",
    "org_status_active": "有効",
    "org_status_suspended": "停止",
    "org_status_closed": "閉鎖",
    "s_recording_read": "{{who}} が {{target}} の録画一覧を表示",
    "s_fleet_console_ticket": "{{who}} が {{target}} のターミナル接続を取得{{mode}}",
    "s_fleet_console_open": "{{who}} が {{target}} のターミナルを開始{{mode}}",
    "s_fleet_console_close": "{{who}} が {{target}} のターミナルを終了",
    "s_fleet_console_writer": "{{who}} が {{target}} のターミナル入力権を取得",
    "s_fleet_command": "{{who}} が {{target}} に「{{cmd}}」を送信",
    "s_fleet_local_credential": "{{who}} が {{target}} のローカルログインパスワードを設定",
    "s_thing_update": "{{who}} が {{target}} の名前を「{{name}}」に変更",
    "s_thing_update_plain": "{{who}} が {{target}} を変更",
    "s_thing_assigned": "{{who}} が {{target}} を {{place}} に割り当て",
    "s_thing_moved": "{{who}} が {{target}} を {{place}} に移動",
    "s_thing_ttl_direct_token": "{{who}} が {{target}} の LAN 直接接続トークンを取得",
    "s_thing_admin_credential_set": "{{who}} が {{target}} の管理者パスワードを設定",
    "s_media_clip_fetch": "{{who}} が {{target}} の映像を取得{{dur}}",
    "s_vms_ai_assign": "{{who}} が {{target}} を AI ホスト {{provider}} に割り当て",
    "s_vms_ai_unassign": "{{who}} が {{target}} の AI ホスト割り当てを解除",
    "s_vms_alarm_state": "{{who}} が {{target}} のアラームを「{{state}}」に変更",
    "s_vms_device_links_put": "{{who}} が {{target}} の連動カメラを設定（{{n}} 台）",
    "s_vms_floorplan_create": "{{who}} が平面図「{{name}}」を追加",
    "s_vms_floorplan_delete": "{{who}} が平面図「{{name}}」を削除",
    "s_view_create": "{{who}} がレイアウト「{{name}}」を追加",
    "s_view_delete": "{{who}} がレイアウト「{{name}}」を削除",
    "s_org_node_enroll_lookup": "{{who}} が Kinio Node を照会{{mac}}",
    "s_org_node_enroll_identify": "{{who}} が Kinio Node を確認{{mac}}",
    "s_org_node_enroll_approve": "{{who}} が Kinio Node を登録{{mac}}",
    "s_org_inventory_claim": "{{who}} が在庫デバイスを登録{{serial}}",
    "s_org_status": "{{who}} が組織の状態を「{{state}}」に変更",
    "s_org_verification": "{{who}} が組織のサービス区分を審査",
    "s_relationship_request": "{{who}} がサービス関係を申請",
    "s_relationship_handover": "{{who}} がサービス関係を引き継ぎ",
    "s_service_client_created": "{{who}} がサービスアカウントキーを作成",
    "s_service_client_revoked": "{{who}} がサービスアカウントキーを取り消し",
    "s_service_client_secret_rotated": "{{who}} がサービスアカウントキーをローテーション",
    "s_service_write": "サービスアカウントがデータを書き込み",
    "s_model_org_assign": "{{who}} が機種 {{model}} を組織に割り当て",
    "s_model_org_moved": "{{who}} が機種 {{model}} を別の組織に移動",
    "s_model_admin_create": "{{who}} が機種 {{model}} を作成",
    "s_aid_allocate": "{{who}} が AID を払い出し",
    "s_qa_org_case": "{{who}} が機種のテストケースを変更",
    "a_recording_read": "録画一覧の表示",
    "a_fleet_console_ticket": "ターミナル接続の取得",
    "a_fleet_console_open": "ターミナルを開く",
    "a_fleet_console_close": "ターミナルを終了",
    "a_fleet_console_session_closed": "ターミナル終了",
    "a_fleet_console_writer": "ターミナル入力権の取得",
    "a_fleet_command": "Node コマンド",
    "a_fleet_local_credential": "ローカルログインパスワードの設定",
    "a_thing_update": "デバイス名の変更",
    "a_thing_assigned": "デバイスの割り当て",
    "a_thing_moved": "デバイスの移動",
    "a_thing_ttl_direct_token": "LAN 直接接続トークン",
    "a_thing_admin_credential_set": "管理者パスワード設定",
    "a_media_clip_fetch": "映像の取得",
    "a_vms_ai_assign": "AI ホストの割り当て",
    "a_vms_ai_unassign": "AI ホスト割り当て解除",
    "a_vms_alarm_state": "アラーム対応",
    "a_vms_device_links_put": "連動カメラの設定",
    "a_vms_floorplan_create": "平面図の追加",
    "a_vms_floorplan_delete": "平面図の削除",
    "a_view_create": "レイアウトの追加",
    "a_view_delete": "レイアウトの削除",
    "a_org_node_enroll_lookup": "Kinio Node の照会",
    "a_org_node_enroll_identify": "Kinio Node の確認",
    "a_org_node_enroll_approve": "Kinio Node の登録",
    "a_org_inventory_claim": "在庫デバイスの登録",
    "a_org_status": "組織状態の変更",
    "a_org_verification": "サービス区分の審査",
    "a_relationship_request": "サービス関係の申請",
    "a_relationship_handover": "サービス関係の引き継ぎ",
    "a_service_client_created": "サービスキーの作成",
    "a_service_client_revoked": "サービスキーの取り消し",
    "a_service_client_secret_rotated": "サービスキーのローテーション",
    "a_service_write": "サービスアカウントの書き込み",
    "a_model_org_assign": "機種の組織割り当て",
    "a_model_org_moved": "機種の移動",
    "a_model_admin_create": "機種の作成",
    "s_device_read": "{{who}} が {{target}} の{{rcmd}}を読み取り",
    "rcmd_other": "データ",
    "rcmd_ch_list": "チャンネル一覧",
    "rcmd_pb_timeline": "録画タイムライン",
    "rcmd_pb_days": "録画のある日",
    "rcmd_pb_thumb": "録画サムネイル",
    "rcmd_sys_info": "システム情報",
    "rcmd_hdd_info": "ディスク情報",
    "rcmd_rec_status": "録画状態",
    "rcmd_wifi_state": "Wi-Fi 状態",
    "rcmd_pb_list": "録画一覧",
    "s_recording_playback_at": "{{who}} が {{target}} の{{at}}からの{{src}}を視聴",
    "s_media_watched_nodur": "{{who}} が {{target}} のライブ映像を視聴",
    "s_media_replayed_nodur": "{{who}} が {{target}} のローカル録画を視聴",
    "no_end_record": "（終了の記録なし）",
    "s_media_replay_started": "{{who}} が {{target}} のローカル録画の視聴を開始",
    "s_media_replayed_at": "{{who}} が {{target}} の{{at}}からのローカル録画を {{dur}} 再生",
    "s_media_replayed_at_nodur": "{{who}} が {{target}} の{{at}}からのローカル録画を視聴",
    "s_media_replay_started_at": "{{who}} が {{target}} の{{at}}からのローカル録画の視聴を開始",
    "catalog_zh_hant": "no",
    "quoted": "「{{v}}」",
    "s_device_command_named": "{{who}} が {{target}} に「{{cmdName}}」を実行",
    "s_device_set_named": "{{who}} が {{target}} の「{{cmdName}}」を変更",
    "rpc_pb_export": "録画のエクスポート",
    "rpc_cfg_set": "設定の変更",
    "rpc_hdd_smartTest": "ディスクの健康診断",
    "rpc_kinio_pair": "デバイスのペアリング",
    "rpc_kinio_pairWindow": "ペアリング受付",
    "rpc_kinio_net": "ネットワーク設定の変更",
    "rpc_sys_factoryReset": "工場出荷時リセット",
    "rpc_upgrade_check": "ファームウェア更新の確認",
    "rpc_tool_run": "診断ツールの実行",
    "rpc_tool_cancel": "診断ツールの停止",
    "times_since": "× {{n}} 回（最初 {{since}}）",
    "each": "この {{n}} 回",
    "filling": "さらに前の該当する記録を探しています…",
    "reason_client_stop": "視聴者が閉じた",
    "reason_client_gone": "視聴者の接続が切れたか、ページが閉じられた",
    "reason_device_gone": "デバイスが切断",
    "reason_viewer_limit": "同時視聴数の上限で切断",
    "reason_token_expired": "ログイン期限切れ",
    "reason_access_revoked": "視聴権限が取り消された",
    "reason_authorization_unavailable": "権限を一時的に確認できなかった",
    "reason_api_delete": "API で終了",
    "reason_timeout": "タイムアウト"
  },
  "sessions": {
    "title": "ログイン中のデバイス",
    "hint": "強制ログアウトすると、そのデバイスのライブ映像は 30 秒以内に停止し、ログインの更新もできなくなります。",
    "device": "デバイス",
    "ip": "IP",
    "signed_in": "ログイン / 最終認証",
    "last_active": "最終アクティブ",
    "current": "このデバイス",
    "mfa": "2 段階認証",
    "revoke": "ログアウト",
    "sign_out": "このデバイスでログアウト",
    "revoke_others": "他のすべてのデバイスからログアウト",
    "revoke_others_confirm": "他のすべてのデバイスからログアウトしますか？",
    "revoke_current_confirm": "このブラウザからログアウトします。よろしいですか？",
    "client_c_livingstyle_vms": "ls-vms",
    "client_c_kinio_vms_work": "VMS",
    "client_c_kinio_emu": "Kinio エミュレーター"
  },
  "transfer": {
    "button": "引き継ぎ / 引き取り",
    "title_handover": "「{{name}}」を引き継ぐ",
    "title_takeover": "「{{name}}」を引き取る",
    "current": "現在の管理人",
    "unassigned": "管理人なし",
    "target": "新しい管理人",
    "me": "自分",
    "warn_new": "新しい管理人はこの$t(leaf.cur)のライブ映像・録画・管理権を得ます。",
    "warn_old": "現在の管理人は管理人の立場と、この$t(leaf.cur)での拠点のアクセス権を失います（自動で管理者にはなりません）。",
    "warn_takeover": "組織管理者による引き継ぎです。監査ログにすべて記録され、関係者に通知されます。",
    "reason": "理由（必須、監査ログに記録）",
    "submit_handover": "引き継ぐ",
    "submit_takeover": "引き取る",
    "done": "完了しました。前の管理人のこの$t(leaf.cur)でのアクセス権 {{n}} 件を取り消しました（30 秒以内に反映）。",
    "unchanged": "対象はすでに管理人です。変更はありません。",
    "not_allowed": "引き継ぎは現在の管理人のみ、引き取りは組織管理者のみ可能です。"
  },
  "policy": {
    "title": "セキュリティポリシー",
    "hint": "この組織のデバイスと管理機能を使うときだけ適用されます。メンバー自身の家や他の組織には影響しません。変更は次のリクエストから有効です。",
    "idle": "無操作タイムアウト",
    "idle_hint": "操作（マウス・キーボード・タッチ）がこの時間ない場合、この組織のデバイスを使い続けるには再認証が必要です。監視用大画面には当直モードを使ってください。",
    "max_sessions": "同時ログイン上限",
    "max_hint": "この組織を使うログインのみ数えます。上限を超えるとそのログインは再認証が必要になります（アカウント全体はログアウトされません）。",
    "unlimited": "無制限",
    "sessions": "{{n}} 件",
    "minutes": "{{n}} 分",
    "hours": "{{n}} 時間",
    "days_one": "{{count}} 日",
    "days_other": "{{count}} 日",
    "saved": "保存しました",
    "ip_allowlist": "IP 許可リスト",
    "ip_hint": "1 行に 1 つの IP または CIDR（例 203.0.113.0/24）。空欄 = 制限なし。リスト外からのこの組織のデバイスと管理機能へのアクセスは拒否されます。保存時、現在の IP がリストに含まれている必要があります。",
    "require_mfa": "2 段階認証を必須にする",
    "require_mfa_hint": "2 段階認証を有効にしていないメンバーはこの組織のデバイスを見られず、有効にするよう案内されます。アカウント自体には強制しません。",
    "login_max_age": "ログインの有効期間",
    "login_max_age_hint": "ログインからこの時間を過ぎると、この組織のデバイスを使い続けるには再ログインが必要です（アカウント全体はログアウトされません）。",
    "api_keys": "メンバーは API キーでこの組織にアクセスできる",
    "api_keys_hint": "オンにすると、メンバーは自分の API キーで Claude にこの組織のデバイス・イベント・アラームを確認させられます（権限は各自の現在の権限まで。書き込みと映像へのアクセスは毎回監査ログに記録し、読み取りは記録しません）。",
    "snapshot_upload": "イベントのスナップショットをクラウドに保存する",
    "snapshot_upload_hint": "イベントごとに小さな画像を 1 枚クラウドに保存し、通知とイベント一覧にサムネイルを表示、クラウド AI の分析に使います。オフはすぐ反映、オンには再認証が必要です。",
    "snapshot_upload_off_hint": "オフ：イベントは記録されますが、通知にサムネイルがなく、イベント一覧とプレビューはカテゴリのアイコン表示になり、クラウド AI は使えません（ローカル AI 連携は影響なし）。保存済みのスナップショットは通常どおり期限で削除されます。アプリのスクリーンショットには影響しません。"
  },
  "passkey": {
    "title": "パスキー",
    "hint": "指紋・顔認証・デバイスの PIN でパスワードなしでログインでき、それ自体が 2 段階認証になります。iCloud キーチェーンや Google パスワードマネージャーに保存したパスキーは他のデバイスに同期されます。",
    "add": "パスキーを追加",
    "none": "パスキーはまだありません。",
    "unsupported": "このブラウザはパスキーに対応していません。",
    "synced": "同期済み",
    "created": "{{date}} に追加",
    "last_used": "最終使用 {{date}}",
    "delete": "削除",
    "delete_confirm": "「{{name}}」を削除しますか？削除するとこのパスキーではログインできません。",
    "sign_in": "パスキーでログイン",
    "or": "または",
    "verify": "パスキーで確認",
    "or_password": "またはパスワードを入力",
    "err_PASSKEY_CANCELED": "キャンセルまたはタイムアウトしました",
    "err_PASSKEY_EXISTS": "このデバイスにはこのアカウントのパスキーがすでにあります",
    "err_PASSKEY_INVALID": "パスキーの確認に失敗しました",
    "err_PASSKEY_STATE_INVALID": "タイムアウトしました。もう一度お試しください",
    "err_NO_PASSKEY": "このアカウントにはこのサイトのパスキーがまだありません。下のパスワードで認証してください（パスキーは〔設定 › セキュリティ〕で追加できます）。",
    "err_LAST_FACTOR": "所属する組織が 2 段階認証を必須にしています。少なくとも 1 つ（TOTP またはパスキー）を残してください",
    "err_PASSKEY_DISABLED": "この環境ではパスキーが有効になっていません",
    "err_BAD_RP": "このアドレスではパスキーを使えません",
    "err_REAUTH_REQUIRED": "再認証が必要です",
    "err_default": "パスキーに失敗しました（{{code}}）"
  },
  "ext": {
    "verified": "Kinio 審査済み：{{kind}}",
    "until": "{{date}} まで",
    "shrink": "範囲を縮小",
    "revoke": "取り消し",
    "auto_include_new_on": "新しいデバイスを自動追加（状態・イベント・アラームのみ）",
    "cond_always": "映像はいつでも閲覧可",
    "cond_alarm_window": "アラーム後 {{n}} 分以内のみ映像を閲覧可",
    "cond_armed": "警戒中のみ映像を閲覧可",
    "code": "招待コード",
    "code_hint": "サービス事業者から受け取ったコードを入力（またはリンクを開く）。承認はあなたのアカウント内で行い、事業者にアカウント情報は見えません。",
    "preview": "内容を確認",
    "duration_one": "期間 {{count}} 日",
    "duration_other": "期間 {{count}} 日",
    "scopes": "許可する操作",
    "devices": "デバイス",
    "devices_all": "$t(leaf.cur)の現在の全デバイス",
    "devices_list": "選択したデバイスのみ",
    "auto_include_new": "後から追加したデバイスも含める（状態・イベント・アラームのみ。映像と操作は常に別途同意が必要）",
    "media_condition": "映像の条件",
    "history": "開始前の履歴",
    "history_none": "提供しない（既定）",
    "history_days_one": "{{count}} 日前まで",
    "history_days_other": "{{count}} 日前まで",
    "install_lan": "施工モードを許可（設置作業員が現地で LAN 接続、最長 8 時間、引き渡しで無効）",
    "consent_note": "映像・警戒設定・施工モードを含む場合は再認証を求められます。",
    "accept": "承認",
    "shrink_of": "「{{name}}」の範囲を縮小",
    "shrink_hint": "縮小のみ可能です。拡大するには事業者に新しいリクエストを出してもらってください。",
    "access_log_empty": "サービスアクセス記録はまだありません。",
    "when": "日時",
    "who": "担当者",
    "what": "操作",
    "device": "デバイス",
    "purpose_install": "設置",
    "purpose_maintenance": "保守",
    "purpose_monitoring": "監視",
    "purpose_security_service": "警備サービス",
    "purpose_care": "介護",
    "purpose_property": "物件管理",
    "kind_installer": "設置業者",
    "kind_security_provider": "警備業",
    "kind_monitoring_center": "監視センター",
    "kind_property_manager": "物件管理",
    "kind_care_provider": "介護事業者",
    "kind_dealer": "販売店",
    "kind_enterprise": "企業",
    "device_unknown": "削除されたデバイス"
  },
  "svc": {
    "title": "共有リクエスト",
    "note": "お客様への説明（任意）",
    "issue": "招待コードを発行",
    "issued": "7 日間有効・1 回限り。このコードまたはリンクをお客様に渡してください：",
    "status_active": "サービス中",
    "status_suspended": "停止中",
    "status_ended": "終了",
    "complete_install": "設置完了（引き渡し）",
    "end": "終了",
    "end_confirm": "この共有を終了しますか？",
    "service_roles": "サービスの役割",
    "service_roles_hint": "サービス役割は、この人が顧客の$t(leaf.cur)でできることを決めます（顧客が承認した範囲まで）。",
    "role_operator": "オペレーター",
    "role_operator_desc": "状態・イベント・映像・再生・アラーム受信",
    "role_supervisor": "スーパーバイザー",
    "role_supervisor_desc": "警戒設定・解除、録画エクスポート",
    "role_technician": "技術者",
    "role_technician_desc": "設置・設定・リモート診断",
    "tab": "この組織への共有",
    "hint_kinds": "この組織のサービス区分：{{kinds}}。1 回限りのコードを$t(leaf.cur)に渡し、$t(leaf.cur)が自分のアプリまたは VMS で承認するとアクセスできます（プラットフォームの審査が済んでいない用途は$t(leaf.cur)に表示され、サーバーでも拒否されます）。",
    "no_kinds": "この組織にはサービス区分（設置・警備・監視センターなど）がないため共有リクエストを送れません。$t(leaf.cur)からの共有は受け取れます。",
    "purpose": "用途",
    "pending_requests": "$t(leaf.cur)の承認待ち",
    "renewal": "更新",
    "cancel_request": "取り下げ",
    "received": "受け取った共有",
    "received_hint": "メンバーができることは、メンバーの「組織権限…」でサービス役割を設定します（$t(leaf.cur)が共有した範囲まで）。組織はこれらのデバイスを管理・再共有できません。",
    "none_received": "受け取った共有はありません。",
    "a_home": "ある$t(leaf.cur)",
    "unverified": "この組織のサービス区分はまだ審査を通過していない（または期限切れの）ため、共有リクエストは審査通過後に送れます。",
    "verified_until": "{{date}} まで審査済み"
  },
  "sensor": {
    "popups": "センサーのポップアップ",
    "contact_title": "{{name}} が開きました",
    "motion_title": "{{name}} が人を検知しました",
    "playback": "{{cam}} を再生",
    "no_link": "連動カメラがありません。「デバイス」で連動を設定すると、検知時にライブ映像を表示します。",
    "contact_on": "開",
    "contact_off": "閉",
    "motion_on": "検知",
    "motion_off": "なし",
    "alarm_title2": "アラーム · {{what}} · {{name}}",
    "detection_title2": "検知 · {{what}} · {{name}}",
    "more_n_one": "ほかに {{count}} 件",
    "more_n_other": "ほかに {{count}} 件",
    "expand": "展開",
    "collapse": "折りたたむ",
    "watch_live": "ライブを見る",
    "no_snapshot": "スナップショットはまだありません。「ライブを見る」で現場を確認できます",
    "switch_scope": "その範囲に切り替える",
    "alarm_kind": "アラーム · {{what}}",
    "detection_kind": "検知 · {{what}}",
    "out_of_scope_path": "現在の範囲外：{{path}}",
    "switch_scope_to": "{{path}} に切り替え"
  },
  "link": {
    "button": "連動",
    "title": "{{name}} の連動カメラ",
    "help": "検知時（ドアが開く / 人を検知）に表示するカメラ。",
    "cameras": "カメラ",
    "no_cameras": "この$t(leaf.cur)にカメラがありません",
    "purposes": "用途",
    "purpose_popup": "ライブポップアップ",
    "purpose_clip": "イベントカードに再生",
    "readonly": "$t(leaf.cur)のオーナー / 管理者 または組織管理者のみ変更できます"
  },
  "onvif": {
    "open": "ONVIF カメラを追加",
    "title": "ONVIF カメラを追加（Kinio ゲートウェイ経由）",
    "help": "現場の NVR・Kinio Station・AI box（ゲートウェイ）経由でサードパーティの ONVIF カメラを接続します。認証情報はゲートウェイにのみ送られます。Kinio 製品は Kinio のペアリングを使います。",
    "no_gateway": "ゲートウェイにできる、管理可能な Kinio NVR または Kinio Station がありません（オーナーか管理者が必要）。ゲートウェイのない拠点には NVR か AI box を追加してください。",
    "gateway": "ゲートウェイ",
    "discover": "検索",
    "discovering": "検索中…",
    "group_managed": "追加済み",
    "group_own": "Kinio 製品",
    "group_suspect": "Kinio 製品の可能性",
    "group_third_party": "他社 ONVIF",
    "none": "なし",
    "on_channel": "CH{{ch}} で使用中",
    "pair_kinio": "Kinio 方式でペアリング（ONVIF ではなく）",
    "suspect_help": "既定は Kinio 方式のペアリングです。旧機種を ONVIF で追加するには、オーナーが理由を記入します。",
    "suspect_help_owner": "既定は Kinio 方式のペアリングです。ONVIF で追加する場合はチェックして理由を記入してください（監査に記録）。",
    "duplicates": "重複応答 {{n}} 件をまとめました（同じカメラが別インターフェースから応答）",
    "creds_help": "カメラの認証情報（ゲートウェイにのみ送信、保存しません。チェックした全台に使用）",
    "user": "ユーザー",
    "password": "パスワード",
    "add": "{{n}} 台を追加",
    "reason": "Kinio 方式を使わない理由（例：独自プロトコル非対応の旧 Swann 機種）",
    "force_add": "ONVIF で {{n}} 台を追加",
    "result_ok": "追加しました",
    "result_auth_failed": "認証情報が正しくありません",
    "result_timeout": "タイムアウト",
    "result_unreachable": "接続できません",
    "result_unsupported": "非対応",
    "h265_only": "H.265 のみ"
  },
  "ptz": {
    "title": "PTZ 操作",
    "home": "ホーム位置へ戻る",
    "speed": "速度",
    "zoom_in": "ズームイン",
    "zoom_out": "ズームアウト",
    "presets": "プリセット",
    "pick_preset": "プリセットを選択",
    "no_presets": "プリセットなし",
    "loading": "読み込み中…",
    "goto": "移動",
    "save_preset": "現在位置を保存",
    "preset_name": "プリセット名",
    "held": "{{role}}が操作中（{{n}} 秒後に解放）",
    "preempted": "{{role}}に操作権を取られました",
    "take_over": "操作権を取得",
    "role_owner": "オーナー",
    "role_admin": "管理者",
    "role_member": "メンバー",
    "role_operator": "オペレーター",
    "role_partner": "サービスパートナー",
    "dir_up": "上",
    "dir_down": "下",
    "dir_left": "左",
    "dir_right": "右",
    "dir_upleft": "左上",
    "dir_upright": "右上",
    "dir_downleft": "左下",
    "dir_downright": "右下",
    "err_GATEWAY_OFFLINE": "ゲートウェイがオフライン",
    "err_GATEWAY_TIMEOUT": "ゲートウェイが応答しません",
    "err_FORBIDDEN": "このデバイスを操作する権限がありません",
    "cruise_start": "巡回を開始",
    "cruise_stop": "巡回を停止",
    "cruise_dwell": "各地点の停止時間（秒）",
    "cruise_at": "巡回中：{{name}}",
    "presets_count": "プリセット　{{n}} / {{max}}",
    "presets_count_a11y": "プリセット、保存済み {{n}} 件、最大 {{max}} 件",
    "preset_n": "位置 {{n}}",
    "preset_add": "＋ 追加",
    "preset_full": "上限です",
    "preset_manage": "管理",
    "preset_manage_a11y": "プリセットを管理",
    "preset_done": "完了",
    "preset_done_a11y": "管理を終了",
    "preset_rename": "名前を変更",
    "preset_name_it": "名前を付ける",
    "preset_update": "現在の位置で更新",
    "preset_delete": "削除",
    "preset_delete_confirm": "「{{name}}」を削除しますか？",
    "preset_here": "現在の位置",
    "preset_going": "{{name}}へ移動中",
    "preset_arrived": "{{name}}に移動しました",
    "preset_card_a11y": "{{name}}、プリセット",
    "preset_card_unnamed_a11y": "{{name}}、プリセット、名前なし",
    "preset_menu": "プリセットのオプション",
    "preset_name_label": "名前",
    "preset_name_hint": "最大 12 文字。このカメラを見られる人全員に表示されます",
    "preset_save": "保存",
    "preset_unreachable": "カメラがオフラインのため、前回のプリセットを表示しています",
    "preset_conflict": "ほかの人がプリセットを変更したため、更新しました",
    "preset_err_BUSY": "PTZ が使用中です。しばらくしてからもう一度お試しください。",
    "preset_err_NOT_FOUND": "この位置は無効になりました",
    "preset_err_NOT_CALIBRATED": "PTZ はまだキャリブレーション中です",
    "preset_err_TIMEOUT": "{{name}}に移動できませんでした",
    "preset_err_OFFLINE": "カメラがオフラインのため、更新 / 削除されていません",
    "preset_err_ASLEEP": "カメラはスリープ中です。しばらくしてからもう一度お試しください。",
    "preset_err_LIMIT": "プリセットが上限に達しました",
    "preset_err_INVALID_NAME": "1〜12 文字の名前を入力してください",
    "preset_err_OTHER": "完了しませんでした。もう一度お試しください。",
    "lens_note": "左右：両方のレンズが回転、上下：{{name}}のみ",
    "lens_none": "方向パッド。このレンズは動きません"
  },
  "ai": {
    "title": "AI 処理",
    "help": "AI box、AI チップ搭載の NVR、Kinio Station が現場で同じ$t(leaf.cur)のカメラの AI 分析を行います。検知イベントは元のカメラに記録されます。現場の AI はハードウェアに含まれ、サブスクリプションは不要です。",
    "no_provider": "この範囲には AI を実行できるデバイス（AI box、AI チップ搭載の NVR、Kinio Station）がまだありません。",
    "assign": "カメラを割り当て",
    "assign_title": "{{name}} にカメラを割り当て",
    "assign_submit": "割り当てる",
    "probing": "プロバイダーにストリームを確認させています…",
    "capacity": "{{used}} / {{total}} ch 使用中",
    "capacity_title": "{{total}} ch 中 {{used}} ch 使用中",
    "load": "負荷 {{n}}%",
    "fps": "{{n}} fps",
    "none": "割り当てなし",
    "move": "移動先…",
    "unassign": "解除",
    "drag_help": "カメラを上のプロバイダーにドラッグするか「カメラを割り当て」を押してください",
    "camera": "カメラ",
    "models": "モデル",
    "sensitivity": "感度 {{n}}",
    "st_pending": "適用中",
    "st_running": "実行中",
    "st_degraded": "負荷軽減中",
    "detail_viewer_limit": "このデバイスの視聴枠がライブ視聴で埋まっています。AI 解析は一時停止し、枠が空くと自動で再開します。",
    "detail_lan_unreachable": "ローカルネットワークでソースデバイスに接続できないため、イベント解析を一時停止しています。",
    "st_unreachable": "接続不可",
    "st_rejected": "拒否",
    "err_AI_SOURCE_UNREACHABLE": "プロバイダーがこのカメラに接続できません：{{message}}",
    "err_AI_SOURCE_UNSUPPORTED": "このカメラ（またはその NVR / Station / ベースステーション）のファームウェアは、まだ AI 処理プロバイダーへ映像を中継できません",
    "err_AI_CAPACITY_FULL": "容量上限（{{used}} / {{channels}} ch）",
    "err_AI_ALREADY_ASSIGNED": "このカメラはすでに割り当て済みです",
    "err_AI_MODEL_UNSUPPORTED": "プロバイダーはモデル {{model}} に未対応です",
    "err_PROVIDER_OFFLINE": "プロバイダーがオフライン",
    "err_NOT_AI_PROVIDER": "このデバイスは AI 処理プロバイダーではありません",
    "err_FORBIDDEN": "$t(leaf.cur)のオーナーまたは管理者が必要です",
    "err_VERSION_CONFLICT": "他の人が変更しました。再読み込みしてください",
    "err_GATEWAY_OFFLINE": "ゲートウェイがオフライン",
    "err_GATEWAY_TIMEOUT": "ゲートウェイが応答しません",
    "model": {
      "kinio": {
        "person_vehicle@2": "人・車両検知",
        "line_cross@1": "ライン通過",
        "intrusion@1": "侵入検知"
      }
    },
    "delivery": "映像の取得方法",
    "delivery_auto": "自動（可能なら常時）",
    "delivery_continuous": "常時ストリーム",
    "delivery_event": "イベントスナップショット",
    "delivery_help": "映像はカメラ本体、またはその NVR / Station / ベースステーションがプロバイダーへ中継するため、プロバイダーにカメラのパスワードは不要です。常時ストリームはそのデバイスの視聴枠を 1 つ使います。バッテリーカメラはイベントスナップショットのみです。",
    "err_AI_DELIVERY_UNSUPPORTED": "このカメラはその取得方法に対応していません（バッテリーカメラはイベントスナップショットのみ）",
    "err_AI_VIEWER_LIMIT": "デバイスの視聴枠が埋まっています（上限 {{limit}}：視聴中 {{viewers}}、AI 常時ストリーム {{ai}}）。イベントスナップショットにするか、後でもう一度お試しください",
    "err_BAD_DELIVERY": "取得方法が正しくありません",
    "tab_local": "ローカル AI",
    "tab_cloud": "クラウド AI",
    "stations_without_one": "{{count}} 台の Kinio Station は AI 処理ができないため、上の一覧にはありません。",
    "stations_without_other": "{{count}} 台の Kinio Station は AI 処理ができないため、上の一覧にはありません。",
    "move_confirm": "{{cam}} を {{to}} に移しますか？",
    "move_body": "今のプロバイダーでの分析は止まり、数秒で新しいプロバイダーに切り替わります。",
    "move_action": "移す",
    "moved": "{{cam}} を {{to}} に移しました。",
    "move_undo": "元に戻す",
    "subject": {
      "person": "人",
      "vehicle": "車両",
      "animal": "動物",
      "face": "顔",
      "plate": "ナンバープレート",
      "package": "荷物",
      "fire": "炎",
      "smoke": "煙"
    },
    "subject_sep": "／",
    "model_detect": "{{what}}検知",
    "model_detect_light": "{{what}}検知（軽量）",
    "model_generic": "AI 検知モデル v{{v}}",
    "stations_without_named": "{{names}} には AI 処理機能がありません（この Kinio Station には推論バックエンドがありません）。そのため上の一覧にありません。",
    "unassign_confirm": "{{cam}} の AI 分析を解除しますか？",
    "unassign_body": "このカメラの AI 検知が停止し、以後 AI イベントは作成されません。解除後〔元に戻す〕で同じ設定で再割り当てできます。",
    "unassign_action": "割り当て解除",
    "unassigned": "{{cam}} の AI 分析を解除しました。",
    "tab_byo": "自前の AI"
  },
  "search": {
    "placeholder": "イベント検索：赤 バイク device:玄関 class:person tag:helmet after:2026-09-01",
    "sort": "並び順",
    "sort_time": "新しい順",
    "sort_relevance": "関連度順",
    "suggest": "候補",
    "syntax": "構文：フリーテキスト、\"フレーズ\"、-除外、class: level: device:（デバイス名、例 device:\"NVR631 / CH5\"）site:（拠点、配下を含む）node: view: group:（組織ツリーのノード / レイアウト / グループ、名前を入力して選択）tag: after: before: on: has:clip；カンマ = または",
    "warnings": "解釈できない条件を無視しました：{{list}}",
    "histogram": "時間ごとのイベント数",
    "more": "さらに読み込む",
    "producer": "{{id}} が検知",
    "bm_add": "ブックマーク追加",
    "bm_title": "ブックマーク名",
    "bm_note": "メモ（任意）",
    "bm_private": "自分だけ",
    "bm_saved": "ブックマークしました",
    "bm_delete": "ブックマーク削除",
    "bookmarks": "ブックマーク",
    "site_unknown": "拠点が見つかりません：{{list}}（この条件では結果が出ません）",
    "saved": "保存した検索",
    "saved_none": "保存した検索はまだありません",
    "saved_shared": "共有",
    "saved_name": "名前",
    "saved_scope": "保存先",
    "saved_personal": "自分だけ",
    "saved_org": "{{name}} で共有",
    "saved_save": "現在の検索を保存",
    "saved_delete": "「{{name}}」を削除",
    "saved_help": "保存されるのは検索条件だけです。適用すると現在の権限で検索し直します。",
    "saved_err_SAVED_SEARCH_LIMIT": "保存した検索は 100 件までです。不要なものを削除してください",
    "saved_err_BAD_NAME": "名前は 1〜80 文字にしてください",
    "saved_err_FORBIDDEN": "共有の保存検索には組織管理者の権限が必要です",
    "to_map": "この結果を地図で見る",
    "src_edge_box": "AI box",
    "src_device": "デバイス AI",
    "node_none": "「{{q}}」に一致するノードはありません",
    "tree_filters": "絞り込み中：{{list}}",
    "tree_field_node": "ノード「{{name}}」",
    "tree_field_view": "レイアウト「{{name}}」",
    "tree_field_group": "グループ「{{name}}」",
    "node_error": "ノード検索に失敗しました。しばらくしてから再試行してください（該当なしではありません）",
    "node_partial": "一部の地域でノード検索に失敗しました。取得できた結果のみ表示しています",
    "tree_name_unknown": "{{id}}（名前不明）",
    "range": "期間",
    "range_any": "すべての期間",
    "range_today": "今日",
    "range_yesterday": "昨日",
    "range_24h": "過去 24 時間",
    "range_custom": "カスタム…",
    "range_from": "開始",
    "range_to": "終了",
    "syntax_btn": "ⓘ 構文",
    "syntax_dates": "日付（YYYY-MM-DD、あなたのタイムゾーン）：after:D は D の当日から（当日を含む）、before:D は D の 0:00 まで（当日を含まない）、on:D はその日だけ。",
    "range_7d": "過去 7 日間",
    "hist_tip": "{{at}} · {{n}} 件",
    "hist_hint": "棒グラフをドラッグすると期間を設定できます。1 本クリックでその 1 時間だけ表示します。",
    "term_as_class": "{{terms}} はイベント種類で検索：「{{cls}}」（映像信号の途絶・取り外し／遮蔽を含む）"
  },
  "exports": {
    "title": "エクスポートと証拠",
    "help": "録画を MP4 の証拠パッケージ（各ファイルの SHA-256 とプラットフォーム署名付き）として書き出します。ソースはクラウド、NVR / Station のディスク、オフサイトバックアップから選べます。ダウンロードのたびに権限を再確認します。完了したパッケージは 30 日間無料で保存され、それ以上は長期保管に切り替えられます。",
    "new": "新規エクスポート",
    "none": "エクスポートはまだありません",
    "st_queued": "待機中",
    "st_running": "処理中",
    "st_done": "完了",
    "st_failed": "失敗",
    "st_expired": "期限切れ",
    "signed": "署名済み",
    "unsigned": "未署名",
    "reason": "理由",
    "download": "証拠パッケージをダウンロード",
    "share": "共有",
    "home": "$t(leaf.cur) / 拠点",
    "cameras": "カメラ（最大 {{max}} 台）",
    "from": "開始",
    "minutes": "長さ",
    "n_min": "{{n}} 分",
    "reason_ph": "例：警察からの照会、事件番号…（必須。監査ログと証拠パッケージに記録）",
    "create": "エクスポート作成",
    "export_this": "この区間をエクスポート",
    "share_title": "共有リンク",
    "ttl": "有効期間",
    "ttl_3600": "1 時間",
    "ttl_86400": "1 日",
    "ttl_604800": "7 日",
    "ttl_2592000": "30 日",
    "max_views": "閲覧回数上限",
    "unlimited": "無制限",
    "share_password": "パスワード",
    "share_password2": "パスワード（確認）",
    "optional": "任意",
    "share_create": "リンク作成",
    "share_once": "このリンクは今回だけ表示されます。今コピーしてください。",
    "expires": "有効期限 {{at}}",
    "views": "閲覧 {{n}} / {{max}}",
    "has_password": "パスワードあり",
    "revoked": "取り消し済み",
    "expired": "期限切れ",
    "revoke": "取り消す",
    "err_REASON_REQUIRED": "理由は必須です（4 文字以上）",
    "err_BAD_RANGE": "範囲が不正です：カメラごとに 1 区間、終了は開始より後、最大 1 時間、未来は不可",
    "err_BAD_SOURCES": "カメラを 1〜4 台選んでください",
    "err_FORBIDDEN": "このカメラをエクスポートする権限がありません",
    "err_EXPORT_NOT_READY": "エクスポートはまだ完了していません",
    "err_BAD_TTL": "期間は 1 時間〜30 日です",
    "source": "ソース",
    "src_cloud": "クラウド録画",
    "src_local": "NVR / Station ディスク",
    "src_backup": "オフサイトバックアップ",
    "src_cloud_help": "クラウド録画のクリップからエクスポートします。",
    "src_local_help": "NVR / Kinio Station にこの区間のローカル録画をアップロードさせてエクスポートします（今回のエクスポート専用で、クラウド録画には数えず、シートも使いません）。デバイスがオンラインである必要があり、カメラの SD カードは未対応です。",
    "src_backup_help": "検証済みのオフサイトバックアップからエクスポートします（読み出し時に完全性を再確認します）。",
    "local_waiting": "デバイスがローカル録画をアップロードするのを待っています（最大 30 分）…",
    "fail_local_export_unsupported": "このデバイスのファームウェアはローカル録画のエクスポートに未対応です",
    "fail_local_upload_timeout": "デバイスが時間内にアップロードを終えませんでした（オフラインか、アップロードが遅い可能性があります）",
    "fail_local_export_failed": "デバイスがエクスポート要求を受け付けませんでした（オフラインの可能性があります）",
    "fail_no_recording": "この時間帯にローカル録画がありません",
    "fail_codec_not_supported": "この時間帯の映像コーデックはエクスポートできません（H.264 / H.265 のみ）",
    "tab_jobs": "エクスポート一覧",
    "no_rec_in_source": "この時間帯は{{src}}がありません",
    "recipient": "受信者",
    "recipient_ph": "例：田中様 / tanaka@example.jp",
    "recipient_help": "受信者ごとに 1 つのリンク。相手の画面の透かしにマスクした形で表示されます。",
    "ttl_until_export": "エクスポートの期限まで（{{at}}）",
    "share_export_expiry": "エクスポートは {{at}} まで保存されます。共有リンクもそれより長くは有効になりません。",
    "share_clamped": "有効期限をエクスポートの期限（{{at}}）までに短縮しました。",
    "no_recipient": "（受信者なし）",
    "err_EXPORT_EXPIRES_SOON": "このエクスポートは 1 時間以内に期限切れになります。共有する前にもう一度エクスポートしてください。",
    "err_RECIPIENT_REQUIRED": "受信者（名前またはメール、100 文字以内）を入力してください",
    "fail_signing_failed": "証拠パッケージの署名に失敗したため、未署名のパッケージは作成していません。しばらくしてからもう一度エクスポートするか、プラットフォームに連絡してください。",
    "block_not_enabled": "この組織では証拠エクスポートがまだ有効になっていません。サービス提供者に有効化を依頼してください。",
    "block_worker_disabled": "この環境では現在エクスポートを作成できません。",
    "block_tmp_space_low": "エクスポートサービスが混み合っています。しばらくしてからもう一度お試しください。",
    "block_gateway_unreachable": "現在エクスポートを作成できません。しばらくしてからもう一度お試しください。",
    "max_views_help": "既定は {{n}} 回です。相手が共有ページを開くたびに 1 回と数えます。",
    "fail_queue_timeout": "待ち時間が長すぎて開始されませんでした（当時エクスポートサービスが停止中か混雑中）。もう一度エクスポートを作成してください。",
    "st_deleted": "削除済み",
    "archived": "長期保管",
    "kept_free": "{{at}} まで無料保存",
    "kept_archive": "{{at}} まで長期保管",
    "quota_line": "無料保存容量（組織で共有）：{{limit}} 中 {{used}} 使用",
    "block_quota_exceeded": "この組織の無料エクスポート容量がいっぱいです。不要なパッケージを削除するか、残したいものを長期保管に切り替えてください。",
    "delete": "削除…",
    "delete_title": "エクスポートパッケージを削除",
    "delete_help": "削除すると証拠パッケージと共有リンクはすぐに無効になり、ファイルはクラウドから削除されます。元に戻せません。",
    "delete_no_refund": "このパッケージは長期保管中です。期限前に削除しても、支払い済みの保管料金は返金されません。",
    "delete_reason": "削除理由（必須・監査ログに記録されます）",
    "delete_confirm": "削除",
    "deleted_reason": "削除理由",
    "err_EXPORT_BUSY": "エクスポートはまだ処理中です。完了後に削除できます。",
    "err_EXPORT_GONE": "パッケージはすでに期限切れか削除されています。",
    "archive": "長期保管…",
    "archive_extend": "保管を延長…",
    "archive_title": "長期保管に切り替え",
    "archive_extend_title": "長期保管を延長",
    "archive_help": "このパッケージは {{size}}（{{cls}}）です。長期保管中もダウンロード・検証・共有リンクの作成ができます（各リンクは最長 30 日）。保管期間が終わると削除されます。延長は現在の期限の後ろに追加されます。",
    "archive_size_5gb": "≤ 5 GB",
    "archive_size_20gb": "≤ 20 GB",
    "archive_size_50gb": "≤ 50 GB",
    "archive_period": "保管期間",
    "archive_p_90d": "90 日",
    "archive_p_1y": "1 年",
    "archive_p_3y": "3 年",
    "archive_after": "支払い後 {{at}} まで保存",
    "archive_reason": "理由（必須・監査ログに記録されます）",
    "archive_no_refund": "一回限りの支払いで、価格は税抜です。期限前にパッケージや$t(leaf.cur)を削除しても、支払い済みの料金は返金されません。",
    "archive_pay": "支払いへ進む",
    "archive_processing": "支払いを処理中です。完了するとここが更新されます…",
    "archive_done": "長期保管が有効になりました。",
    "archive_failed": "支払いが完了しませんでした。パッケージの保存期限は変わりません。",
    "archive_canceled": "支払いを取り消しました。パッケージの保存期限は変わりません。",
    "archive_slow": "支払い結果がまだ届いていません。少し待ってから再読み込みしてください。",
    "err_ARCHIVE_TOO_LONG": "延長後の期限は今日から 3 年を超えられません。",
    "err_ARCHIVE_TOO_LARGE": "50 GB を超えるパッケージは長期保管できません。",
    "err_ARCHIVE_PENDING": "このパッケージの長期保管はすでに決済中です。完了させるか、期限切れ（23 時間）を待ってください。",
    "err_EXPORT_NOT_DONE": "エクスポートが完了してから長期保管に切り替えられます。",
    "err_STORE_NOT_CONFIGURED": "このブランドではまだオンライン決済を利用できません。サービス提供者にお問い合わせください。",
    "err_BAD_PERIOD": "保管期間は 90 日・1 年・3 年のいずれかです。"
  },
  "shares": {
    "tab": "共有リンク",
    "help": "外部への共有リンクの一覧：誰に、誰が作成し、いつ期限切れになり、何回視聴されたか。識別コードは相手の画面の透かしに出る 6 文字です。",
    "filter": "表示",
    "f_active": "有効",
    "f_all": "すべて",
    "revoke_picked": "選択した {{n}} 件を取り消す",
    "none_active": "現在有効な共有リンクはありません",
    "none_all": "共有リンクはまだ作成されていません",
    "pick_all": "有効なものをすべて選択",
    "pick": "{{code}} を選択",
    "col_video": "映像",
    "col_recipient": "受信者",
    "col_code": "識別コード",
    "col_by": "作成者",
    "col_created": "作成日時",
    "col_expires": "有効期限",
    "col_views": "閲覧",
    "col_password": "パスワード",
    "col_status": "状態",
    "col_actions": "操作",
    "by_me": "自分",
    "by_other": "他のメンバー",
    "st_active": "有効",
    "st_expired": "期限切れ",
    "st_revoked": "取り消し済み",
    "st_used_up": "閲覧回数の上限に到達",
    "revoke_one_title": "取り消すと相手はこのリンクを開けなくなります",
    "revoke_body": "受信者：{{who}}（識別コード {{code}}）。30 秒以内に反映され、元に戻せません。再度共有するには新しいリンクを作成してください。",
    "revoke_many_title": "共有リンク {{n}} 件を取り消す",
    "revoke_many_body": "これらの受信者は 30 秒以内に開けなくなり、元に戻せません。取り消しに失敗したものは理由とともに表に残ります。"
  },
  "share": {
    "title": "共有された映像",
    "need_password": "この映像はパスワードで保護されています",
    "password": "パスワード",
    "wrong_password": "パスワードが正しくありません",
    "open": "開く",
    "gone": "この共有リンクは無効です（期限切れ、取り消し、または閲覧回数の上限）。",
    "not_found": "共有リンクが見つかりません。",
    "error": "現在読み込めません。しばらくしてからもう一度お試しください。",
    "expires": "リンクの有効期限：{{at}}",
    "clip_n": "クリップ {{n}}"
  },
  "verify": {
    "title": "証拠パッケージ検証",
    "help": "ブラウザ内で証拠パッケージを確認します：各ファイルの SHA-256 が manifest と一致するか、manifest のプラットフォーム署名が有効か。ファイルはアップロードされません。",
    "drop": "証拠パッケージの ZIP をここにドロップ、またはクリックして選択",
    "checking": "確認中…",
    "v_pass": "検証成功：ファイルは完全、署名は有効",
    "v_fail": "検証失敗：内容が改ざんされているか署名が無効",
    "v_unsigned": "ファイルは完全ですが、このパッケージには署名がありません",
    "job": "エクスポート",
    "exported_by": "エクスポート者",
    "reason": "理由",
    "generated": "作成日時",
    "signature": "署名",
    "sig_valid": "有効",
    "sig_invalid": "無効（manifest が改ざんされているかプラットフォームの署名ではない）",
    "sig_unsigned": "署名なし",
    "sig_no_key": "対応するプラットフォーム鍵がありません",
    "missing": "ファイルがありません",
    "mismatch": "SHA-256 不一致（改ざんされています）",
    "extra": "manifest にない余分なファイル",
    "err_bad_zip": "有効な ZIP ではありません",
    "err_no_manifest": "ZIP に manifest.json がありません",
    "err_bad_manifest": "manifest.json の形式が不正です",
    "tab": "証拠パッケージの検証",
    "key": "署名鍵",
    "fp_short": "フィンガープリント {{fp}}",
    "key_current": "使用中",
    "key_retired": "使用終了",
    "keys_title": "プラットフォームの検証鍵（{{n}} 件）",
    "keys_help": "鍵を変更した後も、古い証拠パッケージは署名した当時の鍵で検証されます。下のフィンガープリントをプラットフォームの公開資料と照合できます。"
  },
  "billing": {
    "subject": "支払い主体",
    "subject_org": "組織：{{name}}",
    "subject_home": "$t(leaf.cur)：{{name}}",
    "no_subject": "プランを管理できる組織または$t(leaf.cur)がありません。",
    "notice_ok": "完了",
    "notice_warn": "注意",
    "notice_err": "エラー",
    "checkout_canceled": "支払いをキャンセルしました。請求は発生していません。",
    "checkout_processing": "支払いを受け付けました。確認中です（通常数秒）…",
    "checkout_done": "購入が完了しました。シートと枠が有効になりました。",
    "checkout_failed": "支払いが完了しなかったか、期限切れです。",
    "checkout_slow": "確認に時間がかかっています。少し後に再読み込みしてください。請求済みの場合、シートは自動で表示されます。",
    "subscriptions": "サブスクリプション",
    "no_subscriptions": "サブスクリプションはまだありません。",
    "items": "内容",
    "state": "状態",
    "period_end": "次回更新 / 終了",
    "grace_until": "猶予期限 {{at}}",
    "manage": "支払いとサブスクリプションを管理",
    "manage_hint": "Stripe の管理ページでシート数の変更、カードの変更、解約ができます（変更は 1 分以内に反映）。",
    "buy": "購入",
    "draft_prices": "価格は暫定",
    "store_not_configured": "このブランドは支払いアカウントが未設定のため、購入できません。",
    "need_org_billing": "購入には組織管理者または「請求」権限が必要です。閲覧のみ可能です。",
    "need_owner": "購入できるのは$t(leaf.cur)のオーナーだけです。",
    "product": "商品",
    "price": "価格",
    "quantity": "数量",
    "per_month": "月",
    "per_year": "年",
    "per_seat": "1 シートあたり",
    "buy_btn": "購入（{{total}}）",
    "seat_name": "クラウド録画シート：{{mode}}・保存 {{days}} 日",
    "ai_name": "クラウド AI：月 {{n}} 回分析",
    "pack_name": "クラウド AI 追加：{{n}} 回",
    "pack_hint": "今月（UTC）のみ有効",
    "ai_already": "クラウド AI は契約済みです。枠が足りなければ追加購入してください",
    "mode_event": "イベント録画",
    "mode_continuous": "常時録画",
    "days_one": "{{count}} 日",
    "days_other": "{{count}} 日",
    "seats": "クラウド録画シート",
    "seats_summary": "全 {{total}} シート、未割り当て {{free}}",
    "no_seats": "シートはまだありません。購入後、ここでデバイスやチャンネルに割り当てます。",
    "seat": "シート",
    "source": "取得元",
    "source_subscription": "サブスクリプション",
    "source_grant": "契約",
    "contract_until": "契約期限 {{at}}",
    "assigned_to": "割り当て先",
    "unassigned": "未割り当て",
    "has_seat": "シートあり",
    "usage_month": "今月のアップロード",
    "usage": "{{clips}} 件 · {{mb}} MB",
    "assigned": "{{name}} に割り当てました。{{within}} 秒以内にこのシートでアップロードを開始します。",
    "covered_by_plan": "{{name}} はもともと$t(leaf.cur)のプランに含まれています。割り当て後はこのシートの保存日数とモードになります。",
    "seats_hint": "1 台のデバイス（または NVR の 1 チャンネル）が同時に持てるのは 1 シートだけです。割り当て変更後、元のデバイスは 60 秒以内にアップロードを停止し、保存済みの録画は元の保存日数のまま残ります。",
    "ai": "クラウド AI の枠",
    "ai_usage": "{{period}}：{{used}} / {{limit}} 回使用",
    "ai_packs": "（追加 {{n}} 回を含む）",
    "ai_limit_reached": "今月の枠を使い切りました。分析は停止中ですが、録画とイベントには影響しません。追加購入できます。",
    "ai_near_limit": "今月の枠の 80% 以上を使用しました。",
    "ai_feature_detect": "物体検出（補完）",
    "ai_feature_attributes": "属性タグ",
    "ai_feature_caption": "シーン説明",
    "ai_feature_lpr": "ナンバープレート認識",
    "state_pending": "支払い待ち",
    "state_active": "有効",
    "state_cancel_pending": "期間終了時に解約",
    "state_grace": "猶予期間",
    "state_on_hold": "停止中（支払い失敗）",
    "state_expired": "期限切れ",
    "state_revoked": "取り消し",
    "state_ended": "終了",
    "err_generic": "操作に失敗しました（{{code}}）",
    "err_FEATURE_DISABLED": "常時録画はまもなく提供開始です。現在は常時録画シートを購入できません。",
    "coming_soon": "まもなく提供開始",
    "err_STORE_NOT_CONFIGURED": "このブランドは支払いアカウントが未設定です。",
    "err_ALREADY_ENTITLED": "クラウド AI は契約済みです。枠が足りなければ追加購入してください。",
    "err_REF_HAS_SEAT": "このデバイスには既にシートがあります。先にそのシートを解除してください。",
    "err_SEAT_ENDED": "このシートは終了しています。",
    "err_PRODUCT_NOT_PURCHASABLE": "この商品は現在購入できません（改版された可能性があります）。再読み込みしてください。",
    "err_BAD_RETURN_URL": "戻り先 URL が許可されていません。",
    "err_DEVICE_NOT_FOUND": "このデバイスは対象の$t(leaf.cur)にありません。",
    "err_FORBIDDEN": "この操作の権限がありません。",
    "err_USE_ORG_BILLING": "チーム組織の$t(leaf.cur)のシートと AI は組織が購入します。",
    "err_NO_CUSTOMER": "まだ購入していないため、管理できる支払い情報がありません。",
    "err_STORE_ERROR": "支払いサービスが一時的に利用できません。しばらくしてから再度お試しください。",
    "rate": "直近 1 時間 {{kbps}} kbps",
    "uplink_title": "常時録画の実測アップロード（直近 1 時間、拠点別）：",
    "uplink_home": "{{mbps}} Mbps。拠点の上り帯域が足りているか確認してください",
    "pick_title": "どのプランと請求を表示しますか？",
    "capsule": "支払い主体：{{name}}",
    "home_plan_item": "{{name}}（{{where}}）",
    "home_plan_cams_one": "ほかに$t(leaf.cur)プランでクラウド録画中のカメラ：{{names}}",
    "home_plan_cams_other": "ほかに$t(leaf.cur)プランでクラウド録画中のカメラ（{{count}} 台）：{{names}}",
    "archives": "証拠パッケージの長期保管",
    "archives_help": "エクスポートパッケージは 30 日間無料で保存されます。それ以上保存するには「エクスポートと証拠」で各パッケージの〔長期保管…〕を選んでください。一回限りの支払い（米ドル・税抜）です。",
    "archive_size": "パッケージのサイズ",
    "no_archives": "長期保管中のパッケージはありません。",
    "archive_job": "エクスポート",
    "archive_period": "期間",
    "archive_ends": "保管期限",
    "archive_days": "{{n}} 日",
    "archive_st_active": "保管中",
    "archive_st_pending": "決済中",
    "archive_st_expired": "決済期限切れ",
    "archive_st_revoked": "返金済み"
  },
  "backup": {
    "title": "オフサイトバックアップ",
    "help": "NVR の録画を暗号化して NAS または別の NVR に送ります。保存先は暗号化されたファイルだけを持ち、鍵は持ちません。保護状況は「届いたことを確認・検証できた最後の時点」で表します。",
    "add_target": "保存先を追加",
    "new_policy": "バックアップポリシーを作成",
    "targets": "保存先",
    "no_targets": "バックアップ先がまだありません。",
    "policies": "バックアップポリシー",
    "no_policies": "バックアップポリシーがまだありません。",
    "delete": "削除",
    "test": "接続テスト",
    "test_ok": "接続 OK",
    "test_first": "先にテスト",
    "save_target": "登録",
    "rotate": "認証情報を更新",
    "rotate_title": "{{name}} の書き込み認証情報を更新",
    "rotate_help": "新しい認証情報はプラットフォームが保管し、古いものは直ちに無効になります。「未テスト」に戻るので再テストしてください。",
    "in_use": "ポリシーが使用中です。先にポリシーを取り消してください",
    "confirm_delete_target": "保存先「{{name}}」を削除しますか？認証情報も無効になります。",
    "via_device": "Kinio デバイス経由",
    "quota_used": "使用 {{used}} / 割当 {{quota}}",
    "cred_hint": "書き込み {{write}}、読み取り {{read}}",
    "policies_n": "ポリシー {{n}} 件",
    "cat_ok": "正常",
    "cat_auth": "認証失敗",
    "cat_network": "ネットワーク問題",
    "cat_permission": "権限不足",
    "cat_space": "容量不足",
    "cat_config": "設定エラー",
    "cat_integrity": "内容不一致",
    "cat_unsupported": "デバイス経由のテストが必要",
    "cat_unknown": "不明なエラー",
    "step_quota": "割当",
    "step_put": "書き込み",
    "step_head": "確認",
    "step_get": "読み戻し",
    "step_delete": "削除",
    "kind_nas_s3": "NAS（S3 互換）",
    "kind_nas_smb": "NAS（SMB）",
    "kind_nas_nfs": "NAS（NFS）",
    "kind_nvr": "別の NVR",
    "kind_help_nas_s3": "Synology / QNAP 内蔵の S3 サービスまたは MinIO。同拠点・遠隔どちらでも可。NVR が S3 API で暗号文を送りチェックサムを検証します。",
    "kind_help_nas_smb": "送信元 NVR と同じ拠点の LAN のみ。必ず同拠点の Kinio デバイス経由でアクセスします。",
    "kind_help_nas_nfs": "SMB と同様、同拠点 LAN のみ（Linux / macOS NAS）。",
    "kind_help_nvr": "同じ組織の別の Kinio NVR（チーム組織の$t(leaf.cur)）。双方のオーナーの承認が必要で、異なる障害ドメインである必要があります。",
    "home": "$t(leaf.cur)",
    "kind": "種類",
    "name": "名前",
    "target_nvr": "保存先 NVR",
    "endpoint_s3": "S3 エンドポイント",
    "endpoint_smb": "SMB パス",
    "endpoint_nfs": "NFS パス",
    "bucket": "バケット",
    "prefix": "プレフィックス",
    "region": "リージョン",
    "path_style": "パス形式（多くの NAS で必要）",
    "access_path": "再生時の読み取り経路",
    "ap_public": "NAS に公開 HTTPS エンドポイントがある（VMS が直接読む）",
    "ap_via_device": "同拠点の別の Kinio デバイス経由",
    "proxy_device": "プロキシデバイス",
    "quota_gb": "割当（GB）",
    "quota_help": "NAS は空き容量を報告できないため、この割当で制限します。超えると新規バックアップを停止し、期限前のコピーは削除しません。",
    "credentials": "認証情報",
    "cred_help": "認証情報は一度だけ送信され、プラットフォームが暗号化して保管します。書き込み用は送信元 NVR のみ、読み取り用は再生のみに使われます。書き込み／読み取りで別のキーを使い、このバケット／プレフィックスに限定してください。",
    "separate_read": "読み取り用に別の認証情報",
    "read_prefix": "読み取り",
    "username": "ユーザー名",
    "password": "パスワード",
    "access_key": "アクセスキー",
    "secret_key": "シークレットキー",
    "fault_domain": "障害ドメイン",
    "fd_site": "拠点",
    "fd_facility": "サーバールーム／建物",
    "fd_power": "電源／UPS",
    "fd_network": "外部回線",
    "fd_help": "サーバールームまたは電源を共有 = 同じ障害ドメイン（火災や停電で両方失われる）。IP が違うだけでは遠隔になりません。",
    "fd_required_nvr": "NVR 間バックアップには双方の拠点・サーバールーム・電源・回線の入力と現地確認が必要です。",
    "site_confirmed": "上記の障害ドメインを現地で確認済み",
    "wz1": "送信元 NVR とチャンネル",
    "wz2": "保存先",
    "wz3": "保持日数・速度・割当",
    "wz4": "容量見積もり",
    "wz5": "障害ドメイン",
    "wz6": "承認に提出",
    "source_nvr": "送信元 NVR",
    "no_nvr": "オーナーである$t(leaf.cur)にマルチチャンネル NVR がありません。",
    "channels": "チャンネル",
    "stream_main": "メインストリーム",
    "stream_sub": "サブストリーム",
    "target": "保存先",
    "needs_target_approval": "保存先は別の$t(leaf.cur)にあります。提出後、その$t(leaf.cur)のオーナーの承認が必要です。",
    "retention_days": "保持日数",
    "rate_limit": "速度上限（Mbps）",
    "unlimited": "無制限",
    "policy_quota": "ポリシー割当（GB）",
    "auto": "= 見積もり",
    "estimate": "見積もり",
    "submit": "提出して送信元として承認",
    "est_line": "合計 {{bps}} × {{days}} 日 ≈ {{raw}}、オーバーヘッド {{oh}}% と余裕 {{margin}}% を加えて {{total}}",
    "est_assumed": "{{n}} チャンネルはビットレート未報告のため仮定値（メイン 2 Mbps、サブ 512 kbps）で見積もりました。",
    "est_note": "常時録画の上限で見積もっています。送信側の上り帯域と保存先の書き込みの両方にこの帯域が継続的に必要です。",
    "target_free": "保存先の残り割当可能量 {{free}}",
    "not_offsite": "遠隔ではない",
    "incoming": "（別の$t(leaf.cur)からのバックアップ）",
    "pst_draft": "下書き",
    "pst_pending_approval": "承認待ち",
    "pst_validating": "検証中",
    "pst_active": "稼働中",
    "pst_degraded": "遅延",
    "pst_paused": "一時停止",
    "pst_revoked": "取り消し済み",
    "cov_ok": "保護済み",
    "cov_degraded": "120 秒超の遅延",
    "cov_not_recording": "送信元は録画していない",
    "cov_partial": "送信元と通信不能（既知の位置まで）",
    "cov_unknown": "不明",
    "tst_untested": "未テスト",
    "tst_ok": "正常",
    "tst_failed": "テスト失敗",
    "tst_disabled": "無効",
    "policy_line": "{{ch}} チャンネル · {{days}} 日保持 · 割当 {{quota}} · 速度 {{rate}} · v{{v}}",
    "target_view": "相手の暗号文のみを保存：{{n}} オブジェクト、{{bytes}}（映像へのアクセスなし）",
    "cov_line": "最も遅いチャンネルは {{until}} まで保護 · 最大遅延 {{lag}} · 未送信 {{pending}} · 欠落 {{missing}} 区間",
    "col_channel": "チャンネル",
    "col_state": "状態",
    "col_protected": "保護済み",
    "col_lag": "遅延",
    "col_pending": "未送信",
    "col_missing": "欠落",
    "col_verified": "最終検証",
    "approve_source": "承認（送信元）",
    "approve_target": "承認（保存先）",
    "pause": "一時停止",
    "resume": "再開",
    "revoke": "取り消し",
    "confirm_revoke": "このポリシーを取り消しますか？新規バックアップは停止し、保存済みコピーは元の保持期間で扱われます（データ削除ではありません）。",
    "v_name": "名前は必須です",
    "v_quota": "割当は必須です",
    "v_endpoint_s3": "エンドポイントは https://ホスト[:ポート]",
    "v_bucket": "バケット名が不正です（小文字英数字・ドット・ハイフン）",
    "v_creds": "認証情報が必要です",
    "v_proxy": "同拠点のプロキシデバイスを選んでください",
    "v_endpoint_smb": "SMB パスは //ホスト/共有名",
    "v_endpoint_nfs": "NFS パスは ホスト:/export",
    "v_nvr": "保存先 NVR を選んでください",
    "v_kind": "種類が不正です",
    "err_ESCROW_UNAVAILABLE": "この環境では鍵の預託がまだ設定されていないため、NAS の認証情報を保存できません。",
    "err_OWNER_REQUIRED": "オフサイトバックアップを設定できるのは$t(leaf.cur)のオーナーのみです",
    "err_SOURCE_UNSUPPORTED": "この NVR のファームウェアはまだオフサイトバックアップに対応していません",
    "err_TARGET_UNSUPPORTED": "保存先 NVR のファームウェアはまだバックアップを受信できません",
    "err_CAPACITY_INSUFFICIENT": "容量不足：{{message}}",
    "err_SAME_FAULT_DOMAIN": "同じ障害ドメイン：{{message}}",
    "err_FAULT_DOMAIN_REQUIRED": "{{message}}",
    "err_TARGET_IN_USE": "この保存先を使用中のポリシーがあります",
    "err_POLICY_VERSION_MISMATCH": "ポリシーが変更されました。再読み込みしてから承認してください",
    "err_VERSION_CONFLICT": "他のユーザーが変更しました。再読み込みしてください",
    "err_PERSONAL_NVR_BACKUP_UNSUPPORTED": "NVR 相互バックアップはチーム組織の$t(leaf.cur)のみ対象です",
    "err_SMB_LAN_ONLY": "SMB は同拠点 LAN のみ",
    "err_RATE_LIMIT_TOO_LOW": "{{message}}",
    "restore": "復元",
    "restore_help": "検証済みのバックアップをこの$t(leaf.cur)の NVR（修理または交換したもの）に書き戻します。区間ごとに検証し、取り消し可能です。書き戻した映像は元のカメラに属し、カメラの認証情報やネットワーク設定は復元されません。",
    "restore_target": "書き戻し先 NVR",
    "restore_start": "復元を開始",
    "restore_line": "{{nvr}} へ復元：{{status}}（{{done}} / {{total}}、失敗 {{failed}}）",
    "rst_queued": "待機中",
    "rst_running": "実行中",
    "rst_done": "完了",
    "rst_failed": "失敗あり",
    "rst_canceled": "取り消し済み",
    "from": "開始",
    "to": "終了",
    "purge": "バックアップを消去",
    "confirm_purge": "このポリシーの保存先上のコピーをすべて消去しますか？ポリシーも取り消されます。NVR がオブジェクトを順に削除し、保存先がオフラインの間は「削除待ち」と表示されます。元に戻せません。",
    "rs_deleting": "削除中 {{n}}",
    "rs_deletion_pending": "削除待ち {{n}}（保存先未確認）",
    "rs_deleted": "削除済み {{n}}",
    "rs_corrupt": "破損 {{n}}",
    "rs_lost": "消失 {{n}}",
    "err_RESTORE_UNSUPPORTED": "この NVR のファームウェアはまだバックアップを書き戻せません",
    "err_NOTHING_TO_RESTORE": "この期間に検証済みのコピーはありません",
    "need_target": "先に保存先を追加してください",
    "no_policies_need_target": "バックアップポリシーはまだありません。先に上で保存先を追加してから作成してください。"
  },
  "aiCloud": {
    "title": "クラウド AI",
    "no_subscription": "クラウド AI のサブスクリプションはまだありません。",
    "go_billing": "プランと請求で購入 →",
    "consented": "同意済み",
    "consented_at": "{{at}} に同意",
    "excluded_help": "カメラごとに除外（トイレ付近や居住エリアなど）：チェックしたカメラはクラウド分析に送られません。",
    "exclude": "除外",
    "revoke": "同意を撤回",
    "revoke_help": "撤回後 60 秒以内に送信を停止します。作成済みの分析はイベントの保存期間に従います。",
    "outdated": "同意書が更新されました。もう一度読んで同意してください。",
    "consent_body": "クラウド AI は、動体イベント発生時のクラウド録画の画面（イベント時点とその後 2 秒、計 3 枚）を分析に送ります：\n・目的：人・車・動物・荷物を検出して誤検知を除外。（選択時）一文のシーン説明と服装・車両などの属性を生成し、検索に使用。\n・処理者：Kinio が運用する物体検出モデル（YOLOX）。シーン説明は Anthropic の Claude が生成。\n・保存：分析結果はイベントと一緒に保存（30 日、録画がある場合は録画の保存日数）。送信した画面は別途保存しません。\n・行わないこと：顔認識、身元の推定。分析結果は提案のみで、デバイスを制御しません。\n・クラウド録画のあるデバイスのみ分析できます。カメラごとの除外や、いつでも撤回ができます。",
    "agree": "上記を読み、同意します",
    "grant": "同意して有効化",
    "grant_help": "本人確認が必要です。",
    "need_org_admin": "同意できるのは組織管理者だけです。",
    "need_owner": "同意できるのは$t(leaf.cur)のオーナーだけです。",
    "badge_confirmed": "クラウド AI 確認：{{what}}",
    "badge_no_target": "クラウド AI：人・車なし",
    "label_person": "人",
    "label_vehicle": "車",
    "label_animal": "動物",
    "label_package": "荷物",
    "err_CONSENT_TEXT_OUTDATED": "同意書が更新されました。再読み込みしてもう一度同意してください。",
    "err_NO_CONSENT": "有効な同意がありません。",
    "err_VERSION_CONFLICT": "他の人が変更したため再読み込みしました。",
    "err_USE_ORG_CONSENT": "チーム組織の$t(leaf.cur)のクラウド AI の同意は組織の管理者が行います。",
    "err_FORBIDDEN": "この操作の権限がありません。",
    "pick_subject": "組織か$t(leaf.cur)を選ぶと、そのクラウド AI の同意と使用量を表示します（ページ上部の範囲が切り替わります）。",
    "no_subject": "現在の範囲にはクラウド AI を契約できる組織や$t(leaf.cur)がありません。",
    "consent_summary": "クラウド AI はイベント発生時のクラウド録画の画像を分析に送ります（人・車・動物・荷物を識別し誤報を減らします）。顔認識は行いません。カメラごとの除外や撤回はいつでもできます。",
    "consent_more": "詳しい説明を見る"
  },
  "dset": {
    "confirm_streams": "この設定は既存の録画と視聴に影響します（ストリームが再ネゴシエーションされます）。変更しますか？",
    "timeout": "デバイスが 25 秒以内に確認しませんでした",
    "load_offline": "デバイスがオフラインか、設定を読み込めません",
    "load_error": "設定の読み込みに失敗しました",
    "none": "このデバイスには Web で変更できる設定がありません",
    "use_app": "デバイスのアプリで操作してください",
    "owner_only": "オーナーのみ",
    "pending": "適用中",
    "applied": "適用済み",
    "adjusted": "デバイスが別の値を適用しました",
    "failed": "失敗",
    "unknown": "未報告",
    "streams_title": "既存の録画と視聴に影響します",
    "streams_body": "ストリームが再ネゴシエートされ、視聴中・録画中の映像が数秒途切れます。",
    "tech_title": "技術設定を誤るとデバイスの切断や録画停止につながります",
    "tech_body": "設置業者 / エンジニア向けの設定です。この値の影響を理解してから変更してください。",
    "tech_help": "設置業者 / エンジニア向けの設定：誤ると切断・録画停止・法規違反になることがあります。変更のたびに確認します。",
    "tech_none": "このデバイスには技術設定がありません",
    "change_body": "「{{label}}」を {{value}} に変更",
    "apply_change": "「{{label}}」を変更",
    "segment_switch": "「{{label}}」に切り替え",
    "depends_on": "先に「{{parent}}」をオンにしてください",
    "depends_value": "「{{parent}}」が {{values}} のときに調整できます",
    "advanced_n": "詳細（{{n}}）",
    "sections": "設定の区分",
    "val_free": "（空き {{v}}）",
    "val_none": "なし",
    "val_locked": "未設定",
    "val_unknown": "不明",
    "val_never": "期限なし",
    "vendor_fw": "メーカーファームウェアバージョン",
    "auto_apply": "変更はすぐデバイスに反映されます。保存ボタンを押す必要はありません。",
    "ch_summary": "{{online}} ch オンライン / 全 {{total}} ch",
    "ch_summary_label": "チャンネル",
    "val_on": "オン",
    "val_off": "オフ",
    "val_present": "あり",
    "val_absent": "なし",
    "read_only_section": "これはデバイスが報告した情報で、ここでは変更できません。",
    "ttl_dut_model": "{{label}}（{{model}}）",
    "ttl_dut_aid": "AID {{aid}}",
    "ttl_token_set_label": "UART（TTL）鍵設定済み",
    "ttl_rx_at_label": "UART（TTL）最終出力",
    "quality_res_named": "{{name}}（{{dims}}）"
  },
  "ddev": {
    "not_found": "デバイスが見つからないか、権限がありません。",
    "back": "デバイス一覧へ戻る",
    "tab_overview": "概要",
    "tab_live": "ライブと再生",
    "tab_channels": "チャンネル",
    "tab_settings": "設定",
    "tab_recording": "録画とストレージ",
    "tab_events": "イベント",
    "tab_health": "健全性とファームウェア",
    "tab_links": "連動",
    "status": "状態",
    "media_status": "メディア状態",
    "capabilities": "機能",
    "storage": "ストレージ",
    "no_events": "過去 24 時間にイベントはありません",
    "links_hint": "このセンサーをカメラに連動させると、イベントカードとポップアップに同時刻のカメラ映像が表示されます。",
    "tab_site": "現場のデバイス",
    "tab_ai": "AI",
    "tab_firmware": "ファームウェア",
    "tab_location": "場所",
    "tab_audit": "監査",
    "ai_unavailable": "AI 処理の情報を取得できません",
    "ai_none": "このカメラはまだ AI 分析に割り当てられていません",
    "ai_open": "AI 分析ページへ",
    "fw_unavailable": "ファームウェア状態を取得できません（またはプラットフォーム経由で更新しない機種）",
    "fw_available": "更新あり",
    "fw_latest": "最新",
    "fw_auto": "自動更新",
    "fw_update_now": "今すぐ更新",
    "fw_confirm": "ファームウェア {{v}} に今すぐ更新しますか？更新中にデバイスが再起動します。",
    "fw_started": "更新を送信しました。ダウンロード後に再起動します",
    "fw_via_app": "この機種はアプリ経由で更新します。アプリで完了してください",
    "site": "拠点",
    "geo": "地図座標",
    "floorplan": "平面図",
    "open_map": "地図へ",
    "tab_analytics": "スマート分析",
    "tab_technical": "技術",
    "tab_nodes": "ノード",
    "tab_advanced": "詳細",
    "maintenance": "メンテナンス",
    "open_playback": "再生ページで開く",
    "last_seen": "最終接続",
    "fw_short": "ファームウェア {{v}}",
    "fw_has_update": "（新しい版あり）",
    "fw_is_latest": "（最新）",
    "fw_all": "すべてのデバイスのファームウェア →",
    "path": "設置場所",
    "reboot_hint": "デバイスは 1～2 分ほどオフラインになり、その間は録画しません。",
    "support_title": "サポートに送る情報",
    "support_hint": "サポートから求められたときにコピーしてください。これらのコードは通常の画面には表示されません。",
    "support_copy": "コピー",
    "support_copied": "コピーしました",
    "ai_provider_unnamed": "名前のない AI 処理デバイス",
    "maintenance_sub": "再起動、登録解除",
    "rec_settings": "録画とストレージの設定",
    "ch_summary_one": "{{count}} ch",
    "ch_summary_other": "{{count}} ch",
    "ch_summary_off_one": "{{count}} ch オフライン",
    "ch_summary_off_other": "{{count}} ch オフライン",
    "ch_view": "チャンネルを見る",
    "adv_diag": "診断",
    "adv_diag_sub": "シリアルコンソール（設置・開発用）",
    "adv_diag_dut": "接続先：{{name}}",
    "ev_recording": "録画クリップ",
    "ev_open_in_events": "イベントページで開く",
    "ev_only_recording": "この 24 時間は録画クリップのみでイベントはありません。「録画クリップ」をオンにすると表示されます。",
    "sd_no_capacity": "SD カード · 容量不明（デバイスから報告がありません）",
    "sd_no_capacity_tip": "SD カードは挿入されていますが、デバイスが容量を報告していません。録画状態は「録画とストレージ」で確認できます。",
    "no_snapshot": "スナップショットはまだありません",
    "watch_live": "ライブを見る",
    "rec_settings_fold_one": "録画とストレージの設定（{{count}} 項目）",
    "rec_settings_fold_other": "録画とストレージの設定（{{count}} 項目）",
    "ev_system_hint": "「システム」はデバイス自身の状態変化（オンライン / オフライン、再起動、配信や録画の開始 / 終了）で、検知ではありません。通常は対応不要です。これらの状態記録はここにだけ表示され、イベントページの検索や集計には含まれません（そのためイベントページの「システム」はここより少ないことがあります）。",
    "ev_system_generic": "デバイスの状態変化",
    "recent_events": "最近のイベント",
    "recent_none": "過去 7 日間のイベントはありません。",
    "recent_all": "このデバイスのすべてのイベント ▸",
    "ev_lasted": "（継続 {{dur}}）",
    "ev_window": "過去 24 時間",
    "change_wifi": "Wi-Fi を変更",
    "change_wifi_app": "スマホアプリで変更してください。デバイスのそばで、Bluetooth またはデバイスのアクセスポイント経由で新しい Wi-Fi を渡します。"
  },
  "health": {
    "title": "健全性",
    "level_ok": "正常",
    "level_warn": "注意",
    "level_alert": "異常",
    "level_unknown": "未報告",
    "free": "空き",
    "retention_days_one": "約 {{count}} 日保存可能",
    "retention_days_other": "約 {{count}} 日保存可能",
    "reason_smart": "SMART 異常",
    "reason_disk_error": "ディスクエラー",
    "reason_disk_full": "ディスク満杯",
    "reason_no_disk": "ディスクが検出されません",
    "reason_almost_full": "空き 5% 未満（上書きオフ）",
    "rate": "現在の録画ビットレート {{kbps}} kbps",
    "no_rate": "デバイスが録画ビットレートを報告しないため、保存日数を推定できません",
    "disk_model": "型番 / シリアル",
    "disk_state": "状態",
    "capacity": "空き / 総容量",
    "no_disks": "デバイスは個別ディスクの情報を報告していません",
    "online_rate": "オンライン率",
    "recorders": "レコーダー",
    "recorders_bad": "異常 / 合計",
    "min_retention": "最短の保存見込み",
    "days_one": "{{count}} 日",
    "days_other": "{{count}} 日",
    "offline_list": "オフラインのデバイス（{{n}}）",
    "smart_ok": "正常",
    "smart_warn": "注意",
    "smart_fail": "異常",
    "smart_unknown": "不明",
    "smart_temp": "{{c}} °C",
    "smart_poh": "通電 {{h}} 時間",
    "smart_sectors": "代替処理 {{realloc}}・保留中 {{pending}}・修正不能 {{uncorr}} セクタ",
    "smart_test_run": "セルフテスト",
    "smart_test_sent": "セルフテストを開始しました（約 2 分）",
    "smart_test_running": "セルフテスト実行中",
    "smart_test_pass": "前回のセルフテスト：合格",
    "smart_test_fail": "前回のセルフテスト：不合格",
    "smart_test_aborted": "前回のセルフテスト：中止",
    "smart_test_weekly": "毎週自動",
    "reason_smart_warn": "SMART 要注意",
    "overwrite": "録画上書き",
    "overwrite_auto": "自動上書き",
    "overwrite_off": "上書きしない（満杯で録画停止）",
    "overwrite_days_one": "{{count}} 日間保持",
    "overwrite_days_other": "{{count}} 日間保持",
    "rec_space": "録画領域",
    "disk_space": "ディスク容量",
    "kind_hdd": "HDD",
    "kind_ssd": "SSD",
    "kind_sd": "SD カード",
    "kind_usb": "USB",
    "kind_flash": "内蔵フラッシュ",
    "kind_disk": "ディスク",
    "disks_title": "物理ディスク",
    "volume_title": "録画ボリューム",
    "legacy_note": "このデバイスは録画ボリュームを報告しています（旧形式）。物理ディスクごとの情報とストレージプールはありません",
    "disk_kind": "種類",
    "disk_record": "録画ディスク",
    "record_yes": "はい",
    "record_no": "いいえ",
    "physical_capacity": "ディスク容量",
    "pools_title": "ストレージプール",
    "no_pools": "デバイスはストレージプールを報告していません",
    "pool_role": "用途",
    "role_record": "録画",
    "role_system": "システム",
    "role_index": "インデックス",
    "pool_disk": "ディスク",
    "pool_part": "パーティション",
    "pool_capacity": "容量",
    "pool_used": "使用量",
    "pool_in_use": "使用中",
    "pool_idle": "未使用",
    "retention_basis": "保存日数は録画領域 {{total}} から推定しています（物理ディスク容量ではありません）",
    "cert": "証明書の期限",
    "cert_note_one": "期限切れまたは {{count}} 日以内に期限",
    "cert_note_other": "期限切れまたは {{count}} 日以内に期限",
    "cert_expired": "証明書の期限切れ（{{date}}）",
    "cert_soon": "証明書は {{date}} に期限",
    "firmware": "最新ファームウェアの適用状況",
    "firmware_note": "最新 / 全体",
    "fw_update": "新しいファームウェアあり（現在 {{v}}）",
    "seats": "クラウド録画シート",
    "seats_note": "割り当て済み / 有効",
    "ai": "AI 枠（今月）",
    "backup": "バックアップの保護状況",
    "backup_note": "正常 / 有効なポリシー",
    "backup_degraded": "{{n}} 件のポリシーが遅延または停止",
    "rec_gaps": "録画の欠落（24 時間）",
    "rec_gaps_note": "欠落あり / 常時録画のカメラ",
    "rec_gap_item": "過去 24 時間に録画の欠落あり",
    "attention": "要確認",
    "not_enabled": "未設定",
    "setup": "設定",
    "unknown": "取得できません",
    "unknown_n_one": "取得できません（{{count}} 台が未報告）",
    "unknown_n_other": "取得できません（{{count}} 台が未報告）",
    "dstate_normal": "正常",
    "dstate_ok": "正常",
    "dstate_degraded": "劣化",
    "dstate_error": "エラー",
    "dstate_failed": "故障",
    "dstate_missing": "見つかりません",
    "dstate_readonly": "読み取り専用",
    "dstate_full": "満杯",
    "dstate_unformatted": "未フォーマット",
    "seats_home_plan_one": "ほかに {{count}} 台が$t(leaf.cur)プランでクラウド録画",
    "seats_home_plan_other": "ほかに {{count}} 台が$t(leaf.cur)プランでクラウド録画",
    "watch_playback": "再生を開く",
    "rec_gaps_off": "常時クラウド録画のカメラだけを確認します（現在なし）",
    "space_unknown": "容量を取得できません",
    "usb_stick": "USB メモリ",
    "cap_used_total_free": "使用 {{used}} / 全 {{total}}（空き {{free}}）",
    "cap_total": "全 {{total}}",
    "reason_other": "ストレージに異常があります",
    "reason_sd_abnormal": "メモリーカードの異常",
    "reason_sd_no_space": "メモリーカードがいっぱいで録画が停止しています",
    "reason_sd_needs_format": "メモリーカードのフォーマットが必要です",
    "days_lt1": "1 日未満（約 {{h}} 時間）",
    "retention_lt1": "保存可能は 1 日未満（約 {{h}} 時間）",
    "sd_looping": "{{total}} · ループ録画中",
    "sd_looping_note": "カードがいっぱいになると、いちばん古い録画から自動で上書きします。録画は止まりません。",
    "rec_gaps_off2": "常時クラウド録画またはローカル録画のカメラはありません",
    "rec_gaps_note2": "過去 24 時間 · クラウド {{cloud}} 台、ローカル {{local}} ch",
    "gap_reason_source_unreachable": "映像を受信できない",
    "gap_reason_storage_full": "ディスク容量不足",
    "gap_reason_storage_error": "録画ディスクの異常",
    "gap_reason_recorder_restart": "レコーダーの再起動",
    "gap_reason_unknown": "原因不明",
    "rec_gaps_unreported_one": "ほかに未報告のローカル録画 {{count}} ch",
    "rec_gaps_unreported_other": "ほかに未報告のローカル録画 {{count}} ch"
  },
  "rpol": {
    "enable_cloud": "クラウド録画を有効にする",
    "enable_sd": "メモリーカード録画を有効にする",
    "confirm_cloud": "クラウド録画を有効にすると、メモリーカード録画は無効になります。以降の録画はクラウドにのみアップロードされます（メモリーカードがある場合、オフライン時の一時保存には引き続き使用されます）。",
    "confirm_sd": "メモリーカード録画を有効にすると、クラウド録画は無効になります。以降の録画はメモリーカードにのみ保存されます。",
    "confirm_sd_seat": "このカメラにはクラウド録画枠が割り当てられています。無効にすると録画枠は未使用になりますが、課金は継続されます。プランページで別のカメラに割り当て直せます。",
    "no_recording": "現在録画していません",
    "device_mode": "デバイス",
    "mode_continuous": "常時録画",
    "mode_event": "動きがあったときのみ録画",
    "mode_unknown": "未報告",
    "cloud": "クラウド録画",
    "cloud_on": "有効（{{mode}}）",
    "cloud_off": "無効",
    "retention": "クラウド保存",
    "days_one": "{{count}} 日",
    "days_other": "{{count}} 日",
    "follows_plan": "プラン / シートで決定",
    "owner_only": "録画ポリシーを変更できるのは$t(leaf.cur)のオーナーだけです。",
    "mode_scheduled": "スケジュール",
    "mode_off": "録画しない",
    "cloud_policy_note": "クラウド常時録画中のため、本機も終日録画します。クラウド録画をオフにすると、このスケジュールに戻ります。",
    "cloud_mode": "クラウドに録画するとき",
    "continuous_coming_soon": "常時録画はまもなく提供開始",
    "err_FEATURE_DISABLED": "常時録画はまもなく提供開始です。現在はイベント録画のみ利用できます。",
    "capplied_applied": "デバイスに適用済み",
    "capplied_not_applied": "デバイスはまだ未適用",
    "capplied_unknown": "デバイスの報告待ち",
    "capplied_days_one": "（デバイス側の保存 {{count}} 日）",
    "capplied_days_other": "（デバイス側の保存 {{count}} 日）",
    "src_seat": "「{{name}}」のクラウド録画シートで提供",
    "src_seat_plain": "クラウド録画シートで提供",
    "src_home_plan": "$t(leaf.cur)のプラン「{{plan}}」で提供",
    "src_home_plan_plain": "$t(leaf.cur)のプランで提供",
    "src_grant": "契約「{{plan}}」で提供",
    "src_grant_plain": "契約で提供",
    "src_until": "、{{date}} まで",
    "src_exempt": "プラン未適用（開発環境の免除）",
    "src_none": "クラウド録画シートが割り当てられていません",
    "assign_seat": "シートを割り当てる",
    "cloud_on_exempt": "録画中（{{mode}}）· プラン未適用（開発環境の免除）",
    "cloud_on_plain": "有効",
    "cloud_unsupported": "このカメラはクラウド録画に対応していません（機種の制限）",
    "reason_not_supported": "このカメラはクラウド録画に対応していません（機種の制限）",
    "reason_plan_no_cloud": "この$t(leaf.cur)のプランにはクラウド録画が含まれていません",
    "reason_home_disabled": "この$t(leaf.cur)のクラウド録画は一時停止中です（サービス提供者にお問い合わせください）",
    "reason_disabled": "このカメラのクラウド録画はオフです",
    "reason_mode_not_in_plan": "選んだ録画方式はプランに含まれないため、イベント録画になります",
    "reason_camera_limit": "プランのカメラ台数の上限に達しています",
    "reason_continuous_paused": "常時録画はまもなく提供開始です。現在はイベント録画です",
    "reason_other": "クラウド録画は現在有効ではありません",
    "col_where": "録画先",
    "col_when": "録画するとき",
    "where_sd": "メモリーカード",
    "where_recorder": "レコーダー",
    "cloud_switch": "オン",
    "status_label": "状態：",
    "platform_state": "プラットフォーム：{{state}}"
  },
  "evd": {
    "watch_recording": "録画を見る",
    "sd_offline": "この録画はカメラのメモリーカードに保存されています。カメラが接続されると視聴できます",
    "no_recording": "イベント発生時には録画されていませんでした",
    "open": "詳細",
    "back": "イベントへ戻る",
    "time": "時刻",
    "class": "分類",
    "device": "デバイス",
    "ai": "AI 分析",
    "phase_started": "開始",
    "phase_ended": "終了",
    "phase_instant": "単発",
    "fields": "元のフィールド",
    "clip": "前後のクリップ",
    "no_cloud_clip": "この時間のクラウドクリップはありません。再生ページでローカル録画を確認できます。",
    "open_playback": "再生ページで開く",
    "related": "連動カメラ（同時刻）",
    "cycle": "このイベントの開始と終了",
    "not_found": "このイベントは見つかりません。保存期間を過ぎたか、削除された可能性があります。",
    "back_list": "イベント一覧へ戻る",
    "looking": "このイベントを読み込んでいます…",
    "cycle_dur": "今回の{{name}}は {{dur}} 続きました",
    "cycle_open": "今回の{{name}}はまだ終わっていません（または終了の記録が未着）",
    "cycle_no_end": "未終了",
    "cycle_this": "この記録",
    "dur_s": "{{s}} 秒",
    "dur_ms": "{{m}} 分 {{s}} 秒",
    "dur_hm": "{{h}} 時間 {{m}} 分",
    "clip_suspect": "このクラウド録画は不完全な可能性があります（長さがイベントと合いません）。画面が緑色になったり止まったりすることがあります。イベント前後 30 秒だけ再生します。再生ページでほかのソースも試せます。",
    "clip_suspect_local": "{{src}}で見る",
    "cycle_no_end_record": "この{{name}}の終了記録を受信していません（開始から 10 分以上）。継続時間は不明です",
    "cycle_end_only": "これは{{name}}の終了記録です。開始の記録は前後 15 分以内にありません",
    "cycle_open_start": "開始の記録を見る ▸",
    "clip_checking": "この時間のクラウドクリップを確認中…",
    "clip_unreadable": "このクリップを読み込めません。",
    "dur_lt1": "1 秒未満"
  },
  "unbind": {
    "title": "登録解除",
    "explain": "このデバイスを$t(leaf.cur)から外します。",
    "reset": "デバイスにリセット指令が送られ、再ペアリング可能な状態に戻ります（オフラインの場合は次回接続時）。",
    "history": "過去の録画とイベントは元の$t(leaf.cur)に残り、デバイスには付いていきません。",
    "children_one": "配下の {{count}} 個のチャンネル / 子デバイスも一緒に外されます。",
    "children_other": "配下の {{count}} 個のチャンネル / 子デバイスも一緒に外されます。",
    "button": "登録解除",
    "confirm": "「{{name}}」の登録を解除しますか？確認のためデバイス ID の末尾 4 文字「{{code}}」を入力してください。",
    "type_code": "デバイス ID の末尾 4 文字"
  },
  "pair": {
    "open": "デバイス追加",
    "title": "Kinio デバイスを追加",
    "no_home": "デバイスを追加できる$t(leaf.cur)がありません（オーナーか管理者が必要）。",
    "method": "ペアリング方法",
    "method_lan": "有線（ペアリングコードを入力）：NVR、Kinio Station、AI box の本体画面でコードを入力",
    "method_qr": "QR を読み取る：このページの Wi-Fi とペアリングコードをカメラのレンズで読み取る",
    "method_app": "Bluetooth またはデバイスのアクセスポイント（スマホアプリ）：アプリでこの QR を読み取り、次にデバイスのラベルを読み取る",
    "aid_hint": "デバイス底面のラベル、または NVR 本体画面の「デバイス情報」にあります。形式 CNV-XXXXXXXXXXXXXXXX-X",
    "err_BAD_DEVICE_REF": "デバイス ID の形式が正しくありません",
    "err_MODEL_NOT_AVAILABLE_FOR_BRAND": "このブランドでは Kinio Station / Kinio Node はご利用いただけません",
    "start": "ペアリングコードを発行",
    "bound": "{{aid}} を$t(leaf.cur)に追加しました。",
    "open_device": "デバイスを開く",
    "status_failed": "ペアリング失敗",
    "status_canceled": "キャンセル済み",
    "status_expired": "ペアリングコードの期限切れ",
    "status_pending": "デバイスがコードを使うのを待っています",
    "status_connected": "デバイスが接続しました。登録を完了しています",
    "again": "もう一度ペアリング",
    "enter_on_device": "デバイス本体の「クラウドペアリング」画面に次のコードを入力してください：",
    "code": "ペアリングコード",
    "url": "登録用 URL",
    "expires_in": "{{m}}:{{s}} で期限切れ",
    "cancel": "ペアリングを取り消す",
    "method_app_unavailable": "（このブランドにはアプリ用ポータルがないため、アプリ用リンクを作れません）",
    "wifi_ssid": "Wi-Fi 名",
    "wifi_psk": "Wi-Fi パスワード（オープンネットワークは空欄）",
    "wifi_note": "Wi-Fi パスワードはこのページの QR にのみ含まれ、クラウドへの送信や保存はされません。",
    "err_SSID_REQUIRED": "Wi-Fi 名を入力してください",
    "err_SSID_TOO_LONG": "Wi-Fi 名が 32 バイトを超えています",
    "err_PSK_LENGTH": "Wi-Fi パスワードは 8〜63 文字（または 16 進 64 桁）です",
    "err_BAD_SESSION": "ペアリング情報が不完全です。やり直してください",
    "show_qr": "QR を表示",
    "show_qr_again": "QR を再表示",
    "hide_qr": "QR を隠す",
    "qr_hidden": "QR を非表示にしました（表示から 5 分で自動的に隠れます）。",
    "qr_auto_hide": "{{m}}:{{s}} 後に自動で隠れます",
    "scan_with_camera": "カメラをペアリング状態にし、QR をレンズから 20〜40 cm に向けてください。通知音の後、接続を待ちます。",
    "scan_with_app": "スマホアプリの「デバイスを追加」でこの QR を読み取り、指示に従ってデバイスのラベルを読み取ってください。アプリの利用者はこの$t(leaf.cur)のメンバーでなくてもかまいません。",
    "qr_alt_kwf": "カメラ用の Wi-Fi とペアリングコードの QR",
    "qr_alt_app": "アプリ用ペアリングリンクの QR",
    "kind_camera": "カメラ",
    "kind_doorbell": "ドアベル",
    "kind_nvr": "NVR",
    "kind_station": "Station",
    "kind_sensor": "センサー",
    "kind_light": "ライト",
    "kind_lock": "スマートロック",
    "kind_plug": "プラグ",
    "kind_frame": "フォトフレーム",
    "kind_other": "デバイス",
    "bound_name_title": "$t(leaf.cur)に追加しました。このデバイスに名前を付けてください",
    "name_label": "デバイス名",
    "name_hint": "通知、アプリ、VMS にこの名前が表示されます（1〜32 文字）。スキップすると入力済みの名前を使います。",
    "err_INVALID_NAME": "名前は 1〜32 文字で、制御文字は使えません",
    "name_failed": "名前を保存できませんでした。もう一度お試しください",
    "name_forbidden": "このデバイスの名前は変更できません（$t(leaf.cur)のオーナーまたは管理者のみ）。後で変更を依頼してください。",
    "name_skip": "スキップ",
    "name_save": "名前を保存",
    "aid_label": "デバイス番号",
    "aid_demo_title": "ラベルの「デバイス番号」"
  },
  "layouts": {
    "pick": "レイアウト…",
    "save": "レイアウトを保存",
    "save_as": "名前を付けて保存",
    "delete": "レイアウトを削除",
    "delete_confirm": "レイアウト「{{name}}」を削除しますか？",
    "name": "名前",
    "scope": "公開範囲",
    "scope_user": "自分のみ",
    "scope_org": "組織で共有：{{org}}",
    "denied_dropped": "権限のないセルは新しいレイアウトに保存されません。",
    "no_permission": "権限なし",
    "err_CELL_FORBIDDEN": "視聴権限のないカメラが含まれています",
    "err_VERSION_CONFLICT": "他の人がレイアウトを変更しました。再読み込みしてください",
    "none": "保存したレイアウトはまだありません",
    "manage": "レイアウトの管理…"
  },
  "bm": {
    "add": "ブックマーク",
    "need_time": "先に再生するか時刻を選んでください",
    "title": "タイトル",
    "note": "メモ",
    "length": "長さ",
    "len_s": "{{n}} 秒",
    "len_point": "時点",
    "visibility": "公開範囲",
    "vis_private": "自分のみ",
    "vis_home": "$t(leaf.cur)のメンバー",
    "list": "ブックマーク"
  },
  "subg": {
    "panel_hint": "{{n}} 台登録済み（上限 {{max}}）。QR ラベル付きの子機は QR を読み取らないと追加できません。",
    "region": "地域 {{r}}",
    "add": "子機を追加",
    "need_admin": "子機の追加には$t(leaf.cur)のオーナーまたは管理者が必要です。",
    "none": "子機はまだありません。",
    "col_slot": "スロット",
    "col_mode": "追加方法",
    "mode_qr": "QR 許可リスト",
    "mode_permit": "期間限定の受付（未認証）",
    "title": "子機を追加",
    "method": "追加方法",
    "method_scan": "カメラで子機の QR を読み取る",
    "method_manual": "手入力（QR の内容、または EUI とインストールコード）",
    "method_permit": "QR のない子機：期間限定で受け付ける",
    "qr_text": "QR の内容",
    "or_fields": "またはラベルの EUI とインストールコードを入力：",
    "is_code": "インストールコード（IS）",
    "is_hint": "26 文字の英数字（A–Z、2–7）。ラベルの QR の横に印字されています。",
    "smartstart": "SmartStart：子機の電源を入れると自動で追加（受付 24 時間）",
    "permit_explain": "ゲートウェイが 120 秒間受け付けます。その間に子機のペアリングボタンを押してください。QR のない子機専用です。QR 付きの子機は QR を読み取ってください。",
    "permit_warn": "この方法にはインストールコードの認証がなく、盗聴は防げますがなりすましは防げません。",
    "start": "追加を開始",
    "permit_start": "120 秒受け付ける",
    "wait_qr": "ゲートウェイが {{eui}} を許可リストに追加しました。子機のボタンを 5 秒長押ししてください（または電池を入れてください）。",
    "wait_qr_smart": "ゲートウェイが {{eui}} を許可リストに追加しました（SmartStart）。子機の電源が入ると自動で追加されます。",
    "wait_permit": "ゲートウェイが受付中です。QR のない子機のペアリングボタンを押してください。",
    "left": "残り {{m}}:{{s}}",
    "closed_found": "受付が終了しました。今回 {{n}} 台追加されました。",
    "closed_none": "受付が終了しました。子機は追加されませんでした。ゲートウェイの近くでボタンを 5 秒長押しして、もう一度お試しください。",
    "stop": "受付を停止",
    "again": "もう 1 台追加",
    "joined": "新しい子機：CH{{slot}}",
    "name_for": "CH{{slot}} の名前",
    "location": "場所（拠点）",
    "location_keep": "（指定しない）",
    "location_personal": "この$t(leaf.cur)の組織には拠点が 1 つしかないため、位置の指定は不要です。地図ページで配置できます。",
    "to_map": "地図へ",
    "saved": "「{{name}}」を保存しました",
    "scan_unsupported": "このブラウザはカメラでの読み取りに対応していません（Chrome / Edge が必要）。手入力してください。",
    "scan_denied": "カメラを使えません（権限がないかカメラがありません）。手入力してください。",
    "scan_hint": "子機の QR をカメラに向けてください。",
    "scan_start": "カメラを起動",
    "err_other": "追加できませんでした（{{code}}）",
    "err_qr_not_subg": "Kinio 子機の QR ではありません（KSG:1 で始まる必要があります）。",
    "err_qr_version": "この QR のバージョンには対応していません。",
    "err_qr_format": "QR の内容の形式が正しくありません。",
    "err_qr_eui": "EUI は 16 桁の 16 進数です。",
    "err_qr_is": "インストールコードが正しくありません（26 文字、A–Z と 2–7）。",
    "err_INVALID_QR": "QR の内容またはインストールコードが正しくありません。",
    "err_QR_DEVICE_NOT_ALLOWED": "QR 付きの子機は期間限定の受付では追加できません。QR を読み取ってください。",
    "err_CAPABILITY_NOT_SUPPORTED": "このデバイスには子機を追加できません。",
    "err_GATEWAY_OFFLINE": "ゲートウェイがオフラインです。",
    "err_GATEWAY_TIMEOUT": "ゲートウェイから応答がありません。",
    "err_GATEWAY_ERROR": "ゲートウェイが拒否しました（許可リストが満杯か処理中）。しばらくしてからもう一度お試しください。",
    "err_FORBIDDEN": "権限がありません。",
    "err_INVALID_NAME": "名前は 1〜64 文字です。",
    "remove": "削除",
    "removing": "削除中（ゲートウェイの確認待ち）",
    "remove_confirm": "「{{name}}」を削除しますか？子機の次回の通信でペアリングが解除されます。再度追加するには QR を読み取り直してください。"
  },
  "inbox": {
    "title": "通知",
    "title_n": "通知（未読 {{n}}）",
    "mark_all": "すべて既読にする",
    "mark_read": "既読にする",
    "empty": "通知はありません",
    "failed": "通知の受信箱を一時的に読み込めません",
    "mfa_alarm_title": "{{from}}からアラームがあります",
    "mfa_alarm_body": "2 段階認証をオンにして再ログインすると内容を確認できます。",
    "mfa_alarm_back": "設定しました。このアラームに戻る",
    "mfa_alarm_someone": "委任元",
    "alarm_title": "アラーム · {{name}}",
    "untitled": "通知",
    "view": "表示",
    "open": "開く",
    "dismiss_tip": "閉じる（未読のまま）",
    "more_n_one": "ほかに {{count}} 件の通知",
    "more_n_other": "ほかに {{count}} 件の通知",
    "bell_tip": "未読の通知 {{n}} 件（メニュー「イベントとアラーム」の未対応アラーム数とは別）",
    "times_n": "× {{n}} 回（最初 {{since}}）",
    "times_only": "× {{n}} 回",
    "empty_alarms": "新しい通知はありません。未対応のアラームが {{count}} 件あります。",
    "go_alarms": "対応する"
  },
  "devpolicy": {
    "title": "MyCam デバイスと AI のポリシー",
    "hint": "この組織のすべての拠点のスマホカメラとパソコンに適用。各項目は変更すると保存されます（再認証が必要）。",
    "k_soft_device_require_attestation": "完全性チェックに合格（verified）したデバイスのみ受け入れる",
    "k_soft_device_lock_settings": "設定をロック（ロックされた設定はスマホで変更不可）",
    "k_soft_device_allow_audio_record": "録音を許可",
    "k_ai_byo_cloud_allowed": "持ち込みクラウド AI を許可",
    "k_soft_device_allow_personal_account": "個人アカウントによるデバイス追加を許可",
    "by_platform": "有効化時にプラットフォームが確認",
    "by_app": "MyCam アプリが適用",
    "by_pending": "メンバーが個人のスマートフォンをこの組織の MyCam デバイスとして使えるかは未決定のため、変更できません"
  },
  "dhealth": {
    "cert": "証明書の期限",
    "cert_expired": "期限切れ",
    "cert_soon": "30 日以内に期限",
    "wifi": "Wi-Fi 信号",
    "temperature": "本体温度",
    "mac": "MAC アドレス",
    "netifs": "ネットワークインターフェース",
    "if_name": "インターフェース",
    "if_kind": "種類",
    "if_kind_wifi": "Wi-Fi",
    "if_kind_wired": "有線",
    "if_kind_cellular": "モバイル通信",
    "if_up": "接続状態",
    "if_up_yes": "接続中",
    "if_up_no": "未接続"
  },
  "tour": {
    "open": "シーケンス",
    "title": "シーケンス表示の設定",
    "interval": "1 ページの表示時間",
    "seconds": "{{n}} 秒",
    "mode": "シーケンスの対象",
    "mode_cameras": "カメラ一覧",
    "mode_layouts": "レイアウト",
    "cameras_hint": "現在の {{size}} 分割でページ分け（{{pages}} ページ）",
    "no_layouts": "保存済みのレイアウトがありません",
    "start": "シーケンス開始",
    "running": "シーケンス表示中：{{i}} / {{n}} ページ",
    "next_in": "{{s}} 秒後に切替",
    "pause": "一時停止",
    "resume": "再開",
    "stop": "停止"
  },
  "nset": {
    "global_title": "自分の通知",
    "home_title": "$t(leaf.cur)の通知",
    "home": "$t(leaf.cur)",
    "no_home": "通知を設定できる$t(leaf.cur)がありません",
    "unavailable": "通知設定を取得できません",
    "quiet": "おやすみ時間",
    "quiet_start": "開始",
    "quiet_end": "終了",
    "quiet_clear": "おやすみ時間を解除",
    "quiet_hint": "タイムゾーン {{tz}}。おやすみ中は受信箱にのみ届き、アラームは通常どおり送信します",
    "email_alerts": "イベント通知をメールでも送る",
    "hide_details": "ロック画面で詳細を隠す",
    "thumbnails": "サムネイルを付ける",
    "category": "カテゴリ",
    "ch_inbox": "受信箱",
    "ch_push": "アプリ通知",
    "ch_email": "メール",
    "forced": "常にオン",
    "per_device": "カメラごとの検知通知",
    "follow_home": "$t(leaf.cur)の設定に従う",
    "cat": {
      "security_alarm": "アラーム（警戒中）",
      "device_detection": "検知（人・車・動き…）",
      "device_doorbell": "ドアベル",
      "device_call": "デバイス呼び出し",
      "device_status": "デバイス状態（オフライン・ストレージ・録画中断・バックアップ）",
      "device_ota": "ファームウェア更新",
      "security_mode": "警戒モード変更",
      "home_access": "$t(leaf.cur)のメンバーとデバイス",
      "account_security": "アカウントのセキュリティ",
      "billing_subscription": "サブスクリプションと支払い",
      "support_reply": "サポートの返信",
      "care_service": "ケアのお知らせ",
      "andrew_insight": "AI アシスタントのお知らせと提案",
      "automation_notify": "自動化ルール",
      "hw_review": "ハードウェア審査",
      "org_notice": "組織からのお知らせ",
      "account_privacy": "プライバシーとデータ請求",
      "sleep_report_ready": "睡眠レポート"
    },
    "ai_confirmed_only": "クラウド AI が確認した検知だけ通知（そのカメラでクラウド AI を使う場合。60 秒結果がなければ通常どおり送信）",
    "cat_other": "その他の通知",
    "part_local": "ポップアップ（このパソコン）",
    "part_receive": "受け取る通知",
    "part_subs": "通知を受け取る拠点とグループ",
    "float_intro": "画面右下のフローティング通知：アラームは常にアラームカードで表示します（まずスナップショット、その場で対応、「ライブを見る」で映像を開く）。その他の通知は下の設定に従います。同じ通知は 1 回だけ表示し、20 秒操作がなければ細いバーに折りたたみます。"
  },
  "rules": {
    "no_home": "ルールを設定できる$t(leaf.cur)がありません",
    "home": "$t(leaf.cur)",
    "unavailable": "ルールを取得できません",
    "from_template": "テンプレートから作成",
    "new_json": "詳細：JSON で編集",
    "enabled": "有効",
    "kind_automation": "自動化",
    "kind_scene": "シーン",
    "placement_cloud": "クラウドで実行",
    "placement_local": "ローカルで実行",
    "pending_sync": "デバイス未同期",
    "never": "未実行",
    "result_ok": "前回成功",
    "result_failed": "前回失敗",
    "result_skipped": "前回スキップ",
    "fires": "計 {{n}} 回",
    "run": "実行",
    "runs": "実行履歴",
    "edit": "編集",
    "delete": "削除",
    "delete_confirm": "ルール「{{name}}」を削除しますか？",
    "last_error": "{{n}} 番目のアクションが失敗：{{reason}}",
    "runs_local": "ローカル実行のルールの履歴はデバイス上にあり、ここには前回の結果のみ表示します",
    "run_time": "時刻",
    "run_trigger": "トリガー",
    "run_status": "結果",
    "run_error": "失敗の理由",
    "trigger_manual": "手動",
    "run_error_at": "{{n}} 番目のアクション：{{reason}}",
    "runs_empty": "7 日以内の実行はありません",
    "status_pending": "待機中",
    "status_running": "実行中",
    "status_done": "完了",
    "status_failed": "失敗",
    "status_canceled": "キャンセル",
    "reason_device_offline": "デバイスがオフライン",
    "reason_running": "前回の実行がまだ終わっていません",
    "reason_forbidden": "権限がありません",
    "template": "テンプレート",
    "tpl_door_record_notify": "ドア開 → 録画 + 通知",
    "tpl_door_record_notify_text": "ドアが開きました",
    "tpl_door_record_notify_hint": "ドア・窓センサーが開いたら連動カメラが録画し通知（ポップアップはデバイスの「連動」で設定）",
    "tpl_armed_pir_siren": "警戒中 PIR → サイレン + 通知",
    "tpl_armed_pir_siren_text": "警戒中に人を検知",
    "tpl_armed_pir_siren_hint": "外出 / 夜間警戒中に PIR が反応したらサイレンを鳴らして通知",
    "tpl_ai_person_notify": "AI が人を検知 → 通知",
    "tpl_ai_person_notify_text": "人を検知しました",
    "tpl_ai_person_notify_hint": "カメラの AI が人を検知したら通知",
    "role_sensor": "センサー",
    "role_camera": "カメラ",
    "role_siren": "サイレン",
    "optional": "（任意）",
    "pick": "選択",
    "none_capable": "この$t(leaf.cur)に対応デバイスがありません",
    "name": "名前",
    "notify_text": "通知の内容",
    "notify_off": "この環境ではルール通知が提供されていないため、テンプレートはデバイスの動作のみ作成します",
    "create": "作成",
    "edit_title": "「{{name}}」を編集",
    "json_hint": "ルールはトリガー（triggers）、条件（conditions）、アクション（actions）の 3 つで構成されます。保存前に形式を確認します。デバイスとクラウドのどちらで実行するかはシステムが決めます。",
    "json": "ルール JSON",
    "bad_json": "JSON の形式が正しくありません",
    "valid": "検証 OK：{{placement}}",
    "validate": "検証",
    "err_RULE_INVALID": "ルールが不正です。問題の一覧を確認してください",
    "err_RULE_RUNNING": "前回の実行がまだ終わっていません",
    "err_RULE_DISABLED": "ルールは無効です",
    "err_VERSION_CONFLICT": "他の人が変更しました。開き直してください",
    "handoff_old_device": "元の実行デバイス",
    "handoff_pending": "引き継ぎ中：{{from}} がオンラインで旧設定を停止した後、{{to}} で実行します",
    "handoff_disabled": "無効（{{from}} がオンラインになると反映）",
    "handoff_deleting": "削除中（{{from}} がオンラインになると停止）",
    "shared_devices_note": "共有されたデバイスは自動化に使えません",
    "err_RULE_HANDOFF_PENDING": "ルールの引き継ぎ中です。旧デバイスがオンラインで旧設定を停止すると実行できます",
    "handoff_cloud": "クラウド",
    "more": "その他のルール操作",
    "empty_intro": "まだルールがありません。ルールを使うとデバイスが自動で反応します（ドアが開いたら録画して通知、警戒中に人がいたらサイレン）。テンプレートから始めましょう：",
    "use_template": "このテンプレートを使う",
    "tpl_door_record_notify_needs": "ドア・窓センサーが必要ですが、この$t(leaf.cur)にはまだありません",
    "tpl_armed_pir_siren_needs": "人感センサー（PIR）が必要ですが、この$t(leaf.cur)にはまだありません",
    "tpl_ai_person_notify_needs": "人物検知ができるカメラが必要ですが、この$t(leaf.cur)にはまだありません",
    "reason_other": "理由は示されていません",
    "tpl_cannot_create": "{{what}}。そのため、まだ作成できません。先に「デバイス」で必要なデバイスを追加するか、別のテンプレートを選んでください。",
    "tpl_pick_first": "先に{{what}}を選んでください"
  },
  "armed": {
    "label": "警戒モード",
    "home": "在宅",
    "night": "夜間",
    "away": "外出",
    "unsynced_one": "{{count}} 台が未同期（オンライン時に送信）",
    "unsynced_other": "{{count}} 台が未同期（オンライン時に送信）"
  },
  "dctl": {
    "siren_on": "🔔 サイレンを鳴らす",
    "siren_off": "サイレン停止",
    "light_on": "💡 補助ライトをオン",
    "light_off": "補助ライトをオフ",
    "reboot": "再起動",
    "reboot_confirm": "「{{name}}」を再起動しますか？1〜2 分オフラインになります。",
    "sent": "送信しました",
    "err_FORBIDDEN": "権限がありません",
    "err_DEVICE_OFFLINE": "デバイスがオフライン",
    "err_DEVICE_WAKING": "デバイスを起動中です。しばらくしてからもう一度お試しください",
    "err_DEVICE_ASLEEP": "デバイスはスリープ中です",
    "err_COMMAND_TIMEOUT": "デバイスが時間内に応答しませんでした",
    "err_RENEW_ONLY": "デバイスの証明書が期限切れのため、更新のみ受け付けます",
    "siren_confirm": "{{name}} のサイレンを 30 秒鳴らしますか？",
    "siren_confirm_body": "現場でサイレンが鳴ります。早く止めるには〔サイレン停止〕を押してください。",
    "siren_action": "サイレンを鳴らす",
    "more": "その他"
  },
  "alarm": {
    "section": "アラーム対応",
    "state_open": "未対応",
    "state_acknowledged": "確認済み",
    "state_claimed": "対応中",
    "state_resolved": "対応済み",
    "state_false_alarm": "誤報",
    "act_acknowledged": "確認済みにする",
    "act_claimed": "対応する",
    "act_take_over": "引き継ぐ",
    "act_resolved": "対応済み",
    "act_false_alarm": "誤報",
    "act_open": "未対応に戻す",
    "claimed_by": "{{name}} が対応中",
    "claimed_by_me": "あなたが対応中",
    "someone": "誰か",
    "note_btn": "メモ",
    "note_label": "メモ",
    "note_placeholder": "メモ（1 行、{{max}} 文字まで）",
    "note_invalid": "メモは 1 行、{{max}} 文字までです",
    "last_note": "メモ：{{note}}",
    "conflict": "{{name}} が対応済みです。画面を更新しました",
    "conflict_anon": "他の人が対応済みです。画面を更新しました",
    "failed": "更新に失敗しました：{{msg}}",
    "history": "対応履歴",
    "history_empty": "まだ誰も対応していません",
    "read_only": "閲覧のみで、対応状態は変更できません",
    "unhandled_n": "未対応のアラーム {{n}} 件",
    "handle_menu": "対応",
    "note_add": "メモを追加",
    "also_done": "この {{n}} 件をまとめて対応済みにしました",
    "more_actions": "その他（誤報・メモ）",
    "unhandled_counting": "未対応のアラームを集計中",
    "age_just_now": "発生したばかり",
    "age_min_one": "発生から {{count}} 分",
    "age_min_other": "発生から {{count}} 分",
    "age_hour_one": "発生から {{count}} 時間",
    "age_hour_other": "発生から {{count}} 時間",
    "age_day_one": "発生から {{count}} 日",
    "age_day_other": "発生から {{count}} 日",
    "recovered_dur": "↺ {{at}} に復旧（{{dur}} 途切れました）",
    "act_resolve_recovered": "復旧済みとして対応完了",
    "resolve_recovered_tip": "状況は解消済みです。「対応済み」にします",
    "recovered_lt1": "↺ {{at}} に復旧（1 秒未満の途切れ）"
  },
  "popup": {
    "title": "アラームポップアップ",
    "help": "イベント発生時に映像を自動で表示します。これはこのパソコン（ブラウザ）の設定で、アカウントには紐づきません。",
    "sensor": "センサー反応",
    "sensor_help": "ドアセンサー / PIR が反応したとき、連動カメラを表示します（連動はデバイスページで設定）",
    "alarm": "アラーム",
    "alarm_help": "煙、取り外し、または警戒中にアラーム設定された検知 → 発生元のカメラを表示",
    "detection": "AI 検知",
    "detection_help": "人や車などの通常の検知でも発生元のカメラを表示します（イベントが多い拠点では頻繁になります）",
    "target": "表示先",
    "target_float": "右下のフローティングウィンドウ",
    "target_cell": "ビデオウォールの指定セル",
    "cell": "セル番号",
    "cell_help": "ビデオウォール表示中は、発生元のカメラをこのセルに移します（すでにウォール上にあれば入れ替え）。それ以外ではフローティングウィンドウを使います。"
  },
  "sync": {
    "title": "複数カメラ同期再生",
    "open": "同期再生",
    "help": "最大 {{max}} 台を同じ時刻で揃えて再生します。クラウド録画があるカメラはクラウドから、ないカメラはローカル録画（NVR / Station のディスク、SD カード）から再生します。その時刻に録画がないカメラは空白になります。",
    "cameras": "カメラ（{{n}} / {{max}}）",
    "load": "読み込む",
    "play": "再生",
    "pause": "一時停止",
    "speed": "速度",
    "position": "再生位置",
    "gap": "この時間のクラウド録画はありません",
    "end": "この時刻以降のクラウドクリップはありません（クラウドはイベントクリップのみ保存）",
    "no_cloud_scope": "この範囲のカメラには直近 2 か月のクラウド録画もローカル録画（NVR / Station のディスク、SD カード）もないため、同期再生できる録画がありません。",
    "no_cloud_cam": "クラウド録画もローカル録画（ディスク / SD カード）もありません",
    "aligned": "{{at}} の時点ではどのカメラにも録画がないため、最も早い録画 {{from}} から開始します。",
    "no_cloud_legend": "鍵マークのカメラは直近 2 か月のクラウド録画（未対応、またはシート / プランなし）もローカル録画（NVR / Station のディスク、SD カード）もありません。",
    "skip_to": "{{time}} へ移動",
    "jump_all": "同期再生は同じ時刻を使うため、すべての画面がその時刻へ移動します",
    "jumped": "すべての画面を {{name}} の次の録画（{{at}}）へ移動しました。",
    "none_later": "この後 {{h}} 時間はクラウドの録画がありません",
    "event_only": "イベント録画のみ",
    "event_only_hint": "このカメラはクラウドにイベント録画だけを保存するため、同期再生ではほとんどが空白になります（「そこへ移動」で次の録画へ）",
    "clip_suspect": "⚠ このクラウドクリップは不完全な可能性があります（緑色・停止の場合あり）",
    "open_single": "1 画面表示で他のソースを見る",
    "gap_next": "この時刻のクラウド録画はありません（次のクリップ {{time}}）",
    "src_cloud": "クラウド",
    "src_nvr": "ディスク",
    "src_sd": "SD カード",
    "gap_local": "この時刻のローカル録画はありません",
    "gap_next_local": "この時刻のローカル録画はありません（次は {{time}}）",
    "end_local": "この時刻以降のローカル録画はありません"
  },
  "chcopy": {
    "title": "設定を他のチャンネルへコピー",
    "help": "1 つのチャンネルの設定を他のチャンネルに書き込み、チャンネルごとに読み戻して確認します。両方に存在し、変更権限のある項目だけをコピーします。スケジュールや検知エリアなどのカスタムエディターとコマンドは対象外です。",
    "source": "コピー元チャンネル",
    "targets": "コピー先チャンネル",
    "all": "他のチャンネルをすべて選択",
    "compare": "比較",
    "items": "コピーする項目",
    "nothing": "コピー元にコピーできる設定がありません",
    "col_channel": "チャンネル",
    "col_diff": "異なる項目",
    "col_result": "結果",
    "diff_n": "{{n}} 件",
    "copy": "コピー",
    "retry": "失敗分を再試行（{{n}}）",
    "same": "すでに同じです",
    "applied_n": "{{n}} 件を適用",
    "not_applied": "未適用：{{list}}"
  },
  "aiset": {
    "open": "設定",
    "title": "AI 設定：{{name}}",
    "zone_help": "映像をクリックして検知エリアを描きます（最大 {{max}} 点、頂点をドラッグして調整）。描かない場合は画面全体です。",
    "line_help": "映像を 2 回クリックしてライン（A → B）を引きます。",
    "zone_points": "エリア {{n}} 点",
    "zone_full": "画面全体",
    "undo": "1 点戻す",
    "clear": "クリア",
    "line_first": "クリックして始点 A を設定",
    "line_second": "もう一度クリックして終点 B を設定",
    "line_set": "ラインを設定済み（映像をクリックで描き直し）",
    "direction": "方向",
    "dir_both": "両方向",
    "dir_a_to_b": "A の左側 → 右側",
    "dir_b_to_a": "A の右側 → 左側",
    "schedule": "スケジュール",
    "always": "終日",
    "start": "開始",
    "end": "終了",
    "schedule_help": "デバイスの現地時刻。終了が開始より早い場合は日付をまたぎます",
    "day_0": "日",
    "day_1": "月",
    "day_2": "火",
    "day_3": "水",
    "day_4": "木",
    "day_5": "金",
    "day_6": "土",
    "err_sensitivity": "感度は 10〜100 にしてください",
    "err_zone_points": "エリアは 3〜16 点必要です",
    "err_line_required": "このモデルは先にラインを引いてください",
    "err_line_short": "ラインが短すぎます",
    "err_schedule_days": "曜日を 1 つ以上選んでください",
    "err_schedule_time": "スケジュールの時刻が正しくありません（開始と終了は同じにできません）"
  },
  "diag": {
    "title": "リモート診断の許可",
    "help": "サポートがこのデバイスを読み取り専用でリモート確認（状態、設定の概要、最近のデバイス記録）する際は、オーナーまたは管理者の許可が必要です。許可には期限があり、いつでも取り消せます。生ログのダウンロードは提供しません。",
    "none": "診断の依頼はありません",
    "st_requested": "許可待ち",
    "st_granted": "許可済み",
    "st_denied": "拒否済み",
    "st_revoked": "取り消し済み",
    "st_expired": "期限切れ",
    "by_brand": "{{brand}} サポート",
    "until": "{{at}} まで",
    "runs": "{{n}} 回確認済み",
    "minutes": "許可する時間",
    "approve": "許可",
    "deny": "拒否",
    "revoke": "取り消す"
  },
  "batch": {
    "open": "一括操作（{{n}}）",
    "title_one": "一括操作：{{count}} 台",
    "title_other": "一括操作：{{count}} 台",
    "pick": "{{name}} を選択",
    "pick_all": "すべて選択",
    "mode_rename": "名前の変更",
    "mode_firmware": "ファームウェア更新",
    "rule": "命名ルール",
    "start": "開始番号",
    "rule_help": "{name} = 現在の名前、{n} = 連番、{n:02} = 2 桁にゼロ埋め。例：1F-{n:02} {name}",
    "fw_help_one": "{{count}} 台のデバイス本体を確認し、更新があれば開始します（チャンネルは NVR に従います）。更新がないものはスキップします。オーナー権限が必要です。",
    "fw_help_other": "{{count}} 台のデバイス本体を確認し、更新があれば開始します（チャンネルは NVR に従います）。更新がないものはスキップします。オーナー権限が必要です。",
    "fw_confirm_one": "{{count}} 台のファームウェア更新を開始しますか？更新中はデバイスが一時的にオフラインになります。",
    "fw_confirm_other": "{{count}} 台のファームウェア更新を開始しますか？更新中はデバイスが一時的にオフラインになります。",
    "col_new": "新しい名前",
    "col_result": "結果",
    "run": "開始（{{n}} 台）",
    "same": "名前は変わりません",
    "st_pending": "待機中",
    "st_running": "実行中…",
    "summary": "成功 {{ok}}、スキップ {{skipped}}、失敗 {{failed}}、残り {{left}}",
    "err_BAD_NAME": "名前が無効です（空、または 64 文字超）",
    "err_FORBIDDEN": "権限がありません",
    "mode_settings": "設定を適用",
    "settings_source": "このデバイスをテンプレートにする",
    "settings_help": "テンプレートのデバイスの設定を、選択した同じ機種の他のデバイスに書き込み、1 台ずつ読み戻して確認します。両方にあり、変更権限のある項目だけをコピーします。スケジュール、検知エリア、コマンドは対象外です。機種が異なるデバイスはスキップします。",
    "settings_confirm_one": "「{{name}}」の設定を {{count}} 台に適用しますか？ストリーム設定は既存の録画と視聴に影響します。",
    "settings_confirm_other": "「{{name}}」の設定を {{count}} 台に適用しますか？ストリーム設定は既存の録画と視聴に影響します。",
    "skip_model": "機種が異なります",
    "skip_same": "設定は同じです",
    "mode_location": "場所を割り当て",
    "loc_site": "場所",
    "loc_pick": "拠点を選択…",
    "loc_help": "選択したデバイス / チャンネルをこの拠点に割り当てます（$t(leaf.cur)のアンカー拠点配下である必要があります）。同じ$t(leaf.cur)のデバイスはまとめて送信し、1 台でも失敗するとその$t(leaf.cur)は何も変更されません。",
    "loc_need_org": "位置の割り当ては、同じチーム組織の$t(leaf.cur)にあり、自分が管理できるデバイスにのみ適用されます。",
    "err_BATCH_REJECTED": "同じバッチの別のデバイスが失敗したため、変更されていません",
    "err_VERSION_CONFLICT": "場所が他の人に変更されました。再読み込みしてやり直してください",
    "err_OUT_OF_ANCHOR": "この拠点は$t(leaf.cur)のアンカー配下にありません",
    "err_BAD_TARGET": "デバイスはこの$t(leaf.cur)にありません",
    "no_manage": "このデバイスは管理できません（$t(leaf.cur)のオーナーか管理者のみ。共有されたデバイスは管理できません）",
    "no_maintain": "このデバイスを保守できません（$t(leaf.cur)のオーナー / 管理者、またはノード管理者 / 保守担当のみ。共有されたデバイスは不可）",
    "denied": "権限がないため実行しません：{{why}}",
    "denied_n_one": "{{count}} 台は権限がないため実行されません。",
    "denied_n_other": "{{count}} 台は権限がないため実行されません。",
    "mode_reboot": "再起動",
    "reboot_help": "接続している {{n}} 台のデバイスを再起動します。サーバーが 1 台ずつ権限を確認し、権限のないものは理由を表示して、ほかは続行します。",
    "reboot_confirm_one": "{{count}} 台のデバイスを再起動しますか？再起動中は録画とライブ映像が止まります。",
    "reboot_confirm_other": "{{count}} 台のデバイスを再起動しますか？再起動中は録画とライブ映像が止まります。",
    "picked_one": "{{count}} 台を選択中",
    "picked_other": "{{count}} 台を選択中",
    "clear": "選択を解除"
  },
  "fwm": {
    "open": "ファームウェア管理",
    "title": "ファームウェア管理",
    "back": "デバイスに戻る",
    "help": "各デバイスのファームウェアバージョンと更新スケジュールです。自動更新がオンのデバイスは、メンテナンス時間帯（デバイスの現地時間）に新しいバージョンをインストールします。配信するバージョン、段階配信、一時停止はプラットフォームのリリース設定で決まります。設定を変更できるのはオーナーだけです。",
    "st_latest": "最新",
    "st_available": "更新あり",
    "st_updating": "更新中",
    "st_unknown": "取得できません",
    "count_one": "{{count}} 台",
    "count_other": "{{count}} 台",
    "empty": "この範囲にファームウェアを管理できるデバイスはありません。",
    "home_failed": "{{home}} のファームウェア状態を取得できません",
    "col_model": "機種",
    "col_state": "状態",
    "col_window": "メンテナンス時間帯",
    "updating": "{{v}} に更新中（{{p}}%）",
    "available": "{{v}} に更新可能",
    "critical": "重要な更新",
    "auto_of": "{{name}} の自動更新",
    "window_of": "{{name}} のメンテナンス時間帯",
    "saved": "保存しました",
    "batch_schedule": "スケジュールを適用（{{n}}）",
    "batch_update": "今すぐ更新（{{n}}）",
    "batch_schedule_help": "選択したデバイスに自動更新とメンテナンス時間帯を書き込みます。時間帯の形式は HH:MM-HH:MM（日付をまたげます）。空欄 = 変更しない。",
    "batch_update_help": "選択したデバイスの更新を開始します。新しいバージョンがない、または更新中のデバイスはスキップします。更新中はデバイスが一時的にオフラインになります。",
    "keep": "変更しない",
    "skip_updating": "更新中",
    "retry": "失敗分を再試行（{{n}}）",
    "err_FORBIDDEN": "権限がありません（オーナーのみ）",
    "err_FIRMWARE_NOT_CONFIGURED": "この環境ではファームウェアサービスが有効ではありません",
    "err_daily_cap": "本日の更新上限に達しました。明日もう一度お試しください",
    "err_offline": "デバイスがオフラインです",
    "report": "更新レポート",
    "period": "期間",
    "period_1": "過去 24 時間",
    "period_7": "過去 7 日間",
    "period_30": "過去 30 日間",
    "report_build": "レポートを作成",
    "report_csv": "CSV をダウンロード",
    "report_summary": "過去 {{days}} 日間：成功 {{success}}、失敗 {{failed}}、その他 {{other}}",
    "report_unread_one": "（{{count}} 台の履歴を取得できません）",
    "report_unread_other": "（{{count}} 台の履歴を取得できません）",
    "report_empty": "この期間の更新記録はありません。",
    "csv_at": "時刻",
    "csv_home": "拠点",
    "csv_device": "デバイス",
    "csv_aid": "デバイス ID",
    "csv_from": "元のバージョン",
    "csv_to": "バージョン",
    "csv_status": "結果",
    "csv_reason": "理由",
    "csv_trigger": "トリガー",
    "csv_finished": "完了時刻",
    "job_success": "成功",
    "job_failed": "失敗",
    "job_rolled_back": "ロールバック済み",
    "job_deferred": "延期",
    "job_canceled": "キャンセル",
    "job_pending": "待機中",
    "job_sent": "送信済み",
    "job_accepted": "デバイスが受け付けました",
    "job_downloading": "ダウンロード中",
    "job_installing": "インストール中",
    "job_rebooting": "再起動中",
    "trigger_auto": "スケジュール（自動更新）",
    "trigger_user_now": "今すぐ更新",
    "trigger_admin_push": "管理者による配信",
    "trigger_legacy_check": "デバイスの更新確認",
    "trigger_dev_pin": "開発者指定",
    "reason_timeout": "タイムアウト",
    "reason_download_failed": "ダウンロード失敗",
    "reason_verify_failed": "検証失敗",
    "reason_suspected_brick": "インストール後に応答なし",
    "reason_outside_window": "メンテナンス時間帯外",
    "reason_battery_low": "バッテリー残量不足",
    "reason_busy": "デバイスがビジー",
    "st_unknown_offline": "取得できません（オフライン）",
    "only_outdated": "更新があるもののみ",
    "how_saved": "「自動更新」は切り替えた時点で保存されます。「メンテナンス時間帯」は編集後に［保存］か Enter を押してください。デバイスは時間帯の中でだけ自動更新します。すぐ更新するにはチェックして［今すぐ更新］を押します。"
  },
  "chmx": {
    "title": "チャンネル設定を比較",
    "help": "各チャンネルの設定を並べて比較します。多数のチャンネルと異なるセルには印が付きます。編集できるセルはその場で変更できます（そのチャンネルに書き込み、読み戻して確認）。まとめて揃える場合は下の「他のチャンネルに設定をコピー」を使ってください。スケジュールや検知エリアは各チャンネルの設定ページで編集します。",
    "load_one": "{{count}} チャンネルの設定を比較",
    "load_other": "{{count}} チャンネルの設定を比較",
    "reload": "再読み込み",
    "only_diff": "異なる項目だけ表示",
    "diff_count": "{{n}} 項目がチャンネル間で異なります",
    "unread": "設定を読み込めません：{{list}}",
    "col_setting": "設定項目",
    "custom": "設定ページへ",
    "save_cell": "{{name}} を保存"
  },
  "tier": {
    "filter": "表示",
    "common": "よく使う",
    "advanced": "詳細",
    "technical": "技術"
  },
  "scope": {
    "src_own": "自分の",
    "src_org": "組織から許可されたもの",
    "src_shared": "共有されたもの",
    "external": "組織への共有",
    "personal_org": "自分の家",
    "sharer_unknown": "共有した人",
    "notice_mfa_required": "2 段階認証が必要",
    "notice_org_suspended": "組織は停止中",
    "notice_ip_not_allowed": "このネットワークからは利用できません",
    "notice_session_reauth": "再ログインが必要",
    "notice_body_mfa_required": "この組織は 2 段階認証を必須にしています。2 段階認証を有効にして再ログインすると、この組織のデバイスが表示されます。自分のデバイスや他の組織には影響しません。",
    "notice_body_org_suspended": "この組織はプラットフォームによって停止されたため、デバイスは一時的に表示されません。",
    "notice_body_ip_not_allowed": "この組織は特定のネットワークからのみ利用できます。現在のネットワークではデバイスが表示されません。",
    "notice_body_session_reauth": "この組織のデバイスを使い続けるには再ログインが必要です。",
    "go_settings": "設定へ",
    "load_failed": "デバイス一覧を読み込めませんでした。しばらくしてから再試行してください。",
    "notice_delegator_mfa_required": "委任元が 2 段階認証を必須にしています",
    "hint_all": "すべて",
    "hint_device": "このデバイスは {{path}} にあり、現在の範囲（{{scope}}）の外です。",
    "hint_event": "このイベントは {{path}} のもので、現在の範囲（{{scope}}）の外です。",
    "hint_switch": "範囲を {{name}} に切り替え",
    "switched_to": "範囲を {{name}} に切り替えました",
    "all_n_orgs_one": "すべて（{{count}} 組織）",
    "all_n_orgs_other": "すべて（{{count}} 組織）",
    "count_one": "{{count}} 台",
    "count_other": "{{count}} 台",
    "count_tip": "アクセスできるデバイス数（NVR チャンネルは含まない）",
    "search": "組織・拠点・$t(leaf.cur)を検索",
    "create_org": "＋ 組織を作成",
    "loading": "範囲を読み込み中…",
    "all_n_orgs_homes_one": "すべて（組織 {{count}}、家 {{homes}}）",
    "all_n_orgs_homes_other": "すべて（組織 {{count}}、家 {{homes}}）",
    "notice_sso_required": "会社アカウントでの認証が必要",
    "go_sso": "会社アカウントで認証"
  },
  "access": {
    "shared_by": "{{name}} が共有",
    "expires": "{{date}} まで",
    "also_via": "ほかの経路：{{list}}"
  },
  "deny": {
    "not_granted": "権限がありません",
    "org_mfa_required": "2 段階認証が必要です",
    "org_suspended": "組織は停止中です",
    "ip_not_allowed": "組織はこのネットワークからの利用を許可していません",
    "session_reauth": "再ログインが必要です",
    "share_expired": "共有は {{date}} に期限切れになりました",
    "share_expired_nodate": "共有は期限切れです",
    "share_suspended": "共有は一時停止中です",
    "alarm_window": "アラーム後 {{n}} 分以内のみ",
    "armed": "警戒中のみ",
    "schedule": "許可された時間帯外です",
    "before_share_start": "共有開始前のデータは見られません",
    "org_unverified": "事業者の審査が失効しています",
    "parent_restricted": "一部のチャンネルのみ許可されています",
    "duty_no_export": "当直アカウントはエクスポートできません",
    "action_not_available": "この環境ではこの機能は提供されていません",
    "device_offline": "デバイスはオフラインです"
  },
  "shr": {
    "tab": "共有",
    "title": "{{name}} の共有",
    "hint": "この$t(leaf.cur)のデバイスを 1 台ずつ個人や組織（設置業者・警備・監視センターなど）に共有します。共有は縮小か取り消しのみ可能で、取り消すと 30 秒以内に映像が止まります。共有された人がさらに共有することはできません。",
    "to_person": "個人に共有",
    "to_org": "組織に共有",
    "people": "個人への共有",
    "orgs": "組織への共有",
    "none": "共有はありません。",
    "no_homes": "共有を管理できる$t(leaf.cur)がありません（$t(leaf.cur)のオーナーか管理者である必要があります）。",
    "no_expiry": "期限なし",
    "renew": "更新",
    "renew_of": "「{{name}}」を更新",
    "renew_hint": "組織から受け取った更新コードを入力します。範囲は変わらず期間が延長されます。範囲が変わる場合は「組織に共有」で改めて承認してください。",
    "revoke_confirm": "「{{name}}」への共有を取り消しますか？30 秒以内に反映されます。",
    "someone": "相手",
    "an_org": "組織",
    "person_hint": "相手のメールアドレスを入力します。アカウントがあればすぐに表示され通知されます。なければ招待メールが届き、登録後に有効になります。承認は不要で、相手はいつでも削除できます。",
    "no_reshare": "既定では「閲覧」のみです。共有された人はさらに共有できません。",
    "expires": "有効期限（任意）",
    "expires_hint": "空欄なら取り消すまで有効です。",
    "send": "送信",
    "sent": "{{email}} に送信しました。",
    "unverified": "未審査",
    "is_renewal": "これは更新リクエストです。範囲は同じで期間が延長されます。",
    "access_log": "共有のアクセス履歴",
    "access_log_hint": "共有経由のライブ映像、再生、デバイス操作はすべてここに記録されます。$t(leaf.cur)のメンバー全員が見られ、変更できません。",
    "grantee": "共有先",
    "grantee_user": "個人",
    "grantee_org": "組織",
    "wrong_env": "このコードは別の環境（{{env}}）のものなので、この$t(leaf.cur)では承認できません。",
    "requested_devices": "要求されたデバイス",
    "unknown_device": "削除されたデバイス"
  },
  "mine": {
    "shared_tab": "共有されたもの",
    "shared_title": "共有されたもの",
    "shared_hint": "個人宛てに共有されたデバイスです。承認は不要で、いつでも削除できます。所属組織への共有はここに表示されません。",
    "shared_none": "共有されたデバイスはありません。",
    "remove": "外す",
    "remove_confirm": "{{name}} から共有されたデバイスを外しますか？",
    "remove_body": "外すとこれらのデバイスは見られなくなります。再度必要な場合は共有し直してもらってください。",
    "access_log": "アクセス履歴",
    "access_log_hint": "共有されたデバイスであなたが行ったライブ映像・再生・操作の記録です。共有した人も見られます。",
    "access_log_empty": "記録はありません。",
    "result": "結果",
    "result_ok": "成功",
    "result_denied": "拒否"
  },
  "inv": {
    "tab_unassigned": "未割り当てのデバイス",
    "tab_detected": "検出されたデバイス",
    "title": "{{name}} の在庫",
    "hint": "組織が所有し、まだ$t(leaf.cur)に入っていないデバイスです。登録して拠点の$t(leaf.cur)に事前割り当てすると、オンラインになったとき自動的に追加されます。在庫だけでは誰も映像を見られません。",
    "detected_hint": "拠点で見つかった未追加のデバイス（近くの新しいデバイス、アドレスを要求する PoE カメラ、ONVIF 検出）。在庫のデバイスはワンクリックで追加できます。",
    "coming_soon": "近日公開予定です。",
    "no_org": "在庫を管理できる組織がありません。",
    "claim": "デバイスを登録",
    "col_name": "名前",
    "col_serial": "シリアル番号",
    "col_status": "状態",
    "col_target": "割り当て / $t(leaf.cur)",
    "empty": "在庫にデバイスはありません。",
    "status_offline": "未接続",
    "status_online_unpaired": "オンライン・未追加",
    "status_assigned": "割り当て済み・オンライン待ち",
    "status_joined": "追加済み",
    "claim_help": "シリアル番号と注文番号を入力します（出荷リストの貼り付けも可）。1 行に 1 台、シリアルと注文番号はスペースかカンマで区切ります。一致しない行は「一致しません」とだけ表示され、どちらが違うかは表示しません。",
    "claim_lines": "シリアル　注文番号（1 行 1 台）",
    "claim_placeholder": "SN2505A0012 PO-20261009-01",
    "claim_bad_lines": "{{lines}} 行目の形式が正しくありません（「シリアル 注文番号」の 2 列）",
    "claim_over": "一度に最大 {{n}} 行です。超えた分は送信しません",
    "claim_run": "{{n}} 台を登録",
    "claim_st_pending": "処理中…",
    "claim_st_ok": "✓ 在庫に追加しました（{{model}}）",
    "claim_st_already": "✓ すでに在庫にあります（{{model}}）",
    "claim_st_not_found": "シリアル番号または注文番号が一致しません",
    "claim_st_rate_limited": "失敗が多すぎます。1 時間後にお試しください",
    "claim_st_error": "現在登録できません（{{code}}）",
    "assign_to": "割り当て…（{{n}}）",
    "assign_title": "{{n}} 台を$t(leaf.cur)に割り当て",
    "assign_help": "設置先の$t(leaf.cur)を選びます。デバイスはオンラインになると自動で参加し、すでにオンラインのものはすぐ参加します。割り当てで映像が見えるようになる人はいません。",
    "assign_search": "$t(leaf.cur)を検索",
    "assign_home": "$t(leaf.cur)",
    "assign_no_home": "該当する$t(leaf.cur)がありません（$t(leaf.cur)はノードの下にある必要があります）",
    "assign_run": "割り当て",
    "assign_st_assigned": "✓ 割り当て済み、オンライン待ち",
    "assign_st_joined": "✓ すでにこの$t(leaf.cur)にあります",
    "err_NOT_FOUND": "この組織の在庫にありません",
    "err_DEVICE_ALREADY_BOUND": "この組織の別の$t(leaf.cur)にあります。$t(leaf.cur)を変更するには先に登録を解除してください",
    "err_ECOSYSTEM_MISMATCH": "エコシステムが一致しません",
    "err_UNAVAILABLE": "一時的に処理できません。しばらくしてからもう一度お試しください",
    "err_INTERNAL": "処理に失敗しました。しばらくしてからもう一度お試しください",
    "unassign": "割り当てを取り消す",
    "unassign_n": "割り当てを取り消す（{{n}}）",
    "unassign_confirm": "{{n}} 台の事前割り当てを取り消しますか？デバイスは在庫に残り、あとで再度割り当てられます。",
    "filter_all_status": "すべての状態",
    "filter_all_models": "すべての機種",
    "search_serial": "シリアルを検索",
    "filter_node": "絞り込み：{{name}}",
    "filter_node_clear": "組織全体を表示",
    "select_all": "すべて選択",
    "col_source": "入庫元",
    "more": "さらにあります。フィルターで絞り込んでください。",
    "source_admin": "プラットフォーム配布",
    "source_shop": "ストア注文",
    "source_claim": "シリアル登録",
    "source_dealer": "販売店出荷",
    "source_org_link": "開発者組織からの引き渡し",
    "source_transfer": "組織間移管",
    "det_node": "対象ノード",
    "det_scope_node": "現在の範囲のノード",
    "det_scan": "ONVIF スキャン",
    "det_scanning": "スキャン中…（最大約 15 秒）",
    "det_nearby_pending": "Station / NVR にネットワークアドレスを要求しているデバイスと、ONVIF スキャンで見つかったカメラを表示します。",
    "det_scan_result": "{{gateways}} 台のゲートウェイをスキャンし、{{found}} 台見つかりました（{{failed}} 台は応答なし）",
    "det_col_kind": "種類",
    "det_col_what": "機種 / メーカー",
    "det_col_seen_by": "検出元",
    "det_col_sources": "ソース",
    "det_col_seen_at": "最終検出",
    "det_kind_kinio": "Kinio デバイス",
    "det_kind_third_party": "他社 ONVIF",
    "det_kind_address_request": "アドレス要求中",
    "det_in_inventory": "在庫",
    "det_gateway": "ゲートウェイ",
    "det_src_onvif": "ONVIF 検出",
    "det_src_station_dhcp": "アドレス要求",
    "det_src_nearby_wifi": "近く（Wi-Fi）",
    "det_src_nearby_lan": "近く（LAN）",
    "det_add": "追加",
    "det_add_onvif": "ONVIF で追加",
    "det_approve": "アドレスを承認",
    "det_suspect": "上位ネットワークのデバイスの可能性があります。承認前に確認してください",
    "det_empty": "新しいデバイスは検出されていません。「ONVIF スキャン」でネットワーク上のカメラを探します。",
    "det_col_ident": "末尾 / MAC",
    "det_lease_error": "検出が開始されていません（一覧が最新でない可能性があります）：",
    "det_adopt_title": "在庫のデバイスを$t(leaf.cur)に追加",
    "det_adopt_help": "追加先の$t(leaf.cur)（このノードの下）を選びます。オンラインならすぐに参加し、まだならオンラインになった時点で自動的に参加します。",
    "det_adopt_joined": "追加しました。",
    "det_adopt_assigned": "割り当て済み。オンラインになると自動で参加します。"
  },
  "ot": {
    "dot": "・",
    "you": "あなた",
    "reauth_suffix": "（再認証が必要）",
    "optional": "（任意）",
    "reason": "理由",
    "next": "次へ",
    "next_preview": "次へ：影響を確認",
    "name": "名前",
    "owner": "オーナー",
    "personal": "個人",
    "org_owned": "組織",
    "add": "追加",
    "clear": "クリア",
    "details": "詳細",
    "now": "現在",
    "forever": "無期限",
    "until": "{{date}} まで",
    "window": "{{from}}–{{to}}",
    "until_date": "期限日",
    "term": "期限",
    "only_window": "この時間帯のみ",
    "window_from": "開始",
    "window_to": "終了",
    "expand": "展開",
    "collapse": "折りたたむ",
    "no_results": "一致する項目はありません",
    "n_people": "{{n}} 人",
    "n_people_paren": "（{{n}} 人）",
    "n_people_link": "{{n}} 人 ›",
    "n_assignments": "割り当て {{n}} 件",
    "n_homes_devices": "{{homes}} か所・{{devices}} 台",
    "n_grantees": "割り当て先 {{n}} 人",
    "member_group_n": "メンバーグループ・{{n}} 人",
    "member_group_paren": "（メンバーグループ・{{n}} 人）",
    "delegation": "委任",
    "delegations": "委任",
    "verified": "審査済み：{{kinds}}",
    "org_code": "組織コード {{code}}",
    "org_code_line": "当組織のコード：{{code}}（相手が委任を作成するときに同じコードが表示されるので、口頭で確認できます）",
    "whole_org": "組織全体",
    "whole_org_name": "{{org}}（組織全体）",
    "whole_org_short": "{{org}}",
    "whole_org_of": "{{org}}（組織全体）",
    "whole_org_now_later": "（現在と今後のノード・場所）",
    "whole_org_check": "組織全体（現在と今後のノード・場所）",
    "leaf_default": "ロケーション",
    "leaf_personal": "ホーム",
    "leaf_default_lc": "ロケーション",
    "leaf_default_pl": "ロケーション",
    "leaf_default_lc_pl": "ロケーション",
    "leaf_personal_lc": "ホーム",
    "leaf_personal_pl": "ホーム",
    "leaf_personal_lc_pl": "ホーム",
    "unassigned": "未割り当て",
    "scope_custom": "（現在の範囲）",
    "level": "階層名",
    "not_in_list": "リストにありません",
    "lvl_site": "拠点",
    "lvl_building": "建物",
    "lvl_floor": "フロア",
    "lvl_zone": "エリア",
    "act_view": "視聴",
    "act_playback": "再生",
    "act_events": "イベント",
    "act_alarm": "アラーム",
    "act_talk": "通話",
    "act_control": "操作",
    "act_arm": "警戒開始",
    "act_disarm": "警戒解除",
    "act_maintain": "保守",
    "act_export": "エクスポート",
    "act_profile": "$t(leaf.cur)情報",
    "role": "役割",
    "role_node_admin": "ノード管理者",
    "role_operator": "オペレーター",
    "role_viewer": "閲覧者",
    "role_installer": "設置技術者",
    "role_maintainer": "保守担当",
    "role_custom": "カスタム",
    "role_owner": "オーナー",
    "role_admin": "管理者",
    "role_member": "メンバー",
    "role_desc_node_admin": "すべてのデータ操作（警戒開始 / 解除を含む）＋保守＋子ノードと割り当て。共有・$t(leaf.cur)の役割・録画設定・登録解除・フォーマットは含まない",
    "role_desc_operator": "視聴、通話、再生、イベント、操作、アラーム対応",
    "role_desc_viewer": "視聴、イベント。アラーム対応なし、アラームのプッシュなし",
    "role_desc_installer": "視聴、操作",
    "role_desc_node_admin_d_tail": "＋このサブツリーで自組織のメンバーを割り当て。警戒解除・保守は別途チェック。{{from}} のノード構成は変更不可",
    "role_node_admin_excl": "（共有・$t(leaf.cur)の役割・録画設定・登録解除・フォーマットを除く）",
    "role_effective_title": "役割・実際に有効 = 役割 ∩ 委任範囲（{{scope}}）",
    "extra_recording_export": "追加：録画のダウンロード / エクスポート",
    "extra_alarm_receive": "追加：アラーム対応",
    "extra_security_arm": "追加：遠隔警戒開始",
    "extra_security_disarm": "追加：遠隔警戒解除",
    "extra_device_maintain": "追加：保守（ファームウェア更新、再起動、名前変更）",
    "tab_tree": "組織ツリー",
    "tab_views": "レイアウト",
    "tab_groups": "グループ",
    "panel_collapse": "パネルを閉じる",
    "panel_expand": "組織ツリー / レイアウト / グループを開く",
    "tree_dlg_changed": "{{from}} が委任範囲を変更しました",
    "auth_changed": "権限が更新されました",
    "dlg_ended_short": "{{from}} は委任を終了しました",
    "tree_search": "ノード・$t(leaf.cur)・デバイスを検索",
    "search_min": "2 文字以上入力してください",
    "search_more": "ほかにもあります。条件を絞ってください",
    "tree_empty": "まだデバイスがありません。",
    "count_tip": "アクセスできるデバイス数",
    "dlg_label": "委任：{{from}}",
    "dlg_label_whole": "委任：{{from}}（組織全体）",
    "dlg_tip": "{{from}} からの委任、{{until}}",
    "mfa_needed": "{{from}} は 2 段階認証を必須にしています。有効にするとこれらのデバイスが表示されます。",
    "setup_mfa": "2 段階認証を設定",
    "dlg_ended_line": "{{from}} は {{time}} に委任を終了しました",
    "no_assignment_yet": "{{org}} ではまだノードが割り当てられていません。{{org}} の管理者に連絡してください",
    "more_actions": "{{name}} のその他の操作",
    "notify_me_node": "このノードの通知を受け取る",
    "notify_me_group": "このグループの通知を受け取る",
    "add_to_view": "レイアウトに追加…",
    "add_to_group": "グループに追加…",
    "open_in_wall": "ビデオウォールで開く",
    "no_devices": "表示できるデバイスはありません",
    "place_on_wall": "ビデオウォールに置く",
    "you_can_view_hint": "画面 = カメラまたはチャンネル。NVR はチャンネルごとに 1 画面（ツリーの数はデバイスの台数）",
    "live_empty": "この範囲に表示できるカメラはありません。",
    "live_dlg_ended": "{{from}} は {{time}} に委任を終了しました。この映像は停止しました",
    "live_dlg_changed": "{{from}} が委任範囲を変更したため、このカメラは表示できません",
    "prev_page": "前のページ",
    "next_page": "次のページ",
    "page_n": "{{n}} / {{total}} ページ",
    "views_hint": "レイアウトは整理のためだけのもので、権限のないデバイスが見えるようにはなりません",
    "groups_hint": "グループは権限を付与しません。各自が権限を持つデバイスだけが表示されます",
    "view_new": "レイアウトを作成",
    "group_dev_new": "デバイスグループを作成",
    "no_views": "レイアウトはまだありません。",
    "no_dev_groups": "デバイスグループはまだありません。",
    "view_label": "レイアウト：{{name}}",
    "group_prefix": "グループ：{{name}}",
    "edit_named": "{{name}} を編集",
    "unavailable_n_one": "{{count}} 件の項目は参照できなくなりました",
    "unavailable_n_other": "{{count}} 件の項目は参照できなくなりました",
    "group_batch": "一括操作",
    "view_edit_title": "レイアウトを編集：{{name}}",
    "group_edit_dev_title": "デバイスグループを編集：{{name}}",
    "org_view_of": "組織：{{org}}",
    "source_personal": "ソース（自分が見られるもの）",
    "source_org": "ソース（自組織の構成と委任されたノード、名前のみ）",
    "source_structure": "自組織の構成",
    "view_content": "レイアウトの内容",
    "group_content": "グループの内容",
    "add_folder": "フォルダを追加",
    "new_folder": "新しいフォルダ",
    "folder": "フォルダ",
    "top_level": "最上位",
    "editor_empty": "左のソースから ＋ で追加します。",
    "ref_folder": "フォルダ",
    "ref_node": "ノード",
    "ref_home": "$t(leaf.cur)",
    "ref_device": "デバイス",
    "ref_group": "グループ",
    "add_ref": "{{name}} を追加",
    "items_from_ended_one": "終了した委任から：{{from}}（{{count}} 件）",
    "items_from_ended_other": "終了した委任から：{{from}}（{{count}} 件）",
    "items_gone_one": "{{count}} 件の項目は参照できなくなりました",
    "items_gone_other": "{{count}} 件の項目は参照できなくなりました",
    "add_to_view_title": "「{{name}}」をレイアウトに追加",
    "add_to_group_title": "「{{name}}」をグループに追加",
    "no_editable_views": "編集できるレイアウトがありません。先に「レイアウト」タブで作成してください。",
    "no_editable_groups": "編集できるグループがありません。先に「グループ」タブで作成してください。",
    "subs_title": "ノードとグループ",
    "subs_hint": "組織ツリーのノードは既定で通常の検知をプッシュしません。購読するとプッシュ / 受信箱に届きます。購読しない場合は「イベント」一覧でのみ確認できます。",
    "subs_mine": "購読中",
    "subs_none": "購読しているノードやグループはありません。",
    "subs_target": "ノード / グループ",
    "subs_detection": "通常の検知",
    "subs_inactive": "現在無効",
    "subs_add": "＋ ノードまたはグループを購読",
    "subscribe": "購読",
    "unsubscribe": "購読解除",
    "ch_push": "プッシュ",
    "ch_inbox": "受信箱",
    "ch_email": "メール",
    "implicit_title": "購読しなくても届くもの",
    "implicit_alarm": "アラーム",
    "implicit_device_status": "デバイス異常",
    "implicit_alarm_push": "通常の設定どおりプッシュ",
    "implicit_alarm_feed": "プッシュなし、イベント一覧で確認可",
    "implicit_alarm_generic": "アラーム対応できる役割の場所は通常どおりプッシュ。閲覧者の場所はプッシュなし（イベント一覧で確認可）",
    "implicit_status": "ノード管理者または保守担当の場所：オフライン・録画停止・ストレージ異常はプッシュ、OTA などは受信箱へ",
    "implicit_mfa": "委任元が 2 段階認証を必須にしていて未設定の場合：アラームはプッシュされますが、「<委任元> にアラームがあります。2 段階認証を有効にすると表示されます」とだけ表示されます",
    "structure_title": "組織構成",
    "structure_moved": "ノード、$t(leaf.cur)、割り当て、継承のブロックは「組織構成」で管理します。",
    "open_structure": "組織構成を開く",
    "no_structure_access": "管理できるノードはありません。",
    "level_settings": "階層名の設定",
    "struct_tree_head": "構成ツリー（数字＝構成上の合計）",
    "struct_tree": "構成ツリー",
    "struct_search": "ノード・{{leaf}}を検索",
    "struct_count_tip": "構成上の合計（デバイス）",
    "blocked_tip": "継承をブロック中：上位の割り当てと委任は適用されません",
    "select_home": "{{name}} を選択",
    "pick_node": "左でノードを選んでください。",
    "struct_totals": "配下 {{nodes}} ノード、{{homes}} か所、{{devices}} 台（構成上の合計）",
    "add_child": "＋ 子ノード",
    "add_home": "＋ {{leaf}}",
    "rename_level": "名前 / 階層",
    "move": "移動",
    "archive": "停止",
    "archive_title": "「{{name}}」を停止しますか？",
    "archive_body": "ノード配下に$t(leaf.cur)と子ノードがない必要があります。このノードの割り当ては終了し、委任からはこのノードだけが外れます。",
    "archived": "「{{name}}」を停止しました",
    "block_label": "継承をブロック（上位の割り当てと委任をこのノード以下に適用しない）",
    "this_node_assignments": "このノードの割り当て",
    "no_assignments": "このノードに割り当てはありません。",
    "add_assignment": "＋ 割り当て",
    "inherited_title": "上位から継承（読み取り専用）",
    "delegated_out_title": "他組織への委任（読み取り専用）",
    "col_who": "対象",
    "col_role": "役割",
    "col_role_before": "元の役割",
    "col_term": "期限 / 時間帯",
    "col_from": "由来",
    "col_to_org": "受託組織",
    "col_from_org": "委任元",
    "col_scope": "範囲",
    "col_how": "経路",
    "col_granted_by": "付与者",
    "col_lost_actions": "失う操作",
    "col_effective": "実際に有効",
    "col_effective_now": "現在有効",
    "col_after_apply": "適用後に追加",
    "col_node": "ノード",
    "col_grantees": "割り当て先",
    "col_assigned": "割り当て済み",
    "n_selected": "{{leaf}} を {{n}} 件選択",
    "move_to": "移動先…",
    "assign_manager": "管理人を指定…",
    "only_unassigned": "未割り当ての場所のみ選択できます",
    "batch_max": "一度に最大 {{n}} か所",
    "node_name": "ノード名",
    "level_hint": "階層名は表示と絞り込み用で、権限には影響しません。",
    "create": "作成",
    "add_child_of": "「{{name}}」の下にノードを追加",
    "rename_title": "名前 / 階層：{{name}}",
    "node_created": "「{{name}}」を作成しました",
    "node_saved": "保存しました",
    "add_home_at": "「{{name}}」に{{leaf}}を追加",
    "manager": "管理人",
    "manager_none": "未割り当て（後で指定）",
    "manager_member": "メンバーを指定",
    "manager_me": "自分を管理人にする",
    "home_name": "{{leaf}}名",
    "creator_not_manager": "作成者はこの場所の管理人になりません。誰が見られるかはノードの割り当てで決まります。",
    "cover_summary": "この場所をカバーする割り当て：{{list}}",
    "cover_part": "{{node}}：{{n}} 人",
    "cover_dlg": "委任：{{org}}",
    "no_one_covers": "現在この場所の映像を見られる人はいません",
    "whole_org_hint": "新しい拠点を毎回自分で見る必要がある場合は、「組織全体」で自分を一度割り当てると（自己付与）、今後追加分もカバーされます",
    "unassigned_install": "管理人が未指定でも設置できます：組織管理者と在庫権限のあるメンバーは事前割り当て・取り込み・ペアリングができます（登録は誰にもデータ権限を与えません）。録画はデバイスの既定値（機種により常時またはイベント）。録画設定の変更・共有・登録解除は先に管理人を指定してください（後でまとめて指定できます）。",
    "self_manager_yellow": "あなたがこの{{leaf}}の管理人になり、すべての録画とイベントを見られるようになります。",
    "create_home": "{{leaf}}を作成",
    "home_created": "{{leaf}}「{{name}}」を作成しました",
    "pick_target_hint": "移動先のノードを選びます（管理できるノードのみ表示）。",
    "move_node_title": "「{{name}}」を移動",
    "move_node_confirm": "「{{name}}」を「{{to}}」へ移動しますか？",
    "move_node_intro": "移動すると、このサブツリーをカバーする割り当てと委任が変わります。",
    "move_action": "移動",
    "move_self_action": "移動してアクセスを取得",
    "moved": "「{{name}}」を移動しました",
    "move_homes_title_one": "{{count}} か所の移動先…",
    "move_homes_title_other": "{{count}} か所の移動先…",
    "move_homes_confirm_one": "{{count}} か所を「{{to}}」へ移動しますか？",
    "move_homes_confirm_other": "{{count}} か所を「{{to}}」へ移動しますか？",
    "move_homes_intro": "一度のプレビューと確認で実行し、すべて成功するか何も変わりません。",
    "move_homes_action_one": "{{count}} か所を移動",
    "move_homes_action_other": "{{count}} か所を移動",
    "homes_moved_one": "{{count}} か所を移動しました",
    "homes_moved_other": "{{count}} か所を移動しました",
    "manager_dialog_title_one": "{{count}} か所の管理人を指定",
    "manager_dialog_title_other": "{{count}} か所の管理人を指定",
    "manager_pick": "新しい管理人（組織メンバー）",
    "manager_effect_one": "{{name}} がこの {{count}} か所の管理人（$t(leaf.cur)のオーナー）になります：すべての録画とイベント（$t(leaf.cur)の役割はカバー開始の制限を受けず、指定前のものも含む）を閲覧、録画設定の変更、共有、登録解除が可能。既存のノード割り当ては変わりません",
    "manager_effect_other": "{{name}} がこの {{count}} か所の管理人（$t(leaf.cur)のオーナー）になります：すべての録画とイベント（$t(leaf.cur)の役割はカバー開始の制限を受けず、指定前のものも含む）を閲覧、録画設定の変更、共有、登録解除が可能。既存のノード割り当ては変わりません",
    "all_or_nothing": "すべて成功するか、何も変わりません。",
    "self_manager_batch_one": "自分を選びました：自己付与となり、この {{count}} か所のすべての録画を見られるようになります。他の管理者に 1 件通知され、監査に記録されます。",
    "self_manager_batch_other": "自分を選びました：自己付与となり、この {{count}} か所のすべての録画を見られるようになります。他の管理者に 1 件通知され、監査に記録されます。",
    "manager_submit_one": "{{count}} か所の管理人を指定",
    "manager_submit_other": "{{count}} か所の管理人を指定",
    "managers_done_one": "{{name}} が {{count}} か所の管理人になりました",
    "managers_done_other": "{{name}} が {{count}} か所の管理人になりました",
    "levels_hint": "組織で階層名のリストを管理し、各ノードが選びます。同じ深さでも別の名前を使えます。最大 12 個、各 1–20 文字。",
    "level_n": "階層名 {{n}}",
    "from_builtin": "元の組み込み名",
    "add_level": "＋ 階層名",
    "leaf_label": "$t(leaf.cur)の呼び名（例：戸、拠点、店舗）",
    "levels_preview": "プレビュー",
    "levels_no_perm": "名前は権限に影響しません。",
    "levels_builtin_warn": "組み込み名は現在の言語の文字になり、他の言語のメンバーにもこの文字で表示されます。それを使っているノードもまとめて変わります。",
    "levels_saved": "階層名を保存しました",
    "levels_err_too_many": "階層名は最大 12 個です",
    "levels_err_length": "各名前は 1–20 文字です",
    "levels_err_at_prefix": "カスタム名は @ で始められません",
    "levels_err_duplicate": "名前が重複しています",
    "previewing": "影響を計算中…",
    "preview_again": "再プレビュー",
    "preview_restaled": "プレビュー後にデータが変わったため、再プレビューして変わった行を強調しました。もう一度確認してください。",
    "losing_title": "組織ツリー経由のアクセスを失う（{{n}} 人、グループ展開込み・受託組織 {{orgs}}）",
    "gaining_title": "アクセスを得る（{{n}} 人）",
    "history_from": "新たにアクセスを得た人は {{time}} 以降のみで、それ以前の録画とイベントは見られません。",
    "remaining_title": "引き続きアクセスできる（組織ツリー経由ではなく、継承のブロックでは止まらない）",
    "other_paths": "別の経路で引き続き閲覧可（下記）",
    "target_still": "{{name}} はこの経路で引き続き閲覧可",
    "granter_still": "付与者は{{path}}で引き続き閲覧可",
    "keep": "保持",
    "also_revoke": "あわせて取り消す",
    "path_home_role": "$t(leaf.cur)の役割",
    "path_site_grant": "拠点付与",
    "path_share_user": "個人への共有",
    "path_share_org": "組織への共有",
    "path_assignment": "サブツリー内の割り当て",
    "path_delegation": "サブツリー内の委任",
    "granted_by_target_title": "この人が付与し、まだ有効な割り当て",
    "still_visible": "実行後も {{n}} 人が {{target}} を閲覧できます：{{who}}",
    "more_rows": "ほか {{n}} 人",
    "impact_scope": "影響：{{homes}} か所、{{devices}} 台",
    "active_streams": "現在 {{n}} 人が視聴中（30 秒以内に停止）",
    "dlg_gained": "{{org}} への委任が {{n}} か所多くカバーするようになります。送信後、委任元のオーナーと全管理者、受託組織に通知されます。",
    "dlg_lost": "{{org}} への委任のカバー範囲が {{n}} か所減ります（即時反映、双方に通知）。",
    "self_gain_generic": "この変更で自分に新しいデータ権限が付きます（自己付与）：理由が必須で、他の組織管理者とオーナーに通知され、監査に記録されます。",
    "block_on_title": "「{{name}}」で継承をブロックしますか？",
    "block_off_title": "「{{name}}」の継承ブロックを解除しますか？",
    "block_on_intro": "ブロックすると、上位の割り当てと委任は {{name}} 以下（{{homes}} か所、{{devices}} 台）に適用されなくなります。{{name}} 自身の割り当ては有効です。上位のノード管理者は {{name}} を見られなくなります（件数・アクセス・監査に表示されません）。",
    "block_off_intro": "解除すると上位の割り当てと委任が {{name}} 以下を再びカバーします。アクセスを再取得した人は現在以降のみ閲覧できます。",
    "block_on_action": "継承をブロック",
    "block_on_action_revoke": "継承をブロックし {{n}} 件を取り消す",
    "block_off_action": "継承ブロックを解除",
    "block_off_self_action": "解除してアクセスを取得",
    "block_on_note": "後でブロックを解除しても、アクセスを再取得した人は解除時点以降のみで、ブロック期間の録画は見られません。",
    "blocked_done": "「{{name}}」で継承をブロックしました",
    "unblocked_done": "「{{name}}」の継承ブロックを解除しました",
    "revoke_assign_title": "「{{node}}」の {{who}} の割り当てを取り消しますか？",
    "revoke_assign_body": "失う操作：{{what}}（新しい要求は即時拒否、視聴中の映像は 30 秒以内に停止）",
    "revoke_assign": "割り当てを取り消す",
    "revoke_node_admin_intro": "ノード管理者を取り消す前に、その人が付与した有効な割り当てを確認し、あわせて取り消せます。チェックしないものは有効なままです。",
    "revoked": "取り消しました",
    "steps": "手順",
    "step_who": "対象",
    "step_role": "役割",
    "step_term": "期限 / 時間帯",
    "step_confirm": "確認",
    "assign_title": "「{{node}}」で割り当て",
    "assign_edit_title": "{{name}} の割り当てを編集",
    "assign_d_title": "「{{path}}」を自組織のメンバーに割り当て",
    "who": "人またはメンバーグループ",
    "who_search": "人・メンバーグループを検索",
    "d_node_label": "ノード（委任サブツリー内、子ノードも選択可、名前と件数のみ）",
    "covers_now": "現在 {{homes}} か所、{{devices}} 台をカバー（構成上の合計）。",
    "covers_subtree": "このノードのサブツリー内のすべての場所をカバー。",
    "covers_tail": "今後追加されたものもカバーします。継承をブロックした子ノードは対象外です。",
    "effective_now": "実際に有効：{{what}}",
    "not_effective": "有効にならない：{{what}}",
    "not_effective_paren": "（有効にならない：{{what}}）",
    "out_of_scope": "委任範囲外：{{what}}",
    "ignored_box": "「{{role}}」には「{{what}}」が含まれますが、{{from}} は委任していないため、この部分は有効になりません。",
    "pick_template": "テンプレートを選択（テンプレートの操作が適用）",
    "assign_done": "割り当てました。",
    "assign": "割り当て",
    "assign_self": "自分を割り当て",
    "self_yellow": "これにより「{{scope}}」の映像（録画を含む）を見られるようになります。",
    "self_notify_others": "他の組織管理者とオーナーに通知され、監査に記録されます。",
    "self_notify_owner": "オーナーに通知され、監査に記録されます。",
    "self_notify_audit_only": "監査に記録されます。",
    "self_notify_d": "{{from}} のオーナーと管理者にも通知されます。",
    "self_suggest_term": "期限の設定をおすすめします。",
    "reason_needed_self": "これにより自分にアクセスが付与されます（自己付与）。理由を入力してください。",
    "d_visible_to_delegator": "{{from}} は割り当て先の表示名、役割、操作履歴を確認できます。",
    "member_groups": "メンバーグループ",
    "member_groups_hint": "メンバーグループはノード割り当ての対象専用です（例：夜間警備）。1 階層でネストなし。メンバー変更には再認証が必要で、割り当てのあるグループに自分を追加すると自己付与になります。",
    "group_new": "メンバーグループを作成",
    "no_groups": "メンバーグループはまだありません。",
    "group_name": "グループ名",
    "group_members": "メンバー",
    "group_used": "使用中",
    "group_edit_title": "メンバーグループを編集：{{name}}",
    "group_delete_title": "メンバーグループ「{{name}}」を削除しますか？",
    "group_delete_body": "このグループを使う割り当て {{n}} 件も無効になり、メンバーは 30 秒以内にそれらを経由した視聴が停止します。",
    "group_delete": "グループを削除",
    "self_group_yellow": "割り当て {{n}} 件のあるグループに自分を追加するため、それらのノードの映像を見られるようになります。",
    "dlg_out": "外部への委任",
    "dlg_in": "自組織への委任",
    "dlg_out_of": "外部への委任（{{org}}）",
    "dlg_in_of": "自組織への委任（{{org}}）",
    "no_dlg_out": "他組織への委任はまだありません。",
    "no_dlg_in": "他組織からの委任はまだありません。",
    "dlg_scope": "範囲",
    "dlg_forever_short": "無期限",
    "dlg_new_by_code": "相手の委任コードで追加",
    "still_needed": "引き続き必要",
    "reviewed": "確認済み：{{org}} への委任は引き続き必要",
    "tag_review": "見直し待ち",
    "tag_expiring": "まもなく期限",
    "tag_suspended": "一時停止",
    "tag_ended": "終了",
    "delegator_paren": "（委任者：{{name}}）",
    "dlg_mfa_note": "{{from}} は 2 段階認証が必須：割り当てられたメンバーも有効にする必要があります",
    "expandable": "範囲が拡大：{{n}} 件の割り当てを拡大できます",
    "apply_ellipsis": "適用…",
    "assign_members": "メンバーを割り当て",
    "gen_code": "委任コードを発行",
    "gen_code_hint": "コード・QR・リンクを委任元の組織に渡します。7 日間有効で 1 回限りです。",
    "code_note": "メモ",
    "code": "委任コード",
    "code_qr": "委任コードの QR",
    "code_valid": "{{date}} まで有効",
    "my_codes": "発行したコード",
    "code_expires": "{{date}} に失効",
    "code_cancel": "取り下げ",
    "dlg_new_title": "委任を追加",
    "wz_code": "コード",
    "wz_nodes": "ノード",
    "wz_scope": "範囲と期限",
    "wz_confirm": "確認",
    "dlg_code_input": "相手の委任コード",
    "dlg_code_hint": "相手が「自組織への委任」で発行したコードです。知っている相手からのものか確認してください。",
    "requested_by": "依頼者：{{name}}（{{domain}}）",
    "unverified_warn": "この組織はプラットフォームの審査を受けていません。知っている相手からのコードか確認してください",
    "single_home_hint": "1 か所だけ委任する場合：ノードを作成してその場所を移し、そのノードを委任します。",
    "scope_view": "視聴（ライブ映像）",
    "scope_event_read": "イベント",
    "scope_recording_read": "再生",
    "scope_alarm_receive": "アラーム対応",
    "scope_media_talk": "通話",
    "scope_device_control": "操作",
    "scope_security_arm": "遠隔警戒開始",
    "scope_security_disarm": "遠隔警戒解除",
    "scope_device_maintain": "保守（ファームウェア更新、再起動、名前変更）",
    "scope_home_profile_read": "$t(leaf.cur)情報（住所、タイムゾーン、地図、平面図）",
    "scope_recording_export": "録画のダウンロード / エクスポート",
    "dlg_fixed_1": "登録解除・フォーマット・権限・ノード構成は常に委任元に残ります。",
    "dlg_fixed_2": "相手の API / Webhook ではこれらのデバイスは取得できません（相手のメンバーアカウントのみ）。",
    "dlg_fixed_3": "自組織の 2 段階認証の要件は相手のメンバーにも適用されます。IP 許可リストと無操作タイムアウトは適用されません。",
    "dlg_forever": "無期限（12 か月ごとに双方へ見直しを通知）",
    "dlg_until": "期限日（30 / 7 日前に通知）",
    "dlg_history": "履歴",
    "dlg_history_now": "委任開始以降のみ",
    "dlg_history_back": "さかのぼる（最大 30 日）",
    "days_back": "日前から",
    "history_days_one": "{{count}} 日前から",
    "history_days_other": "{{count}} 日前から",
    "history_since": "{{date}} から",
    "dlg_notify": "作成後、{{from}} のオーナーと全組織管理者、{{to}} のオーナーと管理者に通知されます",
    "dlg_self_related": "あなたは {{to}} のメンバーでもあるため、自己付与と同様に扱われます。理由が必須で、監査に記録されます。",
    "dlg_create": "委任を作成",
    "dlg_created": "{{org}} に委任しました",
    "dlg_detail_out": "{{org}} への委任",
    "dlg_detail_in": "{{org}} からの委任",
    "edit_scope": "範囲を編集",
    "extend_term": "延長 / 期限設定",
    "revoke_dlg": "委任を取り消す",
    "end_dlg": "委任を終了",
    "end_dlg_title": "{{from}} からの委任を終了しますか？",
    "end_dlg_body": "この委任経由のメンバーのアクセスは即時停止し（映像は 30 秒以内）、この委任での割り当ても無効になります。双方の監査に記録されます。",
    "created_reviewed": "作成 / 見直し",
    "expanded_at": "{{date}} に拡大",
    "reviewed_at": "前回の見直し {{date}}",
    "created_by": "作成者 {{name}}",
    "policy": "適用されるポリシー",
    "policy_mfa": "{{from}} は 2 段階認証が必須（IP 許可リスト・無操作タイムアウトは適用外）",
    "policy_none": "追加の要件なし",
    "grantees_title": "{{org}} の割り当て先（読み取り専用）",
    "no_grantees": "相手はまだメンバーを割り当てていません。",
    "via_group": "グループ {{ref}} 経由",
    "recent_ops": "過去 30 日間のこの委任経由の操作：{{n}} 件",
    "open_audit": "監査を表示",
    "my_assignments_title": "自組織の割り当て",
    "no_d_assignments": "まだメンバーを割り当てていません。",
    "can_expand": "拡大可",
    "delegator_sees_list": "{{from}} はこの一覧を閲覧できます（表示名、役割、実際に有効な操作、ノード、期限。メールアドレスは含まない）",
    "revoke_dlg_title": "{{org}} への委任を取り消しますか？",
    "will_lose": "{{org}} が失うもの（割り当て先 {{n}} 人）",
    "revoke_dlg_note": "送信後 {{org}} のオーナーと管理者に通知され、メンバーには「委任が終了しました」と表示されます。",
    "dlg_revoked": "{{org}} への委任を取り消しました",
    "edit_scope_title": "{{org}} への委任範囲を編集",
    "extend_term_title": "{{org}} への委任期限",
    "edit_dlg_hint": "縮小は即時反映され相手に通知されます。拡大は相手の同意不要で、相手の既存の割り当ては「適用」するまで拡大されません。",
    "save_scope": "範囲を保存",
    "save_term": "期限を保存",
    "dlg_updated": "委任を更新しました",
    "apply_title": "{{from}} が拡大した範囲を適用",
    "apply_hint": "{{from}} が委任範囲を拡大しました。適用するまで変わりません。拡大する割り当てを選んでください。",
    "apply_n": "{{n}} 件を適用",
    "applied": "{{n}} 件の割り当てに適用しました",
    "d_revoke_title": "「{{where}}」の {{who}} の割り当てを取り消しますか？",
    "d_revoke_lose": "失う操作：{{what}}",
    "d_revoke_streams": "現在この割り当て経由で視聴中：{{n}} 人（30 秒以内に停止）",
    "d_revoke_notify": "デバイス異常の通知は次回から送られません。",
    "d_revoke_yellow": "{{from}} の委任詳細の一覧から外れ、双方の監査に記録されます。",
    "err_rate_limited_one": "プレビューが多すぎます。{{count}} 秒後にお試しください",
    "err_rate_limited_other": "プレビューが多すぎます。{{count}} 秒後にお試しください",
    "err_depth": "ノードは最大 {{n}} 階層です",
    "err_limit": "上限（{{n}}）に達しました",
    "err_busy": "組織ツリーを更新中です。しばらくしてからもう一度お試しください",
    "err_not_empty": "ノード配下にまだ {{homes}} か所、子ノード {{nodes}} 件があります。先に移動してください",
    "err_team_org": "ノード割り当てと委任はチーム組織のみ利用できます",
    "err_use_node_assignment": "「拠点管理者」テンプレートは廃止されました。ノード割り当てを使ってください",
    "err_code_gone": "委任コードは期限切れ・取り下げ・使用済みです。新しいコードを依頼してください",
    "err_scope_exceeded": "この役割は委任範囲と重なりがないため、割り当てても効果がありません",
    "err_cycle": "ノードを自分の配下に移動することはできません",
    "err_out_of_anchor": "新しいノードの範囲外にあるデバイスがあります。先にデバイスの位置を調整してください",
    "err_exceeds_actions": "自分の権限を超える操作は付与できません",
    "err_exceeds_expires_at": "期限は自分の割り当てを超えられません",
    "err_exceeds_schedule": "時間帯は自分の割り当てを超えられません",
    "err_preview_stale": "プレビュー後に変更がありました。もう一度プレビューしてください",
    "err_home_assigned": "選択に管理人が指定済みの場所が含まれています。未割り当ての場所のみ選択できます",
    "err_conflict": "同じ委任または設定がすでにあります",
    "err_history_max_one": "さかのぼれるのは最大 {{count}} 日です",
    "err_history_max_other": "さかのぼれるのは最大 {{count}} 日です",
    "err_root_node": "組織全体にはこの操作はできません",
    "err_invalid": "入力内容が正しくありません",
    "err_forbidden_self_modify": "自分の割り当ては変更・取り消しできません",
    "err_forbidden_inheritance_boundary": "継承をブロックしたサブツリーへの出し入れはオーナーと組織管理者のみ可能です",
    "err_forbidden_orgtree_not_open": "ノード割り当てと委任はこの組織ではまだ利用できません",
    "pair_joined_no_access": "追加しました。この場所の映像を見る権限はありません",
    "batch_mode": "まとめて移動 / 管理人を指定",
    "batch_mode_move": "まとめて移動",
    "select_done": "選択を終える",
    "select_hint": "処理する{{leaf}}にチェック",
    "struct_count_head": "数字 = この階層以下のデバイス総数（映像権限のないものを含む）",
    "site_tab_devices": "デバイス",
    "site_tab_access": "アクセスできる人",
    "site_tab_settings": "拠点の設定",
    "site_access_hint": "このノードの割り当て、上位からの継承（読み取り専用）、委任（読み取り専用）、$t(leaf.cur)の役割と共有がここにあります。",
    "maint_title": "保守",
    "block_short": "継承をブロック",
    "block_is_on": "オン",
    "block_is_off": "オフ",
    "archive_desc": "停止したノードはツリーに表示されなくなります。配下に場所や子ノードがあると停止できません。",
    "site_dev_count": "見られるのは {{n}} 台（この配下に {{homes}} か所）",
    "site_dev_name": "名前",
    "site_dev_model": "機種",
    "site_dev_status": "状態",
    "site_dev_home": "場所",
    "site_dev_online": "オンライン",
    "site_dev_offline": "オフライン",
    "site_dev_channels_one": "（{{count}} チャンネル）",
    "site_dev_channels_other": "（{{count}} チャンネル）",
    "site_dev_empty": "この配下にはまだデバイスがありません。",
    "site_dev_hidden": "映像権限のない場所が他に {{n}} か所あります（デバイスは表示しません）：{{names}}",
    "set_name": "名前と階層",
    "set_tz": "タイムゾーン",
    "set_tz_inherit": "上位と同じ（未設定）",
    "set_tz_hint": "時間帯制限・スケジュール・レポートに使います。未設定なら上位に従います。",
    "set_geo": "住所と座標",
    "set_address": "住所",
    "set_lat": "緯度",
    "set_lng": "経度",
    "set_geo_bad": "緯度と経度は両方とも数字で入力してください。",
    "set_saved": "保存しました。",
    "set_offline": "オフライン利用（ローカル VMS）",
    "set_offline_on": "インターネットが切れても、この拠点のパソコンはローカル VMS で Kinio Station のカメラを見られます",
    "set_offline_hours": "オフラインで使える最長時間（時間）",
    "set_offline_hint": "オンにすると、この拠点のメンバーは「マイアカウント › ローカル VMS」でパソコンを登録できます。チーム組織は最長 72 時間です。",
    "set_offline_saved_on": "オフライン利用をオンにしました。",
    "set_offline_saved_off": "オフライン利用をオフにしました。",
    "set_computers": "ローカル VMS に登録したパソコン",
    "set_computer_updated": "最終更新 {{date}}",
    "views_empty": "保存したビデオウォールのレイアウトと、自分で整理したカメラ一覧がここに入ります。ビデオウォールの［名前を付けて保存］や［レイアウトを作成］でここに保存されます。",
    "groups_empty": "グループはカメラの名簿です。シーケンス表示、通知の購読、ビデオウォールへの一括表示に使えます。",
    "layout_cells_one": "レイアウト · {{count}} 枠",
    "layout_cells_other": "レイアウト · {{count}} 枠",
    "layout_open_tip": "このレイアウトでビデオウォールを開く",
    "struct_totals2": "配下に {{nodes}} ノード、{{homes}} か所、{{dev}}（構成上の合計）",
    "struct_dev_incl_one": "{{count}} 台（チャンネル込み）",
    "struct_dev_incl_other": "{{count}} 台（チャンネル込み）",
    "struct_dev_split": "{{devices}} 台のデバイス、{{channels}} チャンネル",
    "struct_count_tip_incl": "構成上の合計（現在は NVR のチャンネルを含む）",
    "struct_count_tip_split": "構成上の合計（台。ほかに {{channels}} チャンネル）",
    "struct_count_head_incl": "。現在は NVR のチャンネルを含みます",
    "set_autosave": "変更は欄を離れると自動保存されます（保存ボタンは不要です）。",
    "you_can_view_wall": "この範囲には {{n}} 画面あり、そのうち {{x}} 画面をウォールに表示中",
    "tree_btn": "組織ツリー",
    "you_can_view_wall_paged": "この範囲には {{n}} 画面：このページに {{x}}、次のページにあと {{rest}}",
    "home_devices": "デバイス {{count}} 台（構成上の合計）",
    "home_delete": "この{{leaf}}を削除",
    "home_delete_desc": "デバイスは外されて工場出荷時の設定に戻り、録画とイベントも削除されます。元に戻せません。",
    "home_delete_title": "「{{name}}」を削除しますか？",
    "home_delete_warn_n": "この{{leaf}}の {{count}} 台のデバイスは外され、工場出荷時の設定に戻ります。",
    "home_delete_warn_empty": "この{{leaf}}にはデバイスがありません。",
    "home_delete_tail": "録画とイベントは削除され、メンバーに通知されます。元に戻せません。",
    "home_delete_archives_n": "この{{leaf}}には長期保管中のエクスポートパッケージが {{count}} 件あります（最長 {{date}} まで保管）。一緒に削除され、支払い済みの保管料金は返金されません。",
    "home_delete_archives_n_nodate": "この{{leaf}}には長期保管中のエクスポートパッケージが {{count}} 件あります。一緒に削除され、支払い済みの保管料金は返金されません。",
    "home_delete_archives_unknown": "この{{leaf}}に長期保管中のエクスポートパッケージがある場合は一緒に削除され、支払い済みの保管料金は返金されません。",
    "home_delete_action": "この{{leaf}}を削除（再認証が必要）",
    "home_deleting": "削除中…",
    "home_deleted": "「{{name}}」を削除しました",
    "err_home_unbind_failed": "一部のデバイスの登録解除に失敗したため、この{{leaf}}は削除されていません。しばらくしてからもう一度お試しください。",
    "err_home_not_found": "この{{leaf}}は存在しないか、表示する権限がありません。",
    "err_home_delete_forbidden": "削除できるのは組織のオーナー / 管理者またはこの{{leaf}}の管理人だけです。",
    "high_risk_badge": "高リスク：理由が必要",
    "high_risk_reason_note": "（高リスクの委任：理由が必要、送信するとすぐ有効）",
    "reason_required_body": "高リスクの委任（組織全体・エクスポート・警戒解除）を広げます：理由を入力してください。送信するとすぐ有効になり、双方のオーナーと管理者に通知されます。",
    "err_high_risk_reason": "高リスクの委任には理由が必要です",
    "dlg_notify_high_risk": "高リスクの委任：送信するとすぐ有効になります。{{from}} のオーナーと全組織管理者、{{to}} のオーナーと管理者に通知されます（作成者と理由つき）",
    "local_playback_full": "ローカル録画（SD カード / HDD）を再生できる（共有・割り当て前の録画を含む）",
    "local_playback_full_hint": "オンにすると、この人は共有・割り当て前の録画を含め、デバイス内のすべてのローカル録画を再生できます。クラウド録画とイベントは従来どおり開始時点以降のみです。組織のオーナーまたは管理者だけが変更できます。",
    "lpf_on": "はい",
    "lpf_off": "いいえ",
    "hm_title": "メンバー",
    "hm_you": "（あなた）",
    "hm_default_role": "組織のロールに従う",
    "hm_add": "メンバーを追加",
    "hm_pick": "組織のメンバーを選択",
    "hm_add_submit": "追加",
    "hm_no_candidates": "追加できる組織のメンバーがいません",
    "hm_added": "{{name}} を{{role}}として追加しました",
    "hm_role_changed": "{{name}} を{{role}}に変更しました",
    "hm_remove": "外す",
    "hm_remove_title": "{{name}} を「{{home}}」から外しますか？",
    "hm_remove_body": "{{name}} はこのホームのデバイスを見られなくなります。組織のメンバーのままです。",
    "hm_removed": "{{name}} を外しました"
  },
  "aiLocal": {
    "title": "分析の担当",
    "help": "カメラごとに AI 分析をどこで行っているかを表示します。ローカル AI（AI box、NVR、Kinio Station PC 版）に割り当てたカメラは、既定でクラウド AI の対象外となり、クラウドの回数を消費しません。",
    "local_too": "ローカルとクラウドの両方で分析",
    "local_too_help": "ローカル AI に割り当てたカメラもクラウド AI に送ります（クラウドの回数を消費します。オンにするには再認証が必要です）",
    "col_camera": "カメラ",
    "col_analyzer": "分析元",
    "col_detail": "詳細",
    "who_local": "ローカル AI",
    "who_cloud": "クラウド AI",
    "who_both": "ローカル + クラウド",
    "who_none": "なし",
    "offline": "ローカル AI がオフラインのため、イベントは今は分析されません",
    "excluded": "クラウド AI から除外済み",
    "status_pending": "適用中",
    "status_running": "実行中",
    "status_degraded": "負荷軽減中",
    "status_unreachable": "映像を取得できません",
    "status_rejected": "プロバイダーが拒否",
    "who_unknown": "確認できません",
    "providers_failed": "この$t(leaf.cur)のローカル AI の状態を読み込めません",
    "not_queried": "この$t(leaf.cur)のローカル AI の状態は表示できません（共有された$t(leaf.cur)）",
    "cloud_failed": "クラウド AI の同意または使用量を読み込めません",
    "status_starting": "起動中",
    "status_detector_error": "検出器エラー",
    "status_other": "状態：{{status}}"
  },
  "poeports": {
    "intro": "この Station の各 PoE ポートの給電と接続デバイスです。報告されていない値は「不明」と表示します。",
    "none": "この Station は PoE ポートを報告していません。",
    "unknown": "不明",
    "col_port": "ポート",
    "col_power": "給電",
    "col_meas": "測定値",
    "col_link": "リンク",
    "col_devices": "接続デバイス",
    "col_actions": "操作",
    "st_disabled": "オフ",
    "st_powered": "給電中",
    "st_idle": "給電なし",
    "class": "クラス",
    "temp": "温度",
    "link_up": "接続",
    "link_down": "未接続",
    "not_home": "この$t(leaf.cur)のチャンネルに対応していません",
    "macs_more": "ほかにもデバイスがあります（先頭 4 台のみ表示）",
    "act_on": "給電をオン",
    "act_off": "給電をオフ",
    "act_cycle": "給電を再投入",
    "confirm_on": "ポート {{port}} の給電をオンにしますか？",
    "confirm_off": "ポート {{port}} の給電をオフにしますか？",
    "confirm_cycle": "ポート {{port}} の給電を再投入しますか？",
    "confirm_body": "このポートのデバイスは電源が切れます。カメラは再起動が終わるまで録画を停止します。",
    "sending": "送信中…",
    "done": "ポート {{port}} に適用しました。",
    "not_persistent": "オフにしたポートは Station の再起動後に給電が戻ります。",
    "err_FORBIDDEN": "PoE ポートの操作には保守権限が必要です。",
    "err_UNSUPPORTED_COMMAND": "この Station は PoE ポート操作に対応していません。",
    "err_BAD_PARAMS": "ポート番号が正しくありません。",
    "err_HAL_ERROR": "Station に適用できませんでした。もう一度お試しください。",
    "err_DEVICE_OFFLINE": "Station がオフラインです。",
    "err_COMMAND_TIMEOUT": "Station が応答しません。しばらくしてからポートの状態を確認してください。",
    "err_other": "失敗しました（{{code}}）。"
  },
  "apikeys": {
    "title": "API キー",
    "count": "{{n}} / {{limit}}",
    "hint": "キーはあなた本人を表します。Claude がこのキーで行う操作は、あなたがここで行うのと同じ扱いで、あなたの名前で記録されます。キーをチャット、コード、ドキュメントに貼らないでください。漏れた場合はすぐに取り消してください。ここのキーは VMS（Kinio Node / Station を含む）専用です。develop portal 用は portal で別に作成してください。",
    "created": "「{{name}}」を作成しました——キーはこの一度だけ表示されます：",
    "copy": "コピー",
    "setup_hint": "パソコンのターミナル（macOS は「ターミナル」、Windows は PowerShell）でこの 1 行を実行すると、Claude に Kinio VMS が追加されます（インストール不要）。Claude のチャットには貼り付けないでください。キーがチャット履歴に残ります：",
    "saved": "保存しました",
    "name": "名前",
    "name_placeholder": "例：ノート PC の Claude",
    "scopes": "範囲",
    "last_used": "最終使用",
    "expires": "有効期限",
    "never_used": "未使用",
    "revoke": "取り消す",
    "revoke_confirm": "「{{name}}」を取り消しますか？このキーを使う Claude は 5 分以内に呼び出せなくなります。",
    "revoke_all": "すべて取り消す",
    "revoke_all_confirm": "{{n}} 個のキーをすべて取り消しますか？5 分以内にすべて無効になります。",
    "revoked": "取り消し済み",
    "expired": "期限切れ",
    "empty": "キーを作成すると、Claude があなたの権限でデバイス・イベント・アラームを確認できます。",
    "need_mfa": "API キーを作成する前に 2 段階認証（認証アプリまたはパスキー）を有効にしてください。",
    "create": "キーを作成",
    "days_one": "{{count}} 日",
    "days_other": "{{count}} 日",
    "limit_hint": "キーでできることは、常に今のあなたの権限を超えません。チーム組織では管理者がセキュリティポリシーで API キーを許可する必要があります。作成・スコープ変更・ローテーション・取り消しには 5 分以内の再認証が必要です。",
    "media_confirm": "理解しました：Claude がこれらのデバイスの画像と録画クリップを自分のパソコンにダウンロードできます（毎回記録されます）",
    "console_confirm": "理解しました：AI アシスタントやツールが Kinio Node につながったデバイスのシリアルポートを読み書きできます",
    "control_confirm": "理解しました：AI アシスタントやツールが自分として、権限のあるデバイスを操作し設定を変更できます（Kinio Node のコマンドと Kinio Station のローカル設定を含む）",
    "pairing_confirm": "理解しました：Claude やツールが、リンクした開発者アカウントの枠で「ペアリング時に AID を割り当てる」ペアリングを開始できます（DEV クラウドのみ）",
    "scope_devices_read": "デバイス",
    "scope_devices_read_hint": "デバイス、$t(leaf.cur)と組織ツリー、状態と設定、OTA 状態、Kinio Node / Station",
    "scope_events_read": "イベントとアラーム",
    "scope_events_read_hint": "イベント一覧、アラームと対応状況",
    "scope_recordings_read": "録画タイムライン",
    "scope_recordings_read_hint": "録画がある時間帯（映像は含まない）",
    "scope_alarms_handle": "アラーム対応",
    "scope_alarms_handle_hint": "アラームを確認済み / 対応中 / 解決済み / 誤報にする",
    "scope_devices_console": "Kinio Node コンソール",
    "scope_devices_console_hint": "Kinio Node につながったデバイスのシリアルポートの読み書き（書き込みは管理者の役割が必要）、LAN 直結トークンを含む",
    "scope_devices_control": "デバイスの操作・設定変更",
    "scope_devices_control_hint": "自分として、デバイスのオン / オフ、PTZ、録画設定、自動化、Kinio Node のコマンド、Kinio Station のローカル設定（自分の役割の範囲で）。削除、初期化、フォーマットなどデータを消す操作はできません",
    "scope_pairing_allocate": "ペアリング時の AID 割り当て（開発環境のみ）",
    "scope_pairing_allocate_hint": "リンクした開発者アカウントの枠で、DEV の$t(leaf.cur)に「ペアリング時に AID を割り当てる」ペアリングを開始します。デバイス側のペアリングは別途必要です",
    "scope_media_snapshot_read": "スナップショット",
    "scope_media_snapshot_read_hint": "イベントのスナップショット、最新のスナップショット、即時撮影、録画サムネイル（1 時間 60 枚まで）",
    "err_API_KEY_MFA_REQUIRED": "API キーを作成する前に 2 段階認証を有効にしてください。",
    "err_API_KEY_LIMIT": "有効なキーは 1 人 5 個までです。使わないキーを取り消してください。",
    "err_API_KEY_PROD_WRITE": "この環境のキーは読み取り範囲のみ設定できます。",
    "err_FEATURE_DISABLED": "この環境では API キーは提供されていません。",
    "err_default": "失敗しました（{{code}}）",
    "scope_media_clip_read": "録画クリップ",
    "scope_media_clip_read_hint": "最大 60 秒のクラウド録画のダウンロード URL（1 日最大 20 回・合計 10 分。エクスポート権限が必要）",
    "rotate": "ローテーション",
    "rotate_confirm": "「{{name}}」をローテーションしますか？同じ名前・スコープ・有効期間で新しいキーを作成します（表示は一度だけ）。古いキーは 24 時間後に無効になり、それまでは通常どおり使えます。",
    "rotated": "ローテーション済み",
    "rotated_until": "{{at}} に無効",
    "rotated_created": "「{{name}}」をローテーションしました——新しいキーはこの一度だけ表示されます：",
    "rotated_old_until": "古いキーは {{at}} まで通常どおり使えます。Claude を新しいキーに切り替えたら、一覧から古いキーを先に取り消せます。",
    "err_API_KEY_ROTATED": "このキーはすでにローテーション済みです。新しいキーを使ってください。",
    "edit_scopes": "スコープを変更",
    "edit_scopes_title": "「{{name}}」のスコープを変更",
    "edit_scopes_hint": "キーは変わらないので Claude の再設定は不要です。5 分以内に反映されます。",
    "save_scopes": "スコープを保存",
    "scopes_saved": "スコープを更新しました。Claude の再設定は不要で、5 分以内に反映されます。",
    "err_NOT_FOUND": "このキーは存在しないか、取り消し済み / 期限切れです。",
    "err_INVALID_ARGUMENT": "スコープが不正です。選び直してください。",
    "scope_devices_maintain": "名前の変更とファームウェア更新",
    "scope_devices_maintain_hint": "デバイス名の変更、ファームウェアの即時更新、自動更新設定の変更（保守権限が必要）",
    "maintain_confirm": "理解しました：AI アシスタントやツールがデバイス名を変更し、ファームウェアを即時更新できます（更新中は数分オフラインになります）",
    "scope_vms_organize": "VMS の整理",
    "scope_vms_organize_hint": "自分のレイアウト、ビュー、デバイスグループ、保存した検索、ブックマークと設定；$t(leaf.cur)の部屋、平面図と配置",
    "group_read": "読み取り",
    "group_media": "映像（既定はオフ）",
    "group_write": "書き込み（既定はオフ）"
  },
  "zed": {
    "snapshot_loading": "最新のスナップショットを読み込み中…",
    "live_connecting": "ライブ映像を読み込み中…",
    "no_snapshot": "スナップショットがありません。〔ライブを見る〕で映像を読み込みます",
    "live_unavailable": "ライブ映像を読み込めません。編集はできます",
    "snapshot_shown": "背景は最新のイベントスナップショットです",
    "view_live": "ライブを見る",
    "back": "戻る",
    "clear_all": "すべてクリア",
    "saving": "保存中…",
    "saved": "保存しました",
    "mode_full": "全画面",
    "mode_zones": "エリアを指定",
    "kept_hint": "描いた {{count}} 個のエリアは残ります。「エリアを指定」に戻すと使えます",
    "surface": "検知エリア編集",
    "zone_label": "エリア {{n}}",
    "delete": "エリア {{n}} を削除",
    "full_frame": "全画面",
    "count_one": "1 個のエリア",
    "count": "{{count}} 個のエリア",
    "limit_counter": "{{count}} / {{max}}",
    "read_only": "現在、検知エリアは変更できません。",
    "limit": "エリアは最大 {{max}} 個です",
    "reported_updated": "デバイスの報告に合わせて更新しました。",
    "hint": "空いている所をドラッグしてエリアを描きます。エリアを選ぶと移動、四隅のドラッグでサイズ変更、Delete で削除できます。",
    "hint_full": "全画面で検知：画面全体が対象です。範囲を絞るには「エリアを指定」を選びます。",
    "discard_title": "未保存の変更を破棄しますか？",
    "discard_body": "検知エリアの変更はまだ保存されていません。移動すると失われます。",
    "discard_body_schedule": "スケジュールの変更はまだ保存されていません。移動すると失われます。",
    "discard": "破棄",
    "tpl_all_day": "終日",
    "tpl_night": "夜間（18:00–06:00）",
    "tpl_office": "勤務時間（月〜金 09:00–18:00）",
    "tpl_clear": "クリア",
    "device_tz": "デバイスのタイムゾーン：{{tz}}",
    "read_only_schedule": "現在、スケジュールは変更できません。",
    "hint_schedule": "ドラッグで塗ります。オフのマスから始めるとオン、オンのマスから始めるとオフになります。1 マス 30 分です。",
    "sum_all_day": "終日",
    "sum_off": "オフ",
    "sum_custom": "カスタム",
    "edit": "編集",
    "view": "表示",
    "offline": "デバイスがオフラインのため、今は変更できません",
    "no_write": "この設定を変更する権限がありません",
    "load_failed": "デバイスの現在の検知エリア設定を読み込めないため、今は表示のみです。しばらくしてからもう一度開いてください",
    "layers": "レイヤー",
    "mask_off": "オフ",
    "mask_count_one": "マスク 1 個",
    "mask_count": "マスク {{count}} 個",
    "mask_mode_off": "オフ",
    "mask_mode_on": "オン",
    "mask_kept_hint": "描いたマスク {{count}} 個は残ります。「オン」に戻すと使えます",
    "mask_warn": "マスクはデバイス側でエンコード前に黒く塗りつぶされます。ライブ映像・録画・スナップショットのどれにも映らず、後から解除できません。マスク内では検知も行いません。",
    "mask_label": "マスク {{n}}",
    "mask_delete": "マスク {{n}} を削除",
    "mask_limit": "マスクは最大 {{max}} 個です",
    "mask_hint": "空いている所をドラッグして隠す範囲を描きます。マスクを選ぶと移動でき、四隅をドラッグしてサイズを変えられます。選んで Delete キーで削除します。",
    "mask_hint_off": "プライバシーマスクはオフです（何も隠しません）。隠すには「オン」を選んでください。",
    "read_only_masks": "現在プライバシーマスクは変更できません。",
    "discard_body_masks": "プライバシーマスクの変更はまだ保存されていません。移動すると失われます。",
    "grid_full_frame": "画面全体",
    "grid_custom": "一部の範囲",
    "grid_cells": "{{total}} マス中 {{count}} マスを検知",
    "grid_fill": "すべて選択",
    "grid_clear": "クリア",
    "grid_cell": "{{row}} 行 {{col}} マス目",
    "grid_hint": "マスをドラッグして塗ります。未選択のマスから始めると追加、選択済みのマスから始めると解除です。何も選ばない場合は画面全体を検知します。"
  },
  "poe": {
    "title": "新しいカメラ {{n}} 台がアドレスを要求しています",
    "new_camera": "新しいカメラを検出しました",
    "port": "PoE ポート {{port}}",
    "asked": "アドレス要求 {{count}} 回（初回 {{first}}、最終 {{last}}）",
    "suspect_uplink_ip": "このアドレスは上位ネットワークのデバイス（ルーターやパソコンなど）のようで、PoE ポートのカメラではない可能性があります。ワンクリックでは追加できません。追加する場合は理由を入力してください。",
    "suspect_uplink_arp": "上位ネットワークからこのデバイスが見えています（上位に接続されたデバイスの可能性があります）。ワンクリックでは追加できません。追加する場合は理由を入力してください。",
    "suspect_other": "PoE ポートのカメラではない可能性があります。ワンクリックでは追加できません。追加する場合は理由を入力してください。",
    "approve": "追加",
    "ignore": "無視",
    "force_reason": "強制追加の理由（5 文字以上）",
    "force": "強制追加",
    "waiting_ip": "承認しました。カメラがアドレスを取得するのを待っています（最大 2 分）…",
    "got_ip": "カメラがアドレス {{ip}} を取得しました。カメラのユーザー名とパスワードを入力してチャンネルに接続します。",
    "own_camera": "Kinio カメラです。NVR が自動でチャンネルに接続するので、パスワードは不要です。",
    "add_channel": "チャンネルに接続",
    "added": "チャンネルに接続しました。",
    "no_ip": "2 分以内にカメラがアドレスを取得しませんでした。ケーブルと電源を確認してから再試行してください。",
    "err_SUSPECT_UPLINK": "上位ネットワークのデバイスの可能性があります。理由を入力すると強制追加できます",
    "err_NOT_PENDING": "このデバイスはもう承認待ちではありません（ほかの人が処理した可能性があります）",
    "err_BAD_IP": "このアドレスは使えません（PoE ネットワーク外か、ほかのデバイスに割り当て済み）",
    "err_default": "操作に失敗しました（{{code}}）",
    "wait_again": "もう一度待つ",
    "block_title": "新しい PoE カメラ（開くと承認待ちを確認します）",
    "none": "承認待ちの PoE カメラはありません。",
    "unsupported": "このデバイスは PoE 承認に対応していません。「ONVIF カメラを追加」を使ってください。"
  },
  "moment": {
    "title": "同じ時刻",
    "help": "時刻を選ぶと、範囲内の各カメラのその時刻の映像を表示します。クラウド録画があればクラウドのサムネイル、なければ NVR ディスクまたは SD カードの映像です。タイルをクリックするとその時刻から再生します。",
    "at": "時刻",
    "browser_tz": "時刻はブラウザのタイムゾーン（{{tz}}）で選びます。各タイルの下はその拠点の現地時刻です",
    "filter": "カメラ名で絞り込み",
    "none": "この範囲に再生できるカメラはありません",
    "no_frame": "クラウド映像なし",
    "more": "ほかに {{n}} 台あります（一度に最大 {{max}} 台）。絞り込みか範囲の切り替えで減らしてください",
    "all_empty": "この時刻、これらのカメラの映像はありません（クラウド・NVR ディスク・SD カードのいずれからも取得できません）。時刻を変えるか、1 画面の再生で前後の録画を確認してください。",
    "go_single": "1 画面で再生",
    "clip_suspect": "⚠ クラウドクリップが不完全な可能性",
    "clip_suspect_hint": "この時刻のクラウドクリップは長さが不自然で、サムネイルが緑色や静止画の場合があります。再生ページでは他のソースを優先します。",
    "no_cloud_at": "この時刻のクラウド録画はありません",
    "from_local": "{{src}}の映像（この時刻のクラウド録画はありません）",
    "no_rec_at": "この時刻の録画はありません",
    "local_has": "{{src}}にこの時刻の録画があります（サムネイルなし）",
    "local_unknown": "クラウド録画なし。{{src}}を読み取れません（再生ページで確認）",
    "no_cloud_scope": "この範囲のカメラには直近 2 か月のクラウド録画がありません。ローカル録画（NVR / Station のディスク、SD カード）があるカメラはローカルの画面を表示します。"
  },
  "hnodes": {
    "intro": "この Host に接続された Kinio Node ボードです。電源・リセット・書き込みは Host を保有する組織の管理者が行います。",
    "none": "この Host にはノードが接続されていません。",
    "unknown": "不明",
    "col_node": "ノード",
    "col_health": "状態",
    "col_fw": "ファームウェア",
    "col_seen": "最終応答",
    "col_thing": "ノードのデバイス",
    "h_healthy": "正常",
    "h_busy": "使用中",
    "h_unhealthy": "異常",
    "h_unknown": "不明",
    "not_visible": "この$t(leaf.cur)にないか、権限がありません",
    "no_aid": "ノードの AID をまだ読み取っていません"
  },
  "localvms": {
    "tab": "ローカル VMS",
    "title": "ネット切断時のローカル VMS",
    "intro": "インターネットが切れても、この拠点の Station はブラウザでライブ映像と HDD 録画の再生を表示できます。各パソコンはオンライン中に一度登録してください。",
    "no_stations": "登録できる Station がありません。組織共有や委任で権限を得た拠点はクラウドでのみ表示できます。",
    "col_station": "レコーダー",
    "col_home": "$t(leaf.cur)",
    "col_offline": "オフライン利用",
    "not_allowed": "拠点で「オフライン利用」がオフです",
    "allowed": "オン",
    "max_hours": "最長 {{n}} 時間",
    "open_here": "このパソコンでローカル VMS を開く",
    "ask_admin": "—（組織管理者に拠点設定で有効にするよう依頼してください）",
    "not_ready": "ローカルアドレスを準備中です（Station がオンラインである必要があります）",
    "fixed_ip_hint": "ルーターで Station に固定アドレス（固定 IP）を割り当てておくと、予備アドレスが無効になりません。",
    "enrolled_title": "登録済みのパソコン",
    "enrolled_empty": "まだパソコンが登録されていません。",
    "col_computer": "パソコン",
    "col_updated": "最終更新",
    "col_expires": "有効期限",
    "fallback_update": "予備アドレスの更新が必要",
    "expired": "期限切れ",
    "expires_in": "あと {{n}} 日で期限切れ",
    "days_left": "残り {{n}} 日",
    "pin_locked": "PIN ロック中（{{until}} まで）",
    "reset_pin": "PIN を再設定",
    "redo": "再登録",
    "redo_unavailable": "この Station は今は登録できません（オフライン利用がオフ、またはローカルアドレスが未準備）",
    "revoke": "取り消す",
    "revoke_confirm": "「{{label}}」を取り消しますか？",
    "revoke_body": "このパソコンはオフライン時に「{{station}}」のローカル画面を開けなくなります。Station がオフライン中の場合は、オンラインに戻るかオフライン利用期限が来た時点で停止します。",
    "revoked": "「{{label}}」を取り消しました。",
    "pin_lock_hint": "PIN を何度も間違えると一時的にロックされます。オンライン時は〔PIN を再設定〕（本人確認が必要）ですぐ使えます。オフライン時は店舗の管理者が Station の画面で解除してください。",
    "pin_reset_done": "「{{label}}」の PIN を再設定しました。",
    "reset_pin_title": "「{{label}}」のローカル PIN を再設定",
    "reset_pin_body": "新しい PIN は Station がオンラインになると有効になり、誤入力回数はリセットされます。",
    "pin_label": "このパソコンのローカル PIN（6 桁、オフラインでのログイン時に入力）",
    "stepup_note": "次に本人確認（パスワード + 認証コード）を行います。",
    "pin_invalid": "PIN はちょうど 6 桁の数字にしてください。",
    "reset_pin_submit": "確認して再設定",
    "err_default": "完了しませんでした（{{code}}）。もう一度お試しください。",
    "err_REAUTH_REQUIRED": "完了するには本人確認が必要です。",
    "err_OFFLINE_NOT_ALLOWED": "この拠点は「オフライン利用」がオフです。",
    "err_CLOUD_REQUIRED": "この拠点はクラウドでのみ表示できます（組織共有 / 委任で権限を取得しています）。",
    "err_NOT_FOUND": "この登録が見つかりません。",
    "req_missing_title": "登録が見つかりません",
    "req_missing": "リンクが不完全です。「設定 › ローカル VMS」に戻ってやり直してください。",
    "back": "ローカル VMS 設定に戻る",
    "done_title": "このパソコンを登録しました",
    "done_body": "「{{station}}」のローカルタブに戻ると完了と表示されます。オフライン時はメインアドレス（ブックマーク済み）を開き、名前が解決できない場合は予備アドレス（表示のみ）を開いてください。",
    "expired_title": "この登録は期限切れです",
    "expired_body": "登録は 5 分以内に完了する必要があります。一覧に戻ってやり直してください。",
    "no_tab_title": "新しいタブでローカル画面が開きませんか？",
    "no_tab_body": "登録するには、このパソコンが「{{station}}」のローカルネットワーク（同じ店内ネットワーク）に接続されている必要があります。",
    "no_tab_continue": "新しいタブが開いている場合は、そちらで続けてください。",
    "waiting_title": "ローカル画面を待っています",
    "waiting_body": "新しいタブで「{{station}}」のローカル画面を開きました。そちらで完了すると、この画面は自動的に確認画面に切り替わります。",
    "popup_blocked": "ブラウザが新しいタブをブロックしました。〔もう一度開く〕を押してください。",
    "reopen": "もう一度開く",
    "confirm_title": "このパソコンでオフライン時も「{{station}}」を表示しますか？",
    "computer_name": "パソコン名",
    "computer_name_ph": "例：監視室 PC-1",
    "confirm_body": "オフラインで使える時間は拠点設定に従います。オンライン中はプラットフォームが毎日自動更新するため、このパソコンを起動しておく必要はありません。権限はこの$t(leaf.cur)でのあなたの役割に従います。このパソコンだけに紐付き、最長 30 日ごとに再登録が必要です。",
    "code_main": "照合コード（メインアドレス）：",
    "code_hint": "ローカルタブの表示と同じ場合のみ続行",
    "fallback_label": "予備アドレス：",
    "fallback_attached": "追加済み（表示のみ）",
    "fallback_waiting": "待機中",
    "fallback_hint": "名前が解決できないときに使います。オフラインでのログインにも下の PIN が必要です。確認時に「待機中」のままなら予備アドレスは登録されません。",
    "approve": "確認して登録",
    "with_fallback": "予備アドレス付き（表示のみ）",
    "pin_locked_plain": "PIN ロック中",
    "someone": "ユーザー …{{id}}",
    "home_title": "この$t(leaf.cur)のその他の登録",
    "home_hint": "$t(leaf.cur)のオーナーまたは管理者として、他の人がこれらの Station に登録したパソコンを取り消せます（そのパソコンのローカル VMS だけが停止し、相手のアプリには影響しません）。",
    "col_person": "登録者",
    "err_LOCAL_VMS_LIMIT": "この Station に登録できるパソコンの上限（{{limit}} 台）に達しました。使っていないパソコンを先に取り消してください。",
    "err_LOCAL_VMS_REQUEST_EXPIRED": "この登録は期限切れです（5 分）。最初からやり直してください。",
    "err_LOCAL_VMS_ALREADY_APPROVED": "この登録はすでに確認済みです。",
    "err_LOCAL_VMS_KEY_PENDING": "ローカルタブでこのパソコンの設定がまだ完了していません。ローカルタブで続けてください。",
    "err_LOCAL_VMS_ENROLLMENT_EXPIRED": "このパソコンの登録は期限切れです。再登録してください。",
    "err_INVALID_ARGUMENT": "パソコン名は必須（最大 64 文字）、PIN は 6 桁の数字です。",
    "not_allowed_short": "オフ",
    "not_allowed_banner_one": "{{count}} 台は拠点で「オフライン利用」がオフのため、まだ登録できません。組織管理者に「組織と拠点 › 拠点設定」でオンにしてもらってください。",
    "not_allowed_banner_other": "{{count}} 台は拠点で「オフライン利用」がオフのため、まだ登録できません。組織管理者に「組織と拠点 › 拠点設定」でオンにしてもらってください。"
  },
  "nenr": {
    "tab": "Kinio Node の登録",
    "title": "「{{name}}」の Kinio Node 登録",
    "just_now": "たった今",
    "min_ago": "{{n}} 分前",
    "hour_ago": "{{n}} 時間前",
    "quota_title": "登録枠",
    "no_quota": "この組織にはまだ Kinio Node の登録枠がありません。枠はプラットフォームが割り当てます。販売店またはプラットフォームにお問い合わせください。",
    "quota_line": "{{type}} 残り {{n}}",
    "alloc_line": "{{date}} 割り当て、残り {{n}}",
    "find_title": "ノードを探す",
    "find_help": "ノードのコンソールで enroll_status を実行し、行全体か fp= の後ろの 16 文字を貼り付けてください。",
    "enroll_url": "このプラットフォームの登録 URL：{{url}}",
    "find_placeholder": "state=pending url=… keypwd=1 … fp=…",
    "find": "検索",
    "name_hint": "ノードの Wi-Fi / Bluetooth 名は MAC の末尾 6 文字だけなので使えません。",
    "bad_fp": "fp= の後ろの 16 桁の 16 進数が見つかりません。",
    "wrong_platform": "このボードは別のプラットフォームに登録しています。コンソールで fac_set enroll を使って {{url}} に変更してください。",
    "not_found": "登録できるノードが見つかりません",
    "check_fp": "fp= の後ろの 16 文字（または enroll_status の行全体）を貼り付けた",
    "check_pending": "ノードがまだ登録中（enroll_status が state=pending）",
    "check_url": "ノードの url= がこのプラットフォームの登録 URL {{url}}",
    "check_quota": "この機種の登録枠がこの組織にある",
    "contact": "見つからない場合はプラットフォームに連絡してください：指紋先頭 8 文字 {{fp8}}、時刻 {{at}}。",
    "fw": "ファームウェア",
    "last_seen": "最終チェックイン",
    "maybe_offline": "ノードはオフラインかもしれません",
    "mac_conflict": "同じ MAC で登録が 2 件あります。プラットフォームに連絡してください。",
    "keypwd_missing": "ボードに登録パスワードが未設定です：先にコンソールで fac_set keypwd … を実行してください。",
    "identify": "点滅",
    "identify_waiting": "ノードのチェックイン待ち（約 1 分以内）。白色で 30 秒点滅します",
    "identify_blinking": "白色で点滅中（30 秒）",
    "identify_missed": "ノードが 90 秒以内にチェックインしませんでした。オフラインかもしれません",
    "approve": "登録…",
    "approve_title": "Kinio Node を登録",
    "alloc": "使用する割り当て",
    "alloc_pick": "選択",
    "note": "メモ（任意）",
    "note_placeholder": "1 行、200 文字以内。メール・電話・住所は書かない",
    "note_bad": "メモは 1 行、200 文字以内です",
    "approve_explain": "「{{name}}」の登録枠を 1 つ使い（残り {{n}}）、このボードは「{{name}}」の所有になります。自分では取り消せません。間違えた場合はプラットフォームに連絡してください。",
    "confirm": "このボードが当組織のものだと確認しました（指紋はボードのコンソールから読んだ、または点滅を確認した）",
    "approve_do": "登録",
    "wait_online": "登録しました。ノードのオンラインを待っています（次のチェックイン、約 1 分以内に ID を受け取ります）",
    "now_online": "オンライン",
    "not_online_long": "ノードがまだオンラインになりません。ボードに書き込んだ登録パスワード（keypwd）がこの割り当てと合っていない可能性があります。プラットフォームに連絡してください。",
    "approved_title": "この組織で登録済み",
    "approved_empty": "まだ登録したノードはありません。",
    "col_at": "登録日時",
    "col_model": "機種",
    "col_by": "登録者",
    "col_note": "メモ",
    "col_state": "状態",
    "by_member": "メンバー",
    "by_platform": "プラットフォーム",
    "online": "オンライン",
    "last_online": "最終オンライン {{at}}",
    "revoked": "停止済み",
    "revoked_hint": "プラットフォームが取り消した後、ボードのコンソールで fac_cred clear を実行して再起動すると、再びチェックインします。",
    "pair_hint": "$t(leaf.cur)に追加するには、アプリのローカルネットワークペアリングで$t(leaf.cur)に加えてください。",
    "err_gone": "このノードは現在登録できません（登録済みかプラットフォームで処理済みの可能性）。もう一度検索してください。",
    "err_lookup_limit": "見つからない検索が多すぎます。{{at}} 以降に再試行してください。",
    "err_daily_cap": "24 時間以内に 100 台登録しました。{{at}} 以降に再試行するか、組織管理者に依頼してください。",
    "err_no_quota": "この割り当ては使い切りました。別のものを選ぶかプラットフォームに申請してください。",
    "err_alloc": "この割り当てはこのノードに使えません。",
    "err_mac_in_use": "この MAC はすでに別の有効なデバイス ID に属しています。プラットフォームに連絡してください。",
    "err_forbidden": "権限が変更されました。ページを再読み込みしてください。",
    "err_unavailable": "現在登録できません。しばらくしてから再試行してください。"
  },
  "ncon": {
    "close": "閉じる",
    "status_idle": "未接続",
    "status_ticket": "チケット取得中…",
    "status_connecting": "接続中…",
    "status_opening": "デバイスの応答待ち…",
    "status_open": "接続済み",
    "status_reconnecting": "デバイス再接続中…",
    "status_closed": "切断",
    "reason_device_offline": "デバイスがオフライン",
    "reason_data_lost": "途中のデータを復元できませんでした",
    "reason_session_superseded": "新しい接続に置き換えられました（ファームウェアが再開に未対応）",
    "reason_device_revoked": "デバイスは失効しています",
    "reason_DEVICE_OFFLINE": "デバイスがオフラインです。オンラインになってから再試行してください",
    "reason_RATE_LIMITED": "試行が多すぎます。しばらくして再試行してください",
    "reason_NOT_FOUND": "このデバイスへのアクセス権がありません",
    "reason_NOT_SUPPORTED": "このデバイスはターミナルに対応していません",
    "reason_NETWORK": "Kinio に接続できません",
    "role_me": "入力できます",
    "role_other": "他の人が入力中です（閲覧のみ）",
    "role_none": "入力中の人はいません",
    "take": "書き込み権を取得",
    "release": "書き込み権を手放す",
    "lost": "切断中に {{n}} バイトを失いました。",
    "rebooted": "デバイスが再起動しました。",
    "dropped": "ネットワークが遅く、出力 {{n}} 件が欠落しました。",
    "in_dropped": "デバイスが受け取れず、入力 {{n}} バイトが届きませんでした。",
    "err_NOT_WRITER": "書き込み権がありません",
    "err_RATE_LIMITED": "入力が速すぎます。しばらくして再送してください",
    "err_DEVICE_RECONNECTING": "デバイス再接続中です。しばらくして再送してください",
    "input_ro": "書き込み権を取ると入力できます（キーは送信されません）",
    "title": "ターミナル",
    "via_platform": "Kinio プラットフォーム経由",
    "auto_reconnect": "接続が切れました。自動で再接続します",
    "clear": "クリア",
    "reconnect": "再接続",
    "popout": "新しいウィンドウ",
    "tunnel": "接続コマンドをコピー",
    "tunnel_hint": "お使いのターミナルでこの行を実行してください。nodectl が経路を自動で選びます：Kinio Node と同じ LAN なら直接、別のネットワークなら Kinio プラットフォーム中継。Ctrl-] で終了。",
    "tunnel_step_download": "nodectl の入手：develop portal〔プラットフォームツール〕の Kinio Node パッケージ（macOS、Linux、Windows）。",
    "tunnel_step_key": "キー：自分の VMS キーを環境変数 KINIO_VMS_KEY に設定。キーの範囲で「Kinio Node LAN コンソール」を有効に。",
    "tunnel_key_link": "API キーへ",
    "tunnel_step_writer": "Web ターミナルを同時に開いている場合、Web 側の書き込み権は通常どおり。nodectl の直接接続は書き込み権を経由しません。",
    "copy": "コピー",
    "copied": "コピーしました",
    "direct": "上級者向け：自分のツールで直接接続",
    "direct_hint": "自分のツールでこの Kinio Node に直接つなぐ場合だけ使います：短期の直接接続トークンと LAN アドレス（8788、kttl/2）を取得。通常は Web ターミナルか上の nodectl コマンドで十分です（経路は自動）。",
    "direct_confirm": "トークンを持つ人はこの Kinio Node に接続されたデバイスのシリアルポートを読み書きできることを理解しました",
    "direct_get": "直接接続トークンを取得",
    "direct_addr": "LAN アドレス",
    "direct_token": "トークン",
    "direct_no_lan": "ノードが LAN アドレスを報告していません。プラットフォーム経由で接続してください（nodectl ttl は自動で中継）",
    "direct_token_once": "表示は一度だけ（{{id}}）、{{at}} に期限切れ",
    "reason_FIRMWARE_UNSUPPORTED": "ノードのファームウェアが古すぎます（1.0.52 以上が必要）",
    "connect_ro": "接続（読み取り専用）",
    "intro": "この Kinio Node に接続されたデバイスのシリアルコンソール（root shell）です。設置・開発用です。接続すると他の人が入力しているコマンドと出力が見えます。まず読み取り専用で接続し、入力するときに書き込み権を取得します。",
    "take_ellipsis": "書き込み権を取得…",
    "take_confirm_title": "{{name}} のシリアルコンソールにコマンドを入力しますか？",
    "take_confirm_body": "入力した内容はそのままデバイス（root）に送られます。他に接続している人は読み取り専用になります。",
    "take_confirm_others": "現在ほかの人が接続中です。入力中の人から書き込み権を引き継ぎます。",
    "others_n_one": "ほかに {{count}} 人が接続中",
    "others_n_other": "ほかに {{count}} 人が接続中",
    "need_admin": "入力できるのは管理者（組織管理者、ノード管理者、設置技術者、または$t(leaf.cur)のオーナー / 管理者）だけです。出力は見られます。",
    "write_forbidden": "あなたの役割ではこのデバイスに入力できません。管理者（組織管理者、ノード管理者、設置技術者、または$t(leaf.cur)のオーナー / 管理者）が必要です。読み取り専用に戻しました。",
    "reason_FORBIDDEN": "直接接続トークンは管理者だけが取得できます（このデバイスに入力できるため）"
  },
  "devacct": {
    "tab": "開発者アカウント",
    "title": "開発者アカウント",
    "hint": "開発者ポータルの開発者アカウントをこのアカウントにリンクします。開発者ポータルの［アプリアカウントのリンク］で発行した 8 文字のコードを入力してください。リンク後、開発者アカウントは自分の AID 枠でこのアカウントにデバイスをペアリングできますが、映像・イベント・録画は見られません。",
    "code_label": "リンクコード（8 文字）",
    "next": "次へ",
    "where": "開発者ポータル：アカウントとセキュリティ › アプリアカウントのリンク › リンクコードを発行。",
    "where_dev": "DEV の開発者ポータル：アカウントとセキュリティ › アプリアカウントのリンク › リンクコードを発行（10 分間有効・1 回のみ）。",
    "confirm_title": "この開発者アカウントをリンクしますか？",
    "confirm_who": "{{email}}（開発者アカウント）がこのアカウントへのリンクを求めています。両方とも自分のアカウントの場合のみ確認してください。他人から送られたコードは確認しないでください。",
    "confirm_can_dev": "リンク後、この開発者アカウントは次のことができます：自分の AID 枠で AID 未書き込みのデバイスをこのアカウントにペアリング；クラウドのエミュレート開発機をあなたがオーナー / 管理者の DEV クラウドのホームに追加；所属する開発者組織のメンバーが、あなたの DEV ホーム内の自組織の機種に開発版ファームウェアを配信；このアカウントで DEV クラウドにホームを作成。映像・イベント・録画は見られません。「開発者アカウント」でいつでも解除できます。",
    "confirm_can_prod": "リンク後、この開発者アカウントは次のことができます：自分の AID 枠で AID 未書き込みのデバイスをこのアカウントにペアリング；このアカウントを製品テストラウンドに追加。映像・イベント・録画は見られません。「開発者アカウント」でいつでも解除できます。",
    "confirm": "リンクを確認",
    "linked_done": "{{email}} をリンクしました。",
    "linked_at": "{{date}} にリンク",
    "unlink": "解除",
    "unlink_confirm": "解除すると、このアカウントで AID を割り当てられず、開発者はその開発機にファームウェアを配信できなくなります。",
    "kind_grant": "枠の付与",
    "grant_title": "この開発者アカウントからの AID 枠の付与を受け入れますか？",
    "grant_who": "{{email}}（開発者アカウント）が自分の AID 枠をこのアプリアカウントに付与しようとしています。これはあなた自身のアカウントとは限りません。相手を知っていて、あなたのアカウントでデバイスをペアリングすることに同意する場合のみ確認してください。不明な場合は確認せず、{{brand}} に報告してください。",
    "grant_can": "受け入れると、この開発者アカウントは次のことができます：自分の AID 枠で AID 未書き込みのデバイスをあなたのアカウントにペアリング（1 日の上限あり・毎回通知されます）。あなたのデバイス・映像・イベント・録画は見られず、ファームウェアの配信、エミュレーターの配置、あなたのアカウントでのホーム作成もできません。「開発者アカウント」でいつでも解除できます。",
    "grant_confirm": "付与を承認",
    "grant_done": "{{email}} からの AID 枠の付与を受け入れました。",
    "grant_linked_at": "{{date}} に付与を承認",
    "grant_unlink_confirm": "解除すると、この開発者アカウントは自分の枠であなたのアカウントにデバイスをペアリングできなくなります。ペアリング済みのデバイスはあなたのもとに残ります。",
    "err_LINK_CODE_GONE": "リンクコードが無効か期限切れです。開発者ポータルで再発行してください。",
    "err_gone_dev_hint": "DEV の開発者ポータルで発行したコードは、DEV クラウドのアカウントで確認してください。",
    "err_LINK_POOL_MISMATCH": "このコードは別のアプリのアカウントで確認する必要があります。",
    "err_APP_ACCOUNT_LINKED": "このアカウントは別の開発者アカウントとリンク済みです。先に解除してください。",
    "err_APP_LINK_EXISTS": "その開発者アカウントはこのアプリの別のアカウントとリンク済みです。開発者ポータルで先に解除してください。",
    "err_LINK_TARGET_MISMATCH": "このコードはこのアカウント宛ではありません。相手にこのアプリアカウントのメールアドレスで再発行してもらってください。",
    "err_RATE_LIMITED": "試行回数が多すぎます。しばらくしてから再試行してください。",
    "err_INVALID_ARGUMENT": "リンクコードは英数字 8 文字です。",
    "err_REAUTH_REQUIRED": "確認の前に本人確認をやり直してください。",
    "err_WRONG_ACCOUNT_POOL": "開発者アカウントではここで確認できません。アプリのアカウントでログインしてください。",
    "err_default": "完了しませんでした（{{code}}）"
  },
  "navg": {
    "watch": "監視",
    "manage": "デバイスと拠点",
    "org": "組織管理"
  },
  "orggate": {
    "capsule": "組織：{{name}}",
    "pick_title": "どの組織を管理しますか？",
    "pick_body": "現在の範囲は「すべて」です。組織を選ぶと、上部の範囲もその組織に切り替わります。",
    "your_role": "あなたの役割：{{role}}",
    "devices_one": "{{count}} 台のデバイス",
    "devices_other": "{{count}} 台のデバイス"
  },
  "time": {
    "just_now": "たった今",
    "min_ago_one": "{{count}} 分前",
    "min_ago_other": "{{count}} 分前",
    "hour_ago_one": "{{count}} 時間前",
    "hour_ago_other": "{{count}} 時間前",
    "day_ago_one": "{{count}} 日前",
    "day_ago_other": "{{count}} 日前"
  },
  "user": {
    "me": "自分",
    "menu": "アカウントメニュー",
    "tz": "時刻の表示",
    "tz_site": "拠点のタイムゾーン",
    "tz_browser": "自分のタイムゾーン",
    "version": "{{brand}} · バージョン {{version}}（Web {{build}}）",
    "version_copy": "バージョン情報をコピー",
    "version_copied": "コピーしました",
    "map_provider": "地図の提供元",
    "map_auto": "地域に合わせて自動"
  },
  "gsearch": {
    "label": "検索",
    "placeholder": "デバイス・拠点・人・機能を検索…  {{key}}",
    "g_pages": "ページ",
    "g_devices": "デバイス",
    "g_places": "拠点と$t(leaf.cur)",
    "g_people": "メンバー",
    "g_events": "イベント",
    "in_events": "イベントで「{{q}}」を検索",
    "places_failed": "拠点と$t(leaf.cur)を検索できませんでした（ほかの結果は表示されます）",
    "seats": "クラウド録画シート",
    "syn_overview": "ホーム,ダッシュボード,健全性",
    "syn_live": "ビデオウォール,ライブ映像",
    "syn_playback": "録画,タイムライン",
    "syn_events": "アラーム,検知",
    "syn_map": "平面図,フロアプラン,位置",
    "syn_exports": "エクスポート,ダウンロード,証拠",
    "syn_devices": "カメラ,NVR,デバイス追加,ペアリング",
    "syn_firmware": "ファームウェア,更新,OTA",
    "syn_inventory": "在庫,シリアル番号,未割り当て,検出",
    "syn_enroll": "登録,アクティベート,Kinio Node",
    "syn_sites": "拠点,組織構成,ノード,フロア",
    "syn_rules": "ルール,自動化,シーン",
    "syn_backup": "バックアップ",
    "syn_people": "メンバー,権限,役割,共有,委任,招待",
    "syn_audit": "監査,ログ,履歴",
    "syn_billing": "プラン,請求,支払い,購読",
    "syn_seats": "シート,クラウド録画",
    "syn_org": "組織,セキュリティポリシー,MyCam ポリシー",
    "syn_account": "アカウント,設定,2 段階認証,パスワード,パスキー",
    "syn_apikeys": "API キー,API,トークン",
    "syn_notify": "通知設定,おやすみモード,メール",
    "syn_verify": "検証,証拠パッケージ,SHA-256,署名",
    "syn_access": "アクセス権,権限,付与,$t(leaf.cur)のメンバー,共有,割り当て",
    "syn_external": "外部,委任,委任コード,組織に共有",
    "g_other": "ほかの範囲",
    "only_other": "現在の範囲には該当なし。ほかの範囲に {{n}} 件あります（開くと範囲を切り替えます）",
    "syn_shares": "共有,リンク,受信者,取り消し,透かし"
  },
  "devtabs": {
    "all": "すべてのデバイス",
    "firmware": "ファームウェア",
    "inventory": "在庫",
    "add": "追加",
    "add_kinio": "Kinio デバイスを追加",
    "add_onvif": "ONVIF カメラを追加",
    "add_enroll": "Kinio Node を登録",
    "add_claim": "シリアル番号で登録",
    "enroll": "登録",
    "add_kinio_channel": "Kinio カメラをレコーダーのチャンネルにつなぐ"
  },
  "toastpref": {
    "title": "ポップアップ通知",
    "help": "新しい通知を画面右下に表示するかどうか。このパソコンだけの設定で、ベルの通知はそのまま残ります。",
    "alarm": "アラームのみ（推奨）",
    "alarm_help": "警戒中の検知、センサーの作動、ドアベル、アカウントのセキュリティ",
    "alarm_detect": "アラームと検知",
    "alarm_detect_help": "通常の動き・人・車の検知も表示",
    "none": "表示しない",
    "none_help": "ベルのみ（アラームカードも表示しません。ビデオウォールの指定セルは動作します）"
  },
  "iam": {
    "tab_access": "アクセス権",
    "tab_external": "外部",
    "left_member": "退出したメンバー",
    "a_group": "メンバーグループ",
    "an_org": "別の組織",
    "org_role_other": "その他の役割",
    "home_role": "$t(leaf.cur)の{{role}}",
    "src_org_role": "組織の役割",
    "src_home_role": "$t(leaf.cur)の役割",
    "src_site_grant": "拠点の権限付与",
    "src_node_assignment": "ノード割り当て",
    "src_share": "共有",
    "src_delegation": "委任",
    "col_who": "対象",
    "col_where": "範囲",
    "col_what": "できること",
    "col_source": "付与元",
    "col_term": "期限",
    "inherited_from": "「{{path}}」から継承（読み取り専用）",
    "filter_who": "対象で絞り込む",
    "filter_who_all": "すべての人",
    "filter_where": "範囲で絞り込む",
    "filter_where_all": "すべての範囲",
    "filter_source": "付与元で絞り込む",
    "filter_source_all": "すべての付与元",
    "grant_btn": "＋ アクセス権を付与",
    "empty": "該当するアクセス権はありません。",
    "more": "さらに読み込む",
    "details": "詳細",
    "revoke": "取り消す",
    "revoke_title": "{{who}} の「{{where}}」へのアクセスを取り消しますか？",
    "revoke_body": "30 秒以内にここのライブ映像・再生・操作ができなくなります。",
    "revoke_body_home_role": "この$t(leaf.cur)のメンバーから外し、見ている映像は 30 秒以内に止まります。",
    "revoke_body_share": "共有が終了し、30 秒以内にこれらのデバイスが見えなくなります。",
    "revoke_body_site_grant": "拠点の権限付与を取り消し、30 秒以内にこれらのデバイスへのアクセスがなくなります。",
    "revoke_action": "アクセスを取り消す",
    "revoke_gone": "このアクセス権はもうありません。再読み込みしてください。",
    "revoked": "{{who}} のアクセスを取り消しました。",
    "refresh": "展開し直す",
    "refresh_hint": "今あるデバイスで展開し直します（後から追加したデバイスは自動では入りません）",
    "refreshed": "{{who}} のアクセスを今あるデバイスで展開し直しました。",
    "all_now": "この場所に今あるすべてのデバイス（後から追加したデバイスは自動では入りません）",
    "grant_title": "アクセス権を付与",
    "step_who": "誰に",
    "step_where": "どこを",
    "step_what": "何ができるか",
    "step_term": "いつまで",
    "kind_member": "この組織のメンバー",
    "kind_member_desc": "組織内の人",
    "kind_group": "メンバーグループ",
    "kind_group_desc": "まとめて付与（ノードのみ）",
    "kind_org": "別の組織",
    "kind_org_desc": "拠点を委任する、またはサービス業者にデバイスを共有する",
    "kind_person": "組織外の個人",
    "kind_person_desc": "メールで 1 か所のデバイスを共有",
    "person_hint": "アカウントがあればすぐに有効、なければ招待メールが届きます。画面には常に「送信しました」とだけ表示されます。",
    "org_delegation": "相手の委任コードで",
    "org_delegation_desc": "拠点の管理を別の組織に任せ、相手が自分のメンバーを割り当てます",
    "org_share": "相手の共有リクエストコードで",
    "org_share_desc": "ある場所のデバイスを施工業者・警備会社・監視センターに共有します",
    "where_hint": "ノード（配下の拠点と場所を含む）か場所を 1 つ選びます。",
    "where_hint_group": "メンバーグループにはノード（配下の拠点と場所を含む）だけ付与できます。",
    "picked": "選択：{{where}}",
    "size_node": "{{homes}} か所、{{devices}} 台",
    "size_home_one": "{{count}} 台",
    "size_home_other": "{{count}} 台",
    "size_list": "指定した {{n}} 台",
    "devices_all": "この場所に今あるすべてのデバイス（後から追加したデバイスは自動では入りません）",
    "devices_list": "一部だけ選ぶ",
    "devices_list_na": "一部だけ選ぶ（この場所の映像権限がないため個別には選べません）",
    "role_node_admin": "この拠点を管理（ノード管理者）",
    "role_operator": "閲覧と操作（オペレーター）",
    "role_viewer": "閲覧のみ（閲覧者）",
    "role_installer": "設置・調整（設置技術者）",
    "role_maintainer": "デバイスの保守（保守担当）",
    "role_custom": "カスタム…",
    "role_custom_desc": "カスタム役割テンプレートの操作",
    "term_n_days": "日数",
    "term_max": "最長 90 日",
    "term_window_label": "特定の時間帯だけ",
    "term_days_one": "{{count}} 日",
    "term_days_other": "{{count}} 日",
    "term_window": "毎日 {{from}}–{{to}}",
    "site_grant_term": "1 か所へのアクセスには必ず期限があります（最長 90 日）。期限前に延長できます。",
    "summary": "{{who}} は {{where}}{{size}} を{{verb}}できます（{{term}}）",
    "verb_node_admin": "管理",
    "verb_operator": "閲覧・操作",
    "verb_viewer": "閲覧",
    "verb_installer": "設置・調整",
    "verb_maintainer": "デバイスを保守",
    "verb_custom": "「{{name}}」で利用",
    "verb_share": "「{{what}}」",
    "grant_submit": "アクセス権を付与",
    "done": "{{who}} に「{{where}}」へのアクセスを付与しました。",
    "done_share": "{{email}} に共有を送りました。",
    "done_org_share": "共有リクエストを承認しました。",
    "drawer_title": "{{name}} ができること",
    "org_role": "組織の役割",
    "powers": "組織権限",
    "no_powers": "組織の業務権限はありません（見られるものは下の一覧）",
    "can_all_org": "組織のすべて（拠点・メンバー・請求・監査・在庫・問題の報告）",
    "can_org_sites": "拠点と人員を管理できる",
    "can_org_devices": "デバイス在庫を管理できる",
    "can_org_audit": "監査ログを見られる",
    "can_org_billing": "請求を管理できる",
    "can_svc": "サービス役割：{{role}}",
    "duty": "当直コンソール用アカウント",
    "drawer_access": "範囲ごとのアクセス権",
    "drawer_hint": "所属するメンバーグループのノード割り当ても含みます。各行で取り消せます。",
    "drawer_need_admin": "完全なアクセス権一覧は組織のオーナーと管理者だけが見られます。",
    "what_can": "{{name}} ができること",
    "change_role": "役割を変更…",
    "edit_perms": "組織権限…",
    "more_of": "{{name}} のその他の操作",
    "suspend_title": "{{name}} を停止しますか？",
    "suspend_body": "30 秒以内にライブ映像と再生が止まり、この組織に入れなくなります。後で再開できます。",
    "change_role_of": "{{name}} の役割を変更",
    "new_role": "新しい役割",
    "role_before": "変更前：{{role}}——{{desc}}",
    "role_after": "変更後：{{role}}——{{desc}}",
    "change_role_action": "役割を変更",
    "org_role_desc_owner": "組織のすべて（組織管理者の指定を含む）",
    "org_role_desc_org_admin": "組織・拠点ツリー・メンバー・請求・監査・在庫。映像は別途アクセス権が必要",
    "org_role_desc_member": "組織のメンバー。見られるものはノード割り当て・拠点の権限付与・$t(leaf.cur)の役割・共有で決まります",
    "org_role_desc_guest": "既定ではデバイスは見えません。別途アクセス権が必要です",
    "org_role_desc_developer": "開発者アカウント（develop portal の作業）",
    "org_role_desc_factory_ops": "生産ライン用アカウント（工場テストと出荷）",
    "roles_hint": "各役割に「できること」と「できないこと」を 1 行ずつ。アクセス権の付与は「アクセス権」タブの〔＋ アクセス権を付与〕から。",
    "roles_export_note": "録画のダウンロード / エクスポートは常に別途チェックが必要で、どの役割にも自動では含まれません。",
    "col_layer": "階層",
    "col_can": "できること",
    "col_cannot": "できないこと",
    "layer_org": "組織",
    "layer_site": "拠点",
    "layer_home": "$t(leaf.cur)",
    "layer_custom": "カスタム役割",
    "custom_cannot": "チェックしていない操作",
    "rl_owner_name": "オーナー",
    "rl_owner_how": "組織の役割",
    "rl_owner_can": "組織のすべて（組織管理者の指定を含む）",
    "rl_owner_cannot": "—",
    "rl_org_admin_name": "組織管理者",
    "rl_org_admin_how": "組織の役割",
    "rl_org_admin_can": "組織・拠点ツリー・メンバー・請求・監査・在庫と取り込み",
    "rl_org_admin_cannot": "それ自体には映像権限なし。組織に共有されたデバイスは管理できません",
    "rl_member_name": "メンバー / ゲスト",
    "rl_member_how": "組織の役割",
    "rl_member_can": "組織のメンバー資格。見られるものは拠点の役割・$t(leaf.cur)の役割・共有で決まります",
    "rl_member_cannot": "組織の業務",
    "rl_auditor_name": "監査担当",
    "rl_auditor_how": "組織権限「監査ログを見られる」",
    "rl_auditor_can": "監査ログ、イベント",
    "rl_auditor_cannot": "ライブ映像、再生",
    "rl_node_admin_name": "ノード管理者",
    "rl_node_admin_how": "ノード割り当て",
    "rl_node_admin_can": "範囲内のすべてのデータ操作（警戒 / 解除を含む）、保守、子ノードと割り当て",
    "rl_node_admin_cannot": "共有、$t(leaf.cur)の役割、録画設定、登録解除、フォーマット",
    "rl_operator_name": "オペレーター",
    "rl_operator_how": "ノード割り当てまたは拠点の権限付与",
    "rl_operator_can": "ライブと再生、通話、PTZ、サイレン、アラーム対応",
    "rl_operator_cannot": "エクスポート、設定、権限",
    "rl_viewer_name": "閲覧者",
    "rl_viewer_how": "ノード割り当てまたは拠点の権限付与",
    "rl_viewer_can": "ライブとイベント",
    "rl_viewer_cannot": "再生、エクスポート、操作、アラーム対応（アラームは通知されません）",
    "rl_installer_name": "設置技術者",
    "rl_maintainer_name": "保守担当",
    "rl_installer_how": "ノード割り当てまたは拠点の権限付与",
    "rl_maintainer_how": "ノード割り当て、または 1 台単位の拠点の権限付与",
    "rl_installer_can": "ピント・角度調整、設定",
    "rl_maintainer_can": "デバイスと状態の確認、OTA、再起動、名前変更、Kinio KMS 監視の閲覧",
    "rl_installer_cannot": "再生、エクスポート、イベント履歴",
    "rl_maintainer_cannot": "映像、通話、イベント、再生、エクスポート、設定、権限；KMS の設定と処置",
    "rl_home_roles_name": "$t(leaf.cur)のオーナー / 管理者 / メンバー / ゲスト",
    "rl_home_roles_how": "$t(leaf.cur)の役割",
    "rl_home_roles_can": "オーナー：$t(leaf.cur)の登録解除と共有を含むすべて。管理者：設定・権限・録画ポリシー。メンバー：閲覧・再生・イベント・操作。ゲスト：共有されたデバイスのみ",
    "rl_home_roles_cannot": "役割による",
    "ext_out_desc": "自組織の拠点の管理を別の組織に任せ、相手が自分のメンバーを割り当てます。",
    "ext_in_desc": "別の組織から管理を任された拠点です。",
    "ext_shares_title": "この組織に共有されたもの",
    "ext_shares_desc": "他の$t(leaf.cur)があなたの組織にデバイスを共有するとここに表示されます。どのメンバーが見られるかを決められます。",
    "size_struct": "{{x}}（構成上の合計）",
    "here": "この階層",
    "maintenance": "メンテナンス",
    "maintenance_hint": "停止するとこの組織でのアクセスが一時的にすべてなくなります。組織から外すと永久になくなり、再度招待が必要です。",
    "email_need": "相手のメールアドレスを入力してください",
    "assign_site_role": "拠点の役割を割り当て",
    "subtree_scope": "この拠点と、権限を継承する子拠点・$t(leaf.cur)のデバイス（今後追加されるものを含む）が対象です。継承をブロックした子拠点は対象外です。",
    "site_admin_help": "デバイスの閲覧・再生・操作・警戒の開始と解除・保守、子拠点と役割の管理が可能です。ダウンロード／エクスポートは別途許可が必要です。",
    "site_scope_help": "現在の範囲：{{scope}}。この範囲のデバイス管理を任せるには「拠点の役割を割り当て」で「この拠点を管理」を選んでください。以下の各権限は対象範囲が異なる場合があります。子拠点への割り当てで組織全体へのアクセスは付与されません。",
    "can_org_support": "問題を報告し、組織の報告を見られる",
    "err_dup_assignment": "{{who}} は「{{where}}」にすでに割り当てがあります：{{role}}、{{term}}。ロールや期間を変えるには、新しく追加せず「アクセス権」タブでその割り当てを編集してください。",
    "err_dup_assignment_unknown": "この対象は「{{where}}」にすでに割り当てがあります。ロールや期間を変えるには、新しく追加せず「アクセス権」タブでその割り当てを編集してください。",
    "dup_until": "{{date}} まで",
    "dup_schedule": "時間帯の制限あり"
  },
  "notfound": {
    "title": "ページが見つかりません",
    "body": "{{path}} は VMS のページではありません。アドレスの入力ミスか、ページが移動した可能性があります。",
    "home": "概要に戻る"
  },
  "nuart": {
    "row": "UART（TTL）に接続中のデバイス",
    "open": "そのデバイスのページを開く",
    "label_was": "配線時に付けた名前：{{label}}",
    "not_visible": "表示できる Kinio デバイスと一致しません（Kinio デバイスでない、別の$t(leaf.cur)にある、または閲覧権限がない可能性があります）。リンクはありません",
    "unset": "接続先のデバイスがまだ設定されていません",
    "howto": "配線した人がデバイスの一括操作で ttl_config に dut を付けて送るか、この Node のコンソールで次を入力します：",
    "howto_name": "名前",
    "howto_model": "機種",
    "old_fw": "この Node のファームウェア {{v}} は接続先を報告しません。{{min}} 以上に更新してください（更新あり：{{next}}）",
    "see_fw": "ファームウェアを見る",
    "rx_none": "接続先のデバイスからの出力はまだありません",
    "rx_just_now": "接続先のデバイスがたった今出力しました",
    "rx_recent": "接続先のデバイスが {{when}}に出力しました",
    "rx_quiet": "接続先のデバイスから 24 時間以上出力がありません（最後 {{at}}）。外れているか電源が入っていない可能性があります",
    "rx_node_offline": "Node がオフラインになる前の最後の出力：{{when}}",
    "summary": "UART（TTL）に接続中のデバイス：{{name}}",
    "old_fw_unreleased": "この Node のファームウェア（{{v}}）は接続先をまだ報告しません。対応版（{{min}} 以上）は更新チャネルにまだ公開されていません"
  },
  "kinioch": {
    "title": "Kinio カメラをレコーダーのチャンネルにつなぐ",
    "help": "Kinio Station が自身の ID で Kinio カメラを自分のチャンネルに取り込みます。ほかのチャンネルと同じく録画・動体検知・ビデオウォール表示ができます。カメラは Station と同じホームや拠点でなくてもよく、あなたがライブ映像を見られれば設定できます。",
    "no_station": "この範囲に管理できる Kinio Station がありません（オーナーまたは管理者が必要）。",
    "station": "レコーダー",
    "camera": "カメラ",
    "pick_camera": "ライブ映像を見られるカメラを選択",
    "no_camera": "ライブ映像を見られる Kinio カメラがありません。",
    "channel": "チャンネル（空欄 = 最初の空き）",
    "channel_auto": "自動",
    "add": "接続",
    "whose": "権限は設定した人に従います：あとでこのカメラが見られなくなると（共有の取り消し、組織からの離脱など）、このチャンネルは停止し、ほかの人が設定し直すか削除するまで止まります。",
    "added": "CH{{ch}} に接続しました：{{name}}",
    "current": "このレコーダーの Kinio カメラチャンネル",
    "none": "まだありません",
    "by_me": "あなたが設定",
    "by_other": "ほかの人が設定",
    "ok": "利用可能",
    "remove": "削除",
    "denied": "設定した人はこのカメラを見られなくなりました",
    "denied_not_granted": "設定した人はこのカメラの権限がなくなりました",
    "denied_org_mfa_required": "カメラの組織が 2 段階認証を必須にしています：設定した人が 2 段階認証でログインして設定し直してください",
    "denied_ip_not_allowed": "カメラの組織が設定時のネットワークを許可していません",
    "denied_session_reauth": "設定した人が再ログインして設定し直してください",
    "denied_share_expired": "共有の期限が切れました",
    "denied_share_suspended": "共有は一時停止中です",
    "denied_alarm_window": "アラーム直後の時間帯のみ表示可能",
    "denied_armed": "警戒中のみ表示可能",
    "denied_schedule": "許可された時間帯外です",
    "denied_org_suspended": "カメラの組織は停止中です",
    "denied_station_rebound": "レコーダーが再登録されました。設定し直してください",
    "denied_device_unbound": "カメラの登録が解除されました",
    "denied_no_assignment": "未設定",
    "err_DEVICE_NOT_FOUND": "カメラが見つからないか、表示権限がありません",
    "err_FORBIDDEN": "このカメラのライブ映像の権限がありません",
    "err_KINIO_SOURCE_SELF": "このレコーダー自身のチャンネルは使えません",
    "err_KINIO_SOURCE_UNSUPPORTED": "このレコーダーは Kinio カメラチャンネルに対応していません",
    "err_NO_FREE_CHANNEL": "レコーダーに空きチャンネルがありません",
    "err_ORG_MFA_REQUIRED": "カメラの組織が 2 段階認証を必須にしています。有効にして再ログインしてください",
    "err_GATEWAY_OFFLINE": "レコーダーがオフラインです"
  },
  "rech": {
    "title": "録画の状態",
    "table_title": "チャンネルごとの録画の状態",
    "col_channel": "チャンネル",
    "col_state": "状態",
    "state_ok": "正常に録画中",
    "state_idle": "現在は録画しない時間です",
    "idle_note": "録画スケジュール外、または録画がオフです",
    "state_interrupted": "録画が中断：{{reason}}",
    "since": "{{at}} から（{{dur}} 経過）",
    "state_none": "報告なし",
    "none_note": "このレコーダーのファームウェアが未対応か、まだクラウドに接続していません",
    "state_unreadable": "読み取れません",
    "host_offline": "レコーダーがオフラインです。最後の報告（{{at}}）を表示しています",
    "reason_disk_repairing": "ハードディスクを修復中のため、書き込めません",
    "reason_no_storage": "録画用ディスクが見つかりません",
    "reason_no_space": "ディスクが満杯で、上書きしない設定です",
    "reason_io_error": "ディスクへの書き込みに失敗しました",
    "reason_no_stream": "カメラの映像が届きません（オフラインまたは映像が途切れています）",
    "reason_unsupported_stream": "カメラの映像形式は録画できません",
    "reason_not_writing": "録画するはずがファイルが書き込まれていません（原因不明）",
    "reason_unknown": "原因不明",
    "last_write": "最終書き込み",
    "dropped": "過去 1 時間に失われたフレーム",
    "dropped_n": "{{n}} フレーム",
    "dropped_note": "書き込みが追いつかずに失われた分です。カメラ側の途切れは含みません",
    "fsync": "ファイル保存にかかった時間（過去 1 時間）",
    "fsync_v": "通常 {{p95}} ミリ秒以内 · 最大 {{max}} ミリ秒",
    "fsync_none": "この 1 時間は保存がありません",
    "write_err": "過去 24 時間の書き込み失敗",
    "write_err_n": "{{n}} 回",
    "reset_note": "レコーダーを再起動すると、これらの数値は 0 から数え直します",
    "loading": "読み込み中…",
    "dur_lt1m": "1 分未満",
    "dur_min_one": "{{count}} 分",
    "dur_min_other": "{{count}} 分"
  },
  "lens": {
    "lens_upper": "上レンズ",
    "lens_lower": "下レンズ",
    "lens_wide": "広角レンズ",
    "lens_tele": "望遠レンズ",
    "lens_left": "左レンズ",
    "lens_right": "右レンズ",
    "lens_n": "レンズ {{n}}",
    "group": "レンズ",
    "group_playback": "再生するレンズ",
    "filter_all": "すべてのレンズ",
    "switching": "{{name}}に切り替え中…",
    "switched": "{{name}}に切り替えました",
    "timeout": "{{name}}から応答がありません",
    "unsupported": "このカメラでは現在{{name}}を表示できません",
    "privacy": "プライバシーマスクがオンのときは{{name}}を表示できません",
    "moved_back": "プライバシーマスクがオンのため、{{name}}に戻しました",
    "old_fw": "このカメラは現在1つのレンズしか表示できません",
    "look": "{{name}}を表示",
    "timeline_main": "{{name}}の録画",
    "no_rec": "{{name}}は録画がオフです",
    "no_rec_at": "この時刻の{{name}}の録画はありません",
    "open_settings": "設定でオンにする",
    "ask_owner": "オーナーに設定でオンにしてもらってください"
  },
  "wb": {
    "filter": "絞り込み",
    "filter_all": "すべて",
    "filter_mine": "自分に割り当て",
    "filter_overdue": "期限超過",
    "list": "アラーム一覧",
    "pane": "アラームの詳細",
    "empty": "現在アラームはありません",
    "empty_mine": "自分に割り当てられた未対応のアラームはありません",
    "empty_overdue": "対応開始期限を過ぎたアラームはありません",
    "all_done": "すべて対応しました",
    "recent_closed": "最近完了したもの",
    "group_security": "未対応（防犯）",
    "group_status": "未対応（状態）",
    "group_recovered": "未対応（復旧済み）",
    "group_claimed": "対応中",
    "group_closed": "完了",
    "group_unlisted": "未登録または削除済みのデバイス",
    "recovered": "↺ 復旧済み",
    "me": "自分",
    "left_member": "退出したメンバー",
    "system": "システム",
    "assigned_to": "{{name}} に割り当て",
    "assigned_line": "{{name}} に割り当て（{{by}} が割り当て、{{at}}）",
    "assigned_now": "現在の担当",
    "assign": "割り当て…",
    "assign_me": "{{name}}（自分）",
    "unassign": "割り当てを解除",
    "assign_filter": "名前で絞り込み",
    "assign_none": "このデバイスに対応できる人が他にいません",
    "assign_truncated": "先頭 500 人のみ表示しています。名前で絞り込んでください",
    "assign_not_eligible": "この人は現在このデバイスのアラームに対応できません",
    "assign_invalid": "現在の状態ではこの割り当てはできません",
    "assign_closed": "完了したアラームは割り当てできません",
    "cannot": "このアラームは「{{state}}」なので「{{act}}」は使えません",
    "conflict": "{{name}} が「{{state}}」に変更しました。もう一度確認してください",
    "wave_skipped": "{{n}} 件は他の人が対応済みのためスキップしました",
    "note_placeholder": "メモ（1 行、最大 {{max}} 文字。Enter でメモのみ追加）",
    "note_saved": "メモを追加しました",
    "read_only": "このアラームは閲覧のみです",
    "no_media": "カメラではないため映像クリップはありません",
    "live": "ライブ",
    "live_open": "ライブを見る",
    "live_offline": "オフライン",
    "enlarge": "拡大表示",
    "floorplan": "平面図",
    "floorplan_open": "この平面図をマップページで開く",
    "related_more": "ほか {{n}} 台",
    "wave": "この連続発生 {{n}} 回",
    "wave_more": "すべて表示",
    "wave_less": "折りたたむ",
    "wave_rest": "ほか {{n}} 回",
    "unlisted": "このデバイスはデバイス一覧にありません（未登録のチャンネルまたは削除済みのデバイス）。未対応件数に含めず、対応開始期限もありません。",
    "started_before_alarm": "この検知はアラームになる前に始まりました（警戒開始後にアラームになったか、開始の記録がありません）。",
    "sla_left": "残り {{d}}",
    "sla_over": "{{d}} 超過",
    "sla_over_now": "期限超過",
    "sla_line": "対応開始期限 {{m}} 分 · {{s}}",
    "sla_recovered": "復旧済みのため計測停止",
    "sla_stopped": "対応開始済み",
    "sla_met": "{{d}}以内に対応開始",
    "sla_met_late": "期限を {{d}}過ぎて対応開始",
    "sla_src_org": "設定元：組織の既定値",
    "sla_src_site": "設定元：ノードの設定",
    "sla_src_share": "設定元：{{org}}（共有）の既定値",
    "sla_src_other_org": "別の組織",
    "dur_min_one": "{{count}} 分",
    "dur_min_other": "{{count}} 分",
    "dur_hour_one": "{{count}} 時間",
    "dur_hour_other": "{{count}} 時間",
    "dur_day_one": "{{count}} 日",
    "dur_day_other": "{{count}} 日",
    "h_assign": "{{by}} が {{to}} に割り当て",
    "h_unassign": "{{by}} が割り当てを解除（元は {{to}}）",
    "h_note": "{{by}} がメモを追加",
    "h_overdue": "対応開始期限を超過、{{list}} に通知",
    "h_overdue_none": "対応開始期限を超過（通知先なし）",
    "h_overdue_merged": "対応開始期限を超過、{{at}} の通知にまとめました",
    "h_cleared": "（元の担当：{{name}}）",
    "help_title": "キーボードショートカット",
    "help_hint": "入力欄にカーソルがあるときやダイアログが開いているときは使えません。",
    "key_jk": "J / K（↓ / ↑）",
    "key_a": "A",
    "key_c": "C",
    "key_r": "R",
    "key_f": "F",
    "key_s": "S",
    "key_n": "N",
    "key_enter": "Enter",
    "key_x": "X",
    "key_q": "?",
    "key_esc": "Esc",
    "keydesc_jk": "次へ / 前へ",
    "keydesc_a": "確認済み",
    "keydesc_c": "対応する（他の人が対応中なら引き継ぐ）",
    "keydesc_r": "対応完了（次へ自動移動）",
    "keydesc_f": "誤報（次へ自動移動）",
    "keydesc_s": "同僚に割り当て",
    "keydesc_n": "メモ（Enter でメモのみ追加、Esc で取り消し）",
    "keydesc_enter": "拡大表示（クリップがあれば再生）",
    "keydesc_x": "この連続発生を展開 / 折りたたみ",
    "keydesc_q": "ショートカット一覧",
    "keydesc_esc": "拡大表示・メニュー・ドロワーを閉じる",
    "assigned_line_noat": "{{name}} に割り当て（{{by}} が割り当て）"
  },
  "sla": {
    "title": "アラーム対応期限",
    "hint": "誰も対応を開始しないままこの時間を過ぎたアラームは「期限超過」と表示され、担当者と管理者（組織のオーナー・管理者・ノード管理者）に 1 回通知します。通知のみで、状態は変わりません。空欄 = 設定なし。",
    "default": "組織の既定値",
    "security": "防犯",
    "status": "状態（映像信号断）",
    "minutes": "分",
    "off": "なし",
    "invalid": "1〜{{max}} の整数を入力するか、空欄にしてください",
    "invalid_node": "正しい分数を入力してください",
    "nodes": "ノードごとの上書き",
    "nodes_none": "ノードごとの上書きはありません。すべて組織の既定値を使います。",
    "node_unknown": "（削除されたノード）",
    "inherit": "上位を継承",
    "set": "カスタム",
    "node_off": "このノードは設定なし",
    "reset": "継承に戻す",
    "pick_node": "ノードを選択",
    "add": "上書きを追加"
  },
  "mycam": {
    "full_mode": "詳細モード",
    "simple_mode": "シンプルモード",
    "add_title": "古いスマートフォンをカメラとして追加",
    "add_intro": "古いスマートフォンに MyCam を入れ、ここに表示される QR コードか 8 文字のコードでホームに追加します。",
    "home": "追加先のホーム",
    "pick_home": "ホームを選択",
    "create_code": "追加コードを作成",
    "steps": "古いスマートフォンで MyCam を開き、この QR コードを読み取るか、下の 8 文字のコードを入力してください。",
    "qr_label": "MyCam 追加コードの QR コード",
    "expires": "有効期限 {{n}} 分",
    "waiting": "古いスマートフォンを待っています…",
    "compare_title": "古いスマートフォンにこの番号が表示されていますか？",
    "compare_device": "追加する端末：{{device}}",
    "name": "名前",
    "name_default": "リビング",
    "confirm": "はい、追加します",
    "reject": "この端末ではない",
    "done": "「{{name}}」を追加しました。古いスマートフォンで PIN を設定すると見守りを始めます。",
    "go_cameras": "カメラを見る",
    "expired": "追加コードの有効期限が切れました。",
    "plan_limit": "プランのカメラ台数の上限です。カメラを削除するかアップグレードしてから追加してください。",
    "no_admin_home": "デバイスを追加できるホームがありません（オーナーまたは管理者である必要があります）。",
    "brand_warn": "「{{home}}」は別ブランドのアプリで作成されたホームです。ここに MyCam を追加すると、動きを検知してもスマートフォンのアプリに通知が届きません。先にアプリで新しいホームを作成し、そこに MyCam を追加してください。",
    "brand_keep": "このホームに追加する",
    "add_old_phone": "古いスマートフォンを追加"
  },
  "leaf": {
    "cur": "ロケーション",
    "cur_lc": "ロケーション",
    "cur_pl": "ロケーション",
    "cur_lc_pl": "ロケーション"
  },
  "support": {
    "title": "問題の報告",
    "no_right": "組織の管理者に「メンバーとアクセス › メンバー」で「問題の報告」をオンにしてもらうと、ここで問題を報告し、組織の報告を見られます。",
    "new": "新しい報告",
    "hint": "VMS、デバイス、録画、アカウントの問題を報告します。同じ組織で「問題の報告」権限を持つ人も閲覧・追記できます。",
    "filter": "絞り込み",
    "scope_all": "すべて",
    "scope_mine": "自分の報告",
    "scope_watching": "フォロー中",
    "scope_org": "組織の報告",
    "load_failed": "報告一覧を読み込めません。しばらくしてから再試行してください。",
    "empty": "報告はまだありません。",
    "new_reply": "新しい返信",
    "by": "{{name}} が作成 · {{org}}",
    "status_open": "受付済み",
    "status_triaged": "確認中",
    "status_in_progress": "対応中",
    "status_resolved": "解決済み",
    "status_closed": "完了",
    "cat_video": "映像とストリーミング",
    "cat_offline": "デバイスのオフライン",
    "cat_recording": "録画と再生",
    "cat_account": "アカウントと権限",
    "cat_alert": "通知とアラーム",
    "cat_other": "その他",
    "new_title": "新しい報告",
    "new_hint": "送信後、テクニカルサポートがここで返信し、メールでもお知らせします。",
    "org": "組織",
    "category": "問題の種類",
    "device": "対象のデバイス（任意）",
    "device_none": "指定しない",
    "subject": "件名",
    "body": "何が起きたか",
    "body_ph": "いつから、どのロケーションで、どの画面で、何をした後に起きたか…",
    "files": "スクリーンショットやファイル（最大 {{n}} 個）",
    "file_type": "{{name}}：画像・テキスト・JSON・ZIP・PDF のみ",
    "file_big": "{{name}}：1 ファイル 20 MB まで",
    "file_many": "最大 {{n}} ファイル",
    "remove": "削除",
    "context": "自動で添付される技術情報",
    "context_hint": "VMS のバージョン、ブラウザ、現在のページ、組織、デバイス、最近のエラーで原因を早く特定できます。",
    "blocked": "送信前チェックで見つかりました：{{summary}}。修正して再送するか、理由を書いてそのまま送れます。",
    "override": "そのまま送る理由",
    "err_NOT_SUPPORT_REPORTER": "この組織で「問題の報告」権限がありません。組織の管理者に依頼してください。",
    "err_BAD_ORG": "所属している組織からのみ報告できます。",
    "err_RATE_LIMITED": "1 時間の報告数が多すぎます。しばらくしてから再試行してください。",
    "err_TICKET_CLOSED": "この報告は完了から 7 日以上たっています。新しく報告してください。",
    "err_generic": "送信できませんでした（{{code}}）。しばらくしてから再試行してください。",
    "upload_failed": "{{n}} 個の添付がアップロードできませんでした。下のコメントで追加できます。",
    "sending": "送信中…",
    "submit": "報告を送信",
    "not_found": "この報告は存在しないか、閲覧権限がありません。",
    "back": "問題の報告に戻る",
    "me": "自分",
    "member": "同僚",
    "staff": "テクニカルサポート",
    "status_changed": "状態が更新されました",
    "attachments": "添付",
    "watchers": "フォロー中の人",
    "add_comment": "補足",
    "send": "送信",
    "report_device": "このデバイスの問題を報告"
  },
  "sso": {
    "sign_in_with": "{{idp}} でサインイン",
    "sign_in_hint": "{{org}} のメンバーは会社アカウントでサインインできます。通常どおりパスワードでもサインインできます。",
    "finishing": "会社アカウントでの認証を完了しています…",
    "back_home": "ホームに戻る",
    "continue": "続ける",
    "email_reminder": "Kinio アカウントのメールアドレスが会社のアドレスです。退職すると使えなくなるため、［マイアカウント］で個人のアドレスに変更することをおすすめします。",
    "org_unavailable": "この組織では会社アカウントでのサインインを利用できません。",
    "start_body": "{{org}} の会社アカウント（{{idp}}）でサインインします。",
    "use_password": "Kinio アカウントのパスワードでサインイン",
    "step_up_title": "会社アカウントでの認証が必要です",
    "step_up_body": "{{org}} のリソースを表示するには会社アカウントでの認証が必要です。ほかの組織や個人の家は通常どおり使えます。",
    "other_orgs": "ほかの組織に戻る",
    "verify_with": "{{idp}} で認証",
    "break_glass_hint": "会社アカウントのシステムが使えない場合は",
    "break_glass": "パスキーで緊急アクセス",
    "err_default": "会社アカウントでの認証が完了しませんでした（{{code}}）。最初からやり直してください。",
    "err_SSO_NOT_LINKED": "この会社アカウントはまだ Kinio アカウントにリンクされていません。先に Kinio アカウントでサインインし、組織のページで会社アカウントの認証を行ってください。",
    "err_SSO_ALREADY_LINKED": "この会社アカウントは別の Kinio アカウントにリンクされています。",
    "err_binding": "このサインインはこのブラウザーで開始されていません。最初からやり直してください。",
    "err_SSO_BINDING_MISSING": "このサインインはこのブラウザーで開始されていません。最初からやり直してください。",
    "err_BREAK_GLASS_NOT_ALLOWED": "この組織の緊急アクセス名簿に含まれていません。",
    "err_PASSKEY_REQUIRED": "先にパスキーで認証してください。",
    "err_PASSKEY_CANCELED": "パスキーでの認証がキャンセルされました。",
    "err_SSO_IDP_UNAVAILABLE": "会社のサインインシステムに接続できません。しばらくしてからお試しください。",
    "err_idp_error": "会社のサインインシステムがエラーを返しました。社内 IT にお問い合わせください。",
    "err_state": "このサインインは期限切れか使用済みです。最初からやり直してください。",
    "ff_title": "パスキーを設定",
    "ff_body": "このアカウントは会社アカウントで作成されたため、まだ独自のサインイン方法がありません。パスキーを設定すると、本人確認に使えます。",
    "ff_why": "2 段階認証が必須の組織や、自分のアカウントで再確認が必要な操作があります。会社アカウントでのサインインは会社の組織でしか使えません。パスキーを設定すれば、これらすべてが使えます。",
    "ff_verified": "会社アカウントで確認しました。もう一度［パスキーを設定］を押してください。",
    "ff_unsupported": "このブラウザはパスキーに対応していません。最新の Chrome、Edge、Safari をお使いください。",
    "ff_setup": "パスキーを設定",
    "ff_later": "あとで",
    "ff_not_needed": "このアカウントにはすでに独自のサインイン方法があります。設定は不要です。",
    "ff_go": "パスキーを設定",
    "ff_passkey_name": "最初のパスキー",
    "no_account_title": "先に Kinio アカウントにログインするか、登録してください",
    "no_account_body": "この会社アカウントはまだ Kinio アカウントに連携されていません。ご自身の Kinio アカウントでログイン（お持ちでない場合は先に登録）してから、組織ページで「会社アカウントで認証」を押してください。登録した場合は、先にメールアドレスの確認を完了してください。",
    "no_account_action": "ログイン / 登録",
    "link_pending_body": "会社アカウント（{{idp}}）で認証すると、この組織に参加できます。",
    "link_pending_dismiss": "スキップ",
    "link_not_eligible": "この組織ではまだ会社アカウントで参加できません。組織の管理者に招待してもらう（Kinio アカウントのメールアドレス宛て）か、会社の名簿のメールアドレスが Kinio アカウントと同じか確認してください。"
  },
  "ssoadm": {
    "title": "エンタープライズ SSO",
    "hint": "この組織のリソースを使うには、メンバーに会社アカウント（Entra ID、Okta、Google…）での認証を求めます。アカウントは個人のままで、パスワード・2 段階認証・個人の家に会社は触れません。",
    "idp": "会社の IdP",
    "protocol": "プロトコル",
    "display_name": "表示名（サインインボタンの文字）",
    "cert": "IdP の署名証明書（PEM）",
    "create": "作成",
    "test": "接続テスト",
    "activate": "有効にする",
    "disable": "無効にする",
    "delete": "IdP を削除",
    "delete_title": "会社の IdP を削除しますか？",
    "delete_body": "すべてのメンバーの会社アカウントのリンクが無効になります。再設定・テスト・有効化のあと、メンバーはもう一度会社アカウントで認証します。",
    "status_draft": "下書き",
    "status_active": "有効",
    "status_disabled": "無効",
    "untested": "このバージョンはまだテストしていません",
    "pending": "テスト待ちの設定があります。接続テストに成功すると反映されます。",
    "sp_values": "次の値を IdP のアプリ設定に入力してください：",
    "sp_redirect_uri": "Redirect URI",
    "sp_entity_id": "SP Entity ID",
    "sp_acs_url": "ACS URL",
    "sp_metadata_url": "SP メタデータ",
    "domains": "会社のドメイン",
    "domains_hint": "確認済みのドメインのメールアドレスを入力すると「会社アカウントでサインイン」が表示されます。完全一致のみで、既存のアカウントは変更しません。",
    "domain_pending": "確認待ち",
    "domain_verified": "確認済み",
    "verify": "確認",
    "add_domain": "ドメインを追加",
    "require": "SSO を必須にする",
    "require_label": "メンバーに会社アカウントでの認証を求める",
    "require_hint": "この組織のリソースを使うときだけ求めます。個人の家やほかの組織は通常どおりです。MFA は IdP が担当します。",
    "require_title": "SSO を必須にしますか？",
    "require_body": "会社アカウントで認証していないメンバーはこの組織に入れなくなります（アカウント全体からはサインアウトしません）。ほかの組織に委任したノードは、相手のメンバーに 2 段階認証を求めます。break-glass 名簿：{{bg}}。",
    "require_on": "オンにする",
    "max_age": "認証の有効時間",
    "break_glass": "緊急アクセス（break-glass）",
    "break_glass_hint": "会社の IdP が使えないとき、名簿の人はパスキーで SSO を省略して入れます。使うたびに監査ログに記録し、ほかの管理者に通知します。最大 2 人、オーナーだけが変更できます。",
    "bg_none": "（なし）",
    "err_default": "完了しませんでした（{{code}}）",
    "err_SSO_IDP_INVALID": "IdP の設定に問題があるか接続できません（{{reason}}）",
    "err_SSO_IDP_UNTESTED": "有効にする前に［接続テスト］を一度実行してください。",
    "err_SSO_REQUIRED_ON": "SSO が必須になっています。IdP を無効化・削除する前にオフにしてください。",
    "err_SSO_NOT_CONFIGURED": "SSO を必須にする前に、会社の IdP を設定して有効にしてください。",
    "err_SSO_PROOF_REQUIRED": "このセッションではまだ会社アカウントで認証していません。締め出されないよう、先に一度認証してください。",
    "err_DOMAIN_NOT_VERIFIED": "TXT レコードがまだ見つかりません（DNS の反映に数分かかることがあります）。",
    "err_DOMAIN_TAKEN": "このドメインは別の組織が確認済みです。異議がある場合はサポートにご連絡ください。",
    "err_INVALID_ARGUMENT": "値が正しくありません（無料メールのドメインは確認できません）。",
    "err_REAUTH_REQUIRED": "本人確認をやり直してください。",
    "err_BAD_POLICY": "設定値が正しくありません。",
    "scim": "SCIM プロビジョニング",
    "scim_hint": "会社のディレクトリ（Entra ID、Okta）から名簿を自動同期します。従業員が無効化されると、この組織での権限が自動的に削除されます（アカウント自体は影響を受けません）。",
    "scim_endpoint": "テナント URL（SCIM エンドポイント）",
    "scim_counts": "名簿 {{users}} 人（未照合 {{unmatched}} 人）· グループ {{groups}} 件",
    "scim_last_sync": "最終同期：{{at}}",
    "scim_never": "まだ同期されていません",
    "scim_token_row": "トークン作成日時 {{at}}",
    "scim_token_used": "最終使用 {{at}}",
    "scim_new": "トークンを生成",
    "scim_new_shown": "このトークンは一度だけ表示されます。今すぐ IdP の Secret Token 欄にコピーしてください：",
    "scim_revoke": "取り消す",
    "scim_revoke_title": "この SCIM トークンを取り消しますか？",
    "scim_revoke_body": "取り消すと、このトークンを使った IdP からの同期は失敗します。名簿とメンバーは変更されません。",
    "err_CONFLICT": "有効なトークンは最大 2 個です。先に 1 個取り消してください。"
  },
  "ssolink": {
    "title": "会社アカウントのリンク",
    "hint": "これらの組織では会社アカウントで認証します。リンクを解除すると、組織を使うときにもう一度会社アカウントで認証が必要です。",
    "unlink": "解除",
    "unlink_title": "{{org}} との会社アカウントのリンクを解除しますか？",
    "unlink_body": "この組織での会社アカウントの認証も無効になります。",
    "unlink_failed": "解除できませんでした。本人確認をやり直してから再試行してください。"
  },
  "aiByo": {
    "title": "自前の AI",
    "help": "ご自身の OpenAI / Anthropic / Gemini アカウントでイベント画像を解析します：検索できる一文の説明と、人 / 車 / 動物 / 荷物のラベル。料金はサービスから直接請求され、Kinio は上乗せも立て替えもしません。",
    "provider": "サービス",
    "provider_openai": "OpenAI",
    "provider_anthropic": "Anthropic Claude",
    "provider_gemini": "Google Gemini",
    "api_key": "API キー",
    "key_help": "保存後は末尾 4 文字のみ表示され、Kinio を含め誰も完全なキーを見られません。プラットフォームはモデル一覧の取得（無料）で一度だけ有効性を確認します。",
    "consent_summary": "自前の AI を有効にしたカメラでは、動きのイベントごとに画像 1 枚を {{provider}} に送って解析し、結果はイベントと検索に反映されます。",
    "consent_body": "送信するデータ：イベント発生時の画像 1 枚（長辺 1024 px に縮小）。カメラ名は送りません。\n送信先：選択したサービス（OpenAI / Anthropic / Google）の公式 API。\n保存と学習：お客様とそのサービスの契約によります。Kinio は解析結果のみをイベントと同じ期間保存します。\n料金：サービスから直接請求されます。1 時間 / 1 日の上限を設定できます。\n通知の責任：お客様がデータ管理者です。撮影される人へお知らせください。\nいつでも撤回可能：キーを削除すると 60 秒以内に送信を停止します。\n顔認識はしません：解析は人物の身元を特定・推測しません。",
    "agree": "内容を読み、同意します",
    "add": "確認して保存",
    "add_help": "再認証が必要です。",
    "status_active": "使用中",
    "status_invalid": "キーが無効",
    "status_disabled": "停止中",
    "status_needs_reentry": "キーの再入力が必要",
    "invalid_help": "サービスからキーが無効または権限なしと返されたため、使用を停止しました。キーを差し替えてください。",
    "last_used": "最終使用 {{at}}",
    "model": "モデル",
    "usage": "今月の呼び出し {{calls}} 回",
    "cost_note": "料金はサービスの請求が正です。",
    "max_per_hour": "1 時間の上限",
    "max_per_day": "1 日の上限",
    "devices_help": "自前の AI で解析するカメラを選びます（これらは Kinio クラウド AI の対象外となり、回数にも数えません）：",
    "rekey_placeholder": "新しいキーを貼り付け",
    "rekey": "キーを差し替え",
    "delete": "削除",
    "delete_help": "削除後 60 秒以内に送信を停止します。漏えいが心配な場合はサービスの管理画面でもキーを無効にしてください。",
    "fail_auth": "キーが無効",
    "fail_rate": "レート制限",
    "fail_quota": "クォータ超過",
    "fail_model": "モデル利用不可",
    "fail_timeout": "タイムアウト",
    "fail_server": "サービスエラー",
    "fail_schema": "応答形式が不正",
    "fail_bad_request": "リクエスト拒否",
    "err_BYO_AI_KEY_INVALID": "このキーは無効か、権限がありません。",
    "err_BYO_AI_MODEL_UNAVAILABLE": "このキーではそのモデルを使えません。",
    "err_BYO_AI_DISABLED_BY_POLICY": "組織のセキュリティポリシーで自前のクラウド AI が許可されていません。",
    "err_BYO_AI_CREDENTIAL_EXISTS": "キーは登録済みです。差し替えてください。",
    "err_BYO_AI_PROVIDER_UNAVAILABLE": "サービスに接続できないか、レート制限中です。しばらくしてから再試行してください。",
    "err_ENTITLEMENT_REQUIRED": "現在のプランには自前のクラウド AI が含まれていません。",
    "err_AI_ALREADY_ASSIGNED": "このカメラはローカル AI に割り当て済みです。先に解除してください。",
    "err_VERSION_CONFLICT": "他の人が変更しました。再読み込みしてください。",
    "err_REAUTH_REQUIRED": "再認証してからもう一度お試しください。"
  },
  "email_verify": {
    "title": "先にメールアドレスを確認してください",
    "body": "アカウントを保護するため、ログイン方法を追加する前にメールアドレスの確認が必要です。確認メールを {{email}} に送信します。",
    "body_action": "アカウント保護のため、この操作の前にメールアドレスを確認してください。確認メールは {{email}} に送信されます。",
    "send": "確認メールを送信",
    "later": "後で",
    "sent": "確認メールを送信しました。メール内のリンクを開いてから、もう一度お試しください。",
    "err_RATE_LIMITED": "送信回数が多すぎます。しばらくしてからもう一度お試しください。",
    "err_default": "確認メールを送信できませんでした（{{code}}）。しばらくしてからもう一度お試しください。",
    "already": "メールアドレスは確認済みです。もう一度お試しください。",
    "body_no_email": "アカウントを保護するため、ログイン方法を追加する前にメールアドレスの確認が必要です。",
    "body_action_no_email": "アカウント保護のため、この操作の前にメールアドレスを確認してください。"
  }
}
